import { SiteCode } from '../../shared/models/site.model'
import { SiteSettings } from '../../shared/models/site-settings.model'

export function getSiteSettings(useProdSettings: boolean, siteCode: string): SiteSettings | undefined {
  return useProdSettings ? SiteSettingsMapProd.get(siteCode) : SiteSettingsMapStag.get(siteCode)
}

export const SiteSettingsMapProd = new Map<string, SiteSettings>([
  [
    SiteCode.Track,
    {
      api_url: 'https://api.flotrack.org',
      california_privacy_url: 'https://www.flosports.tv/california-privacy-policy/',
      careers_url: 'https://www.flosports.tv/work-with-us',
      contact_url: 'https://support.flosports.tv/',
      core_site_url: 'https://www.flotrack.org',
      facebook_app_id: '119215858156983',
      facebook_page_url: 'https://www.facebook.com/FloTrack',
      faq_url: 'https://support.flosports.tv/',
      favicon_url: 'https://d6fm3yzmawlcs.cloudfront.net/favicons/new-favicon/',
      flosports_url: 'https://www.flosports.tv/',
      google_client_id: '189220610443-287apugqvr12kq5e8hllonspr3ldi6i7.apps.googleusercontent.com',
      instagram_page_url: 'https://www.instagram.com/flotrack',
      meta_articles_page_description:
        'Track articles, videos, news, & events. Watch & stream live track competitions on FloTrack.org. College & professional track & field coverage.',
      meta_articles_page_title: 'Track News | Videos, Highlights & Articles',
      meta_articles_page_type: 'article',
      meta_default_image: 'https://d6fm3yzmawlcs.cloudfront.net/ogImages/Track-1920x1080.jpg',
      meta_default_type: 'website',
      meta_events_entries_page_description:
        'Watch & stream live track competitions on FloTrack.org. Track events, videos, news, & articles. College & professional track & field coverage.',
      meta_events_entries_page_title: 'Track Events | Track Roster & Schedules',
      meta_events_entries_page_type: 'events',
      meta_events_news_page_description:
        'Watch & stream live track competitions on FloTrack.org. Track events, videos, news, & articles. College & professional track & field coverage.',
      meta_events_news_page_title: 'Track Events | Videos, Highlights & Articles',
      meta_events_news_page_type: 'event',
      meta_events_page_description:
        'Watch & stream live track competitions on FloTrack.org. Track events, videos, news, & articles. College & professional track & field coverage.',
      meta_events_page_title: 'Track Events | Videos & Highlights',
      meta_events_page_type: 'event',
      meta_events_photo_page_type: 'event',
      meta_events_photos_page_description:
        'Watch & stream live track competitions on FloTrack.org. Track events, videos, news, & articles. College & professional track & field coverage.',
      meta_events_photos_page_title: 'Track Events | Photos & Highlights',
      meta_events_schedule_page_description:
        'Watch & stream live track competitions on FloTrack.org. Track events, videos, news, & articles. College & professional track & field coverage.',
      meta_events_schedule_page_title: 'Track Events | Schedule & Videos',
      meta_events_schedule_page_type: 'event',
      meta_events_videos_page_description:
        'Watch & stream live track competitions on FloTrack.org. Track events, videos, news, & articles. College & professional track & field coverage.',
      meta_events_videos_page_title: 'Track Events | Videos & Highlights',
      meta_events_videos_page_type: 'event',
      meta_films_page_description:
        'Track films, videos, events, news, & articles. Watch & stream live track competitions on FloTrack.org. College & professional track & field coverage.',
      meta_films_page_title: 'Track Films | Videos, News, & Articles',
      meta_home_page_description:
        'Track events, videos, news, & articles. Watch & stream live track competitions on FloTrack.org. College & professional track & field coverage.',
      meta_home_page_title: 'Track | News, Videos & Articles',
      meta_login_page_description:
        'Track events, videos, news, & articles. Watch & stream live track competitions on FloTrack.org. College & professional track & field coverage.',
      meta_login_page_title: 'Track Events | Meets & Videos',
      meta_not_found_page_description: 'Page not found for whatever reason!',
      meta_not_found_page_title: 'Page not found',
      meta_pay_page_description:
        'Track events, videos, news, & articles. Watch & stream live track competitions on FloTrack.org. College & professional track & field coverage.',
      meta_pay_page_title: 'Track Events | Meets & Videos - Join Today',
      meta_ranking_page_description:
        'Watch & stream live track competitions on FloTrack.org. Track events, videos, news, & articles. College & professional track & field coverage.',
      meta_ranking_page_title: 'Track Events | Track Rankings & Highlights',
      meta_ranking_page_type: 'rankings',
      meta_result_page_description:
        'Watch & stream live track competitions on FloTrack.org. Track events, videos, news, & articles. College & professional track & field coverage.',
      meta_result_page_title: 'Track Results | Track News & Highlights',
      meta_search_page_description:
        'Track events, videos, news, & articles. Watch & stream live track competitions on FloTrack.org. College & professional track & field coverage.',
      meta_search_page_title: 'Track | News, Videos & Articles',
      meta_signup_page_description:
        'Track events, videos, news, & articles. Watch & stream live track competitions on FloTrack.org. College & professional track & field coverage.',
      meta_signup_page_title: 'Track Events | Meets & Videos - Join Today',
      meta_sport_name: 'Track & Field',
      meta_training_page_description:
        'Track training videos, events, news, & articles. Watch & stream live track competitions on FloTrack.org. College & professional track & field coverage.',
      meta_training_page_title: 'Track Training | Videos, News, & Articles',
      meta_twitter_card_type: 'summary_large_image',
      meta_videos_page_description:
        'Track videos, events, news, & articles. Watch & stream live track competitions on FloTrack.org. College & professional track & field coverage.',
      meta_videos_page_page_type: 'video.other',
      meta_videos_page_title: 'Track Videos | Track Events & Highlights',
      ooyala_master_ad_set: 'b68c50e9db24587898e857a3290cb7c',
      ooyala_player_id: 'e0798993365348c58b8e71befc2860e6',
      primary_color: '#FF140F',
      privacy_url: 'https://www.flosports.tv/privacy/',
      segment_api_key: 'skeGAyIHViCZO7cMimyGz0UUFWNKD12e',
      site_id: 1,
      site_name: 'FloTrack',
      sport_name: 'Track & Field',
      tos_url: 'https://www.flosports.tv/terms-of-service/',
      training_videos_name: 'Training',
      twitter_page_url: 'https://twitter.com/FloTrack',
      youtube_page_url: 'https://www.youtube.com/channel/UC1Fp52XJH8UKaa_gHMZrckw',
      gift_url: '/gift'
    }
  ],
  [
    SiteCode.Wrestling,
    {
      api_url: 'https://api.flowrestling.org',
      california_privacy_url: 'https://www.flosports.tv/california-privacy-policy/',
      careers_url: 'https://www.flosports.tv/work-with-us',
      contact_url: 'https://support.flosports.tv/',
      core_site_url: 'https://www.flowrestling.org',
      facebook_app_id: '177182988999383',
      facebook_page_url: 'https://www.facebook.com/FloWrestling/',
      faq_url: 'https://support.flosports.tv/',
      favicon_url: 'https://d6fm3yzmawlcs.cloudfront.net/favicons/new-favicon/',
      flosports_url: 'https://www.flosports.tv/',
      google_client_id: '854713922714-jihf7ra0rltj2e4tnpho1e03kvsuqahs.apps.googleusercontent.com',
      instagram_page_url: 'https://instagram.com/flowrestling/',
      meta_articles_page_description:
        'Wrestling articles, events, videos, & news. Watch & stream live wrestling competitions on FloWrestling.org. High school, NCAA, & elite wrestling coverage.',
      meta_articles_page_title: 'Wrestling News | Videos, Highlights & Articles',
      meta_articles_page_type: 'article',
      meta_default_image: 'https://d6fm3yzmawlcs.cloudfront.net/ogImages/Wrestling-1920x1080.jpg',
      meta_default_type: 'website',
      meta_events_entries_page_description:
        'Watch & stream live wrestling competitions on FloWrestling.org. Wrestling events, videos, news, & articles. High school, NCAA, & elite wrestling coverage.',
      meta_events_entries_page_title: 'Wrestling Matches | Schedule & Entries',
      meta_events_entries_page_type: 'events',
      meta_events_news_page_description:
        'Watch & stream live wrestling competitions on FloWrestling.org. Wrestling events, videos, news, & articles. High school, NCAA, & elite wrestling coverage.',
      meta_events_news_page_title: 'Wrestling Matches | Videos, Highlights & Articles',
      meta_events_news_page_type: 'event',
      meta_events_page_description:
        'Watch & stream live wrestling competitions on FloWrestling.org. Wrestling events, videos, news, & articles. High school, NCAA, & elite wrestling coverage.',
      meta_events_page_title: 'Wrestling Matches | Videos & Highlights',
      meta_events_page_type: 'event',
      meta_events_photo_page_type: 'event',
      meta_events_photos_page_description:
        'Watch & stream live wrestling competitions on FloWrestling.org. Wrestling events, videos, news, & articles. High school, NCAA, & elite wrestling coverage.',
      meta_events_photos_page_title: 'Wrestling Matches | Photos & Highlights',
      meta_events_schedule_page_description:
        'Watch & stream live wrestling competitions on FloWrestling.org. Wrestling events, videos, news, & articles. High school, NCAA, & elite wrestling coverage.',
      meta_events_schedule_page_title: 'Wrestling Matches | Schedule & Videos',
      meta_events_schedule_page_type: 'event',
      meta_events_videos_page_description:
        'Watch & stream live wrestling competitions on FloWrestling.org. Wrestling events, videos, news, & articles. High school, NCAA, & elite wrestling coverage.',
      meta_events_videos_page_title: 'Wrestling Matches | Videos & Highlights',
      meta_events_videos_page_type: 'event',
      meta_films_page_description:
        'Wrestling films, videos, events, news, & articles. Watch & stream live wrestling competitions on FloWrestling.org. High school, NCAA, & elite wrestling coverage.',
      meta_films_page_title: 'Wrestling Films | Videos, News, & Articles',
      meta_home_page_description:
        'Wrestling events, videos, news, & articles. Watch & stream live wrestling competitions on FloWrestling.org. High school, NCAA, & elite wrestling coverage.',
      meta_home_page_title: 'Wrestling | News, Videos & Articles',
      meta_login_page_description:
        'Wrestling events, videos, news, & articles. Watch & stream live wrestling competitions on FloWrestling.org. High school, NCAA, & elite wrestling coverage.',
      meta_login_page_title: 'FloWrestling | Wrestling Matches & Videos',
      meta_not_found_page_description: 'Page not found for whatever reason!',
      meta_not_found_page_title: 'Page not found',
      meta_pay_page_description:
        'Wrestling events, videos, news, & articles. Watch & stream live wrestling competitions on FloWrestling.org. High school, NCAA, & elite wrestling coverage.',
      meta_pay_page_title: 'FloWrestling | Wrestling Matches & Videos - Join Today',
      meta_ranking_page_description:
        'Watch & stream live wrestling competitions on FloWrestling.org. Wrestling events, videos, news, & articles. High school, NCAA, & elite wrestling coverage.',
      meta_ranking_page_title: 'Wrestling Rankings | Wrestling Highlights & Rankings',
      meta_ranking_page_type: 'rankings',
      meta_result_page_description:
        'Watch & stream live wrestling competitions on FloWrestling.org. Wrestling events, videos, news, & articles. High school, NCAA, & elite wrestling coverage.',
      meta_result_page_title: 'Wrestling Results | Wrestling Highlights & Results',
      meta_search_page_description:
        'Wrestling events, videos, news, & articles. Watch & stream live wrestling competitions on FloWrestling.org. High school, NCAA, & elite wrestling coverage.',
      meta_search_page_title: 'Wrestling | News, Videos & Articles',
      meta_signup_page_description:
        'Wrestling events, videos, news, & articles. Watch & stream live wrestling competitions on FloWrestling.org. High school, NCAA, & elite wrestling coverage.',
      meta_signup_page_title: 'FloWrestling | Wrestling Matches & Videos - Join Today',
      meta_sport_name: 'Wrestling',
      meta_training_page_description:
        'Wrestling training videos, events, news, & articles. Watch & stream live wrestling competitions on FloWrestling.org. High school, NCAA, & elite wrestling coverage.',
      meta_training_page_title: 'Wrestling Training | Videos, News, & Articles',
      meta_twitter_card_type: 'summary_large_image',
      meta_videos_page_description:
        'Wrestling videos, events, news, & articles. Watch & stream live wrestling competitions on FloWrestling.org. High school, NCAA, & elite wrestling coverage.',
      meta_videos_page_page_type: 'video.other',
      meta_videos_page_title: 'Wrestling Videos | Wrestling Matches & Highlights',
      ooyala_master_ad_set: 'eb894ae87a004492b82fe1dbfde13bbc',
      ooyala_player_id: 'e0798993365348c58b8e71befc2860e6',
      primary_color: '#FF140F',
      privacy_url: 'https://www.flosports.tv/privacy/',
      segment_api_key: 'PeU3W5lJPrCuFbN0dAbbWjviweF6AKof',
      site_id: 2,
      site_name: 'FloWrestling',
      sport_name: 'Wrestling',
      tos_url: 'https://www.flosports.tv/terms-of-service/',
      training_videos_name: 'Training',
      twitter_page_url: 'https://twitter.com/flowrestling',
      youtube_page_url: 'https://www.youtube.com/channel/UC0OFPvrlWV-FiAVIYjBHkQg',
      gift_url: '/gift'
    }
  ],
  [
    SiteCode.Gymnastics,
    {
      api_url: 'https://api.flogymnastics.com',
      california_privacy_url: 'https://www.flosports.tv/california-privacy-policy/',
      careers_url: 'https://www.flosports.tv/work-with-us',
      contact_url: 'https://support.flosports.tv/',
      core_site_url: 'https://www.flogymnastics.com',
      facebook_app_id: '1681071402129318',
      facebook_page_url: 'https://www.facebook.com/FloGymnastics/',
      faq_url: 'https://support.flosports.tv/',
      favicon_url: 'https://d6fm3yzmawlcs.cloudfront.net/favicons/new-favicon/',
      flosports_url: 'https://www.flosports.tv/',
      google_client_id: '306049847281-jln17ifm929lbg7k2e46jg0ahn5qcqq8.apps.googleusercontent.com',
      instagram_page_url: 'https://www.instagram.com/flogymnastics',
      meta_articles_page_description:
        'Gymnastics articles, competitions, news, & videos. Watch & stream live gymnastics events on FloGymnastics.com. Club & Elite Gymnastics events & news coverage.',
      meta_articles_page_title: 'Gymnastics News | Videos, Highlights & Articles',
      meta_articles_page_type: 'article',
      meta_default_image: 'https://d6fm3yzmawlcs.cloudfront.net/ogImages/Gymnastics-1920x1080.jpg',
      meta_default_type: 'website',
      meta_events_entries_page_description:
        'Watch & stream live gymnastics events on FloGymnastics.com. Gymnastics competitions, videos, news, & articles. Club & Elite Gymnastics events & news coverage.',
      meta_events_entries_page_title: 'Gymnastics Competitions | Schedule & Entries',
      meta_events_entries_page_type: 'events',
      meta_events_news_page_description:
        'Watch & stream live gymnastics events on FloGymnastics.com. Gymnastics competitions, videos, news, & articles. Club & Elite Gymnastics events & news coverage.',
      meta_events_news_page_title: 'Gymnastics Competitions | Videos, Highlights & Articles',
      meta_events_news_page_type: 'event',
      meta_events_page_description:
        'Watch & stream live gymnastics events on FloGymnastics.com. Gymnastics competitions, videos, news, & articles. Club & Elite Gymnastics events & news coverage.',
      meta_events_page_title: 'Gymnastics Competitions | Videos & Highlights',
      meta_events_page_type: 'event',
      meta_events_photo_page_type: 'event',
      meta_events_photos_page_description:
        'Watch & stream live gymnastics events on FloGymnastics.com. Gymnastics competitions, videos, news, & articles. Club & Elite Gymnastics events & news coverage.',
      meta_events_photos_page_title: 'Gymnastics Competitions | Photos & Highlights',
      meta_events_schedule_page_description:
        'Watch & stream live gymnastics events on FloGymnastics.com. Gymnastics competitions, videos, news, & articles. Club & Elite Gymnastics events & news coverage.',
      meta_events_schedule_page_title: 'Gymnastics Competitions | Schedule & Videos',
      meta_events_schedule_page_type: 'event',
      meta_events_videos_page_description:
        'Watch & stream live gymnastics events on FloGymnastics.com. Gymnastics competitions, videos, news, & articles. Club & Elite Gymnastics events & news coverage.',
      meta_events_videos_page_title: 'Gymnastics Competitions | Videos & Highlights',
      meta_events_videos_page_type: 'event',
      meta_films_page_description:
        'Gymnastics films, competitions, videos, news, & articles. Watch & stream live gymnastics events on FloGymnastics.com. Club & Elite Gymnastics events & news coverage.',
      meta_films_page_title: 'Gymnastics Films | Videos, News, & Articles',
      meta_home_page_description:
        'Gymnastics competitions, videos, news, & articles. Watch & stream live gymnastics events on FloGymnastics.com. Club & Elite Gymnastics events & news coverage.',
      meta_home_page_title: 'Gymnastics | Videos, News & Articles',
      meta_login_page_description:
        'Gymnastics competitions, videos, news, & articles. Watch & stream live gymnastics events on FloGymnastics.com. Club & Elite Gymnastics events & news coverage.',
      meta_login_page_title: 'Gymnastics News | Gymnastics Competitions & Videos',
      meta_not_found_page_description: 'Page not found for whatever reason!',
      meta_not_found_page_title: 'Page not found',
      meta_pay_page_description:
        'Gymnastics competitions, videos, news, & articles. Watch & stream live gymnastics events on FloGymnastics.com. Club & Elite Gymnastics events & news coverage.',
      meta_pay_page_title: 'Gymnastics News | Gymnastics Competitions & Videos - Join Today',
      meta_ranking_page_description:
        'Watch & stream live gymnastics events on FloGymnastics.com. Gymnastics competitions, videos, news, & articles. Club & Elite Gymnastics events & news coverage.',
      meta_ranking_page_title: 'Gymnastics News | Gymnastics Highlights & Rankings',
      meta_ranking_page_type: 'rankings',
      meta_result_page_description:
        'Watch & stream live gymnastics events on FloGymnastics.com. Gymnastics competitions, videos, news, & articles. Club & Elite Gymnastics events & news coverage.',
      meta_result_page_title: 'Gymnastics News | Gymnastics Highlights & Results',
      meta_search_page_description:
        'Gymnastics competitions, videos, news, & articles. Watch & stream live gymnastics events on FloGymnastics.com. Club & Elite Gymnastics events & news coverage.',
      meta_search_page_title: 'Gymnastics | Videos, News & Articles',
      meta_signup_page_description:
        'Gymnastics competitions, videos, news, & articles. Watch & stream live gymnastics events on FloGymnastics.com. Club & Elite Gymnastics events & news coverage.',
      meta_signup_page_title: 'Gymnastics News | Gymnastics Competitions & Videos - Join Today',
      meta_sport_name: 'Gymnastics',
      meta_training_page_description:
        'Gymnastics training, competitions, videos, news, & articles. Watch & stream live gymnastics events on FloGymnastics.com. Club & Elite Gymnastics events & news coverage.',
      meta_training_page_title: 'Gymnastics Training | Videos, News, & Articles',
      meta_twitter_card_type: 'summary_large_image',
      meta_videos_page_description:
        'Gymnastics videos, competitions, news, & articles. Watch & stream live gymnastics events on FloGymnastics.com. Club & Elite Gymnastics events & news coverage.',
      meta_videos_page_page_type: 'video.other',
      meta_videos_page_title: 'Gymnastics Videos | Gymnastics Routines & Highlights',
      ooyala_master_ad_set: '6dd87271fd3d4b29a146f64117a090af',
      ooyala_player_id: 'e0798993365348c58b8e71befc2860e6',
      primary_color: '#FF140F',
      privacy_url: 'https://www.flosports.tv/privacy/',
      segment_api_key: 'yhn1vl4NxmF5P0LGnmOG7Jef2aTgC4I7',
      site_id: 4,
      site_name: 'FloGymnastics',
      sport_name: 'Gymnastics',
      tos_url: 'https://www.flosports.tv/terms-of-service/',
      training_videos_name: 'Training',
      twitter_page_url: 'https://twitter.com/FloGymnastics',
      youtube_page_url: 'https://www.youtube.com/channel/UCHtBh35nBTgC5uW2ZgsRs1A',
      gift_url: '/gift'
    }
  ],
  [
    SiteCode.Hoops,
    {
      api_url: 'https://api.flohoops.com',
      california_privacy_url: 'https://www.flosports.tv/california-privacy-policy/',
      careers_url: 'https://www.flosports.tv/work-with-us',
      contact_url: 'https://support.flosports.tv/',
      core_site_url: 'https://www.flohoops.com',
      facebook_app_id: '520901398075294',
      facebook_page_url: 'https://www.facebook.com/FloHoops',
      faq_url: 'https://support.flosports.tv/',
      favicon_url: 'https://d6fm3yzmawlcs.cloudfront.net/favicons/new-favicon/',
      flosports_url: 'https://www.flosports.tv/',
      google_client_id: '731157393139-6rtj6l5c02cqnnf3gnoe69vl9ri048d2.apps.googleusercontent.com',
      instagram_page_url: 'https://www.instagram.com/flohoops/',
      meta_articles_page_description:
        'Basketball news, videos, games, & articles. Watch & stream live basketball games on FloHoops.com. High School & NCAA basketball games & news coverage.',
      meta_articles_page_title: 'Basketball News | Basketball Articles',
      meta_articles_page_type: 'article',
      meta_default_image: 'https://d6fm3yzmawlcs.cloudfront.net/ogImages/Hoops-1920x1080.jpg',
      meta_default_type: 'website',
      meta_events_entries_page_description:
        'Watch & stream live basketball games on FloHoops.com. Basketball games, videos, news, & articles. High School & NCAA basketball games & news coverage.',
      meta_events_entries_page_title: 'Basketball Games | Basketball Roster',
      meta_events_entries_page_type: 'events',
      meta_events_news_page_description:
        'Watch & stream live basketball games on FloHoops.com. Basketball games, videos, news, & articles. High School & NCAA basketball games & news coverage.',
      meta_events_news_page_title: 'Basketball News | Basketball Articles',
      meta_events_news_page_type: 'event',
      meta_events_page_description:
        'Watch & stream live basketball games on FloHoops.com. Basketball games, videos, news, & articles. High School & NCAA basketball games & news coverage.',
      meta_events_page_title: 'Basketball Games | Basketball Live Games',
      meta_events_page_type: 'event',
      meta_events_photo_page_type: 'event',
      meta_events_photos_page_description:
        'Watch & stream live basketball games on FloHoops.com. Basketball games, videos, news, & articles. High School & NCAA basketball games & news coverage.',
      meta_events_photos_page_title: 'Basketball Games | Basketball Game Photos',
      meta_events_schedule_page_description:
        'Watch & stream live basketball games on FloHoops.com. Basketball games, videos, news, & articles. High School & NCAA basketball games & news coverage.',
      meta_events_schedule_page_title: 'Basketball Schedule | Basketball Game Times',
      meta_events_schedule_page_type: 'event',
      meta_events_videos_page_description:
        'Watch & stream live basketball games on FloHoops.com. Basketball games, videos, news, & articles. High School & NCAA basketball games & news coverage.',
      meta_events_videos_page_title: 'Basketball Videos | Basketball Highlights & Games',
      meta_events_videos_page_type: 'event',
      meta_films_page_description: 'Watch Films and Documentaries',
      meta_films_page_title: 'Films and Documentaries',
      meta_home_page_description:
        'Basketball games, videos, news, & articles. Watch & stream live basketball games on FloHoops.com. High School & NCAA basketball games & news coverage.',
      meta_home_page_title: 'Basketball | Games, News, & Articles',
      meta_login_page_description:
        'Basketball games, videos, news, & articles. Watch & stream live basketball games on FloHoops.com. High School & NCAA basketball games & news coverage.',
      meta_login_page_title: 'Live Basketball | Stream Games, News, & Articles - Join Today',
      meta_not_found_page_description: 'Page not found for whatever reason!',
      meta_not_found_page_title: 'Page not found',
      meta_pay_page_description:
        'Basketball games, videos, news, & articles. Watch & stream live basketball games on FloHoops.com. High School & NCAA basketball games & news coverage.',
      meta_pay_page_title: 'Live Basketball | Stream Games, News, & Articles - Join Today',
      meta_ranking_page_description:
        'Watch & stream live basketball games on FloHoops.com. Basketball games, videos, news, & articles. High School & NCAA basketball games & news coverage.',
      meta_ranking_page_title: 'Basketball | Rankings & Live Basketball',
      meta_ranking_page_type: 'rankings',
      meta_result_page_description:
        'Watch & stream live basketball games on FloHoops.com. Basketball games, videos, news, & articles. High School & NCAA basketball games & news coverage.',
      meta_result_page_title: 'Basketball Scores | Basketball Results & Games',
      meta_search_page_description:
        'Basketball games, videos, news, & articles. Watch & stream live basketball games on FloHoops.com. High School & NCAA basketball games & news coverage.',
      meta_search_page_title: 'Basketball | Games, News, & Articles',
      meta_signup_page_description:
        'Basketball games, videos, news, & articles. Watch & stream live basketball games on FloHoops.com. High School & NCAA basketball games & news coverage.',
      meta_signup_page_title: 'Live Basketball | Stream Games, News, & Articles - Join Today',
      meta_sport_name: 'basketball',
      meta_training_page_description: 'Watch training and technique videos',
      meta_training_page_title: 'Training and Technique Videos',
      meta_twitter_card_type: 'summary_large_image',
      meta_videos_page_description:
        'Basketball videos, games, news, & articles. Watch & stream live basketball games on FloHoops.com. High School & NCAA basketball games & news coverage.',
      meta_videos_page_page_type: 'video.other',
      meta_videos_page_title: 'Basketball Videos | Games & Highlights',
      ooyala_master_ad_set: '2b0e8f9115ab481fbf73eadb83bb15a4',
      ooyala_player_id: 'e0798993365348c58b8e71befc2860e6',
      primary_color: '#FF140F',
      privacy_url: 'https://www.flosports.tv/privacy/',
      segment_api_key: 'biMZTuKZ3XxQ8Tac9K2PmlQCs5fLVdZQ',
      site_id: 7,
      site_name: 'FloHoops',
      sport_name: 'Basketball',
      tos_url: 'https://www.flosports.tv/terms-of-service/',
      training_videos_name: 'Training',
      twitter_page_url: 'https://twitter.com/FloHoops',
      youtube_page_url: 'https://www.youtube.com/channel/UCjfcsyEFS4g-rJHxzOba9ng',
      gift_url: '/gift'
    }
  ],
  [
    SiteCode.Grappling,
    {
      api_url: 'https://api.flograppling.com',
      california_privacy_url: 'https://www.flosports.tv/california-privacy-policy/',
      careers_url: 'https://www.flosports.tv/work-with-us',
      contact_url: 'https://support.flosports.tv/',
      core_site_url: 'https://www.flograppling.com',
      facebook_app_id: '1474343309552465',
      facebook_page_url: 'https://www.facebook.com/FloGrappling',
      faq_url: 'https://support.flosports.tv/',
      favicon_url: 'https://d6fm3yzmawlcs.cloudfront.net/favicons/new-favicon/',
      flosports_url: 'https://www.flosports.tv/',
      google_client_id: '423841874240-qd5p69t0u7l3inj0flnrg5p8plmbdmv0.apps.googleusercontent.com',
      instagram_page_url: 'https://instagram.com/flograppling/',
      meta_articles_page_description:
        'BJJ articles, videos, news, & events. Watch & stream live BJJ competitions on FloGrappling.com. Professional Brazilian Jiu Jitsu event & news coverage.',
      meta_articles_page_title: 'BJJ News | Articles, Videos, & Highlights',
      meta_articles_page_type: 'article',
      meta_default_image: 'https://d6fm3yzmawlcs.cloudfront.net/ogImages/Grappling-1920x1080.jpg',
      meta_default_type: 'website',
      meta_events_entries_page_description:
        'Watch & stream live BJJ competitions on FloGrappling.com. BJJ events, videos, news, & articles. Professional Brazilian Jiu Jitsu event & news coverage.',
      meta_events_entries_page_title: 'BJJ Competitions | Schedule & Entries',
      meta_events_entries_page_type: 'events',
      meta_events_news_page_description:
        'Watch & stream live BJJ competitions on FloGrappling.com. BJJ events, videos, news, & articles. Professional Brazilian Jiu Jitsu event & news coverage.',
      meta_events_news_page_title: 'BJJ Competitions | Videos, Highlights & Articles',
      meta_events_news_page_type: 'event',
      meta_events_page_description:
        'Watch & stream live BJJ competitions on FloGrappling.com. BJJ events, videos, news, & articles. Professional Brazilian Jiu Jitsu event & news coverage.',
      meta_events_page_title: 'BJJ Competitions | Videos & Highlights',
      meta_events_page_type: 'event',
      meta_events_photo_page_type: 'event',
      meta_events_photos_page_description:
        'Watch & stream live BJJ competitions on FloGrappling.com. BJJ events, videos, news, & articles. Professional Brazilian Jiu Jitsu event & news coverage.',
      meta_events_photos_page_title: 'BJJ Competitions | Photos & Highlights',
      meta_events_schedule_page_description:
        'Watch & stream live BJJ competitions on FloGrappling.com. BJJ events, videos, news, & articles. Professional Brazilian Jiu Jitsu event & news coverage.',
      meta_events_schedule_page_title: 'BJJ Competitions | Schedule & Videos',
      meta_events_schedule_page_type: 'event',
      meta_events_videos_page_description:
        'Watch & stream live BJJ competitions on FloGrappling.com. BJJ events, videos, news, & articles. Professional Brazilian Jiu Jitsu event & news coverage.',
      meta_events_videos_page_title: 'BJJ Competitions | Videos & Highlights',
      meta_events_videos_page_type: 'event',
      meta_films_page_description:
        'BJJ films, videos, news, & events. Watch & stream live BJJ competitions on FloGrappling.com. Professional Brazilian Jiu Jitsu event & news coverage.',
      meta_films_page_title: 'BJJ Films | Videos, News, & Articles',
      meta_home_page_description:
        'BJJ events, videos, news, & articles. Watch & stream live BJJ competitions on FloGrappling.com. Professional Brazilian Jiu Jitsu event & news coverage.',
      meta_home_page_title: 'BJJ | News, Videos & Articles',
      meta_login_page_description:
        'BJJ events, videos, news, & articles. Watch & stream live BJJ competitions on FloGrappling.com. Professional Brazilian Jiu Jitsu event & news coverage.',
      meta_login_page_title: 'BJJ News | BJJ Competition & Videos',
      meta_not_found_page_description: 'Page not found for whatever reason!',
      meta_not_found_page_title: 'Page not found',
      meta_pay_page_description:
        'BJJ events, videos, news, & articles. Watch & stream live BJJ competitions on FloGrappling.com. Professional Brazilian Jiu Jitsu event & news coverage.',
      meta_pay_page_title: 'BJJ News | BJJ Competition & Videos - Join Today',
      meta_ranking_page_description:
        'Watch & stream live BJJ competitions on FloGrappling.com. BJJ events, videos, news, & articles. Professional Brazilian Jiu Jitsu event & news coverage.',
      meta_ranking_page_title: 'BJJ News | BJJ Highlights & Rankings',
      meta_ranking_page_type: 'rankings',
      meta_result_page_description:
        'Watch & stream live BJJ competitions on FloGrappling.com. BJJ events, videos, news, & articles. Professional Brazilian Jiu Jitsu event & news coverage.',
      meta_result_page_title: 'BJJ News | BJJ Highlights & Results',
      meta_search_page_description:
        'BJJ events, videos, news, & articles. Watch & stream live BJJ competitions on FloGrappling.com. Professional Brazilian Jiu Jitsu event & news coverage.',
      meta_search_page_title: 'BJJ | News, Videos & Articles',
      meta_signup_page_description:
        'BJJ events, videos, news, & articles. Watch & stream live BJJ competitions on FloGrappling.com. Professional Brazilian Jiu Jitsu event & news coverage.',
      meta_signup_page_title: 'BJJ News | BJJ Competition & Videos - Join Today',
      meta_sport_name: 'BJJ',
      meta_training_page_description:
        'BJJ training, articles, videos, news, & events. Watch & stream live BJJ competitions on FloGrappling.com. Professional Brazilian Jiu Jitsu event & news coverage.',
      meta_training_page_title: 'BJJ Training | Videos, News, & Articles',
      meta_twitter_card_type: 'summary_large_image',
      meta_videos_page_description:
        'BJJ videos, articles, news, & events. Watch & stream live BJJ competitions on FloGrappling.com. Professional Brazilian Jiu Jitsu event & news coverage.',
      meta_videos_page_page_type: 'video.other',
      meta_videos_page_title: 'BJJ Videos | News & Articles',
      ooyala_master_ad_set: 'f74229fd8ad04c158c2041949f3a1c86',
      ooyala_player_id: 'e0798993365348c58b8e71befc2860e6',
      primary_color: '#FF140F',
      privacy_url: 'https://www.flosports.tv/privacy/',
      segment_api_key: 'rS5XGs3J5bG3tqRcsfcS4QmsNEw5NZe2',
      site_id: 8,
      site_name: 'FloGrappling',
      sport_name: 'Jiu-Jitsu',
      tos_url: 'https://www.flosports.tv/terms-of-service/',
      training_videos_name: 'Training',
      twitter_page_url: 'https://twitter.com/flograppling',
      youtube_page_url: 'https://www.youtube.com/channel/UCeOvhU6RbmEj8GKFiIMWxKQ',
      gift_url: '/gift'
    }
  ],
  [
    SiteCode.Cheer,
    {
      api_url: 'https://api.flocheer.com',
      california_privacy_url: 'https://www.flosports.tv/california-privacy-policy/',
      careers_url: 'https://www.flosports.tv/work-with-us',
      contact_url: 'https://support.flosports.tv/',
      core_site_url: 'https://www.flocheer.com',
      facebook_app_id: '176623749339168',
      facebook_page_url: 'https://www.facebook.com/FloCheer/',
      faq_url: 'https://support.flosports.tv/',
      favicon_url: 'https://d6fm3yzmawlcs.cloudfront.net/favicons/new-favicon/',
      flosports_url: 'https://www.flosports.tv/',
      google_client_id: '838185638796-0hh7dvgjcaaan27iqgek466jfdb5v2op.apps.googleusercontent.com',
      instagram_page_url: 'https://www.instagram.com/flocheer',
      meta_articles_page_description:
        'Cheerleading articles, events, news, & videos. Watch & stream live cheerleading competitions. Professional Cheerleading event & news coverage.',
      meta_articles_page_title: 'Cheerleading | Videos, News & Articles',
      meta_articles_page_type: 'article',
      meta_default_image: 'https://d6fm3yzmawlcs.cloudfront.net/ogImages/Cheer-1920x1080.jpg',
      meta_default_type: 'website',
      meta_events_entries_page_description:
        'Watch & stream live cheerleading competitions. Cheerleading events, videos, news, & articles. Professional Cheerleading event & news coverage.',
      meta_events_entries_page_title: 'Cheerleading Events | Entries & Videos',
      meta_events_entries_page_type: 'events',
      meta_events_news_page_description:
        'Watch & stream live cheerleading competitions. Cheerleading events, videos, news, & articles. Professional Cheerleading event & news coverage.',
      meta_events_news_page_title: 'Cheerleading Events | Videos & Competitions',
      meta_events_news_page_type: 'event',
      meta_events_page_description:
        'Watch & stream live cheerleading competitions. Cheerleading events, videos, news, & articles. Professional Cheerleading event & news coverage.',
      meta_events_page_title: 'Cheerleading Events | Videos & Competitions',
      meta_events_page_type: 'event',
      meta_events_photo_page_type: 'event',
      meta_events_photos_page_description:
        'Watch & stream live cheerleading competitions. Cheerleading events, videos, news, & articles. Professional Cheerleading event & news coverage.',
      meta_events_photos_page_title: 'Cheerleading Events | Cheerleading Event Photos',
      meta_events_schedule_page_description:
        'Watch & stream live cheerleading competitions. Cheerleading events, videos, news, & articles. Professional Cheerleading event & news coverage.',
      meta_events_schedule_page_title: 'Cheerleading Events | Schedule & Videos',
      meta_events_schedule_page_type: 'event',
      meta_events_videos_page_description:
        'Watch & stream live cheerleading competitions. Cheerleading events, videos, news, & articles. Professional Cheerleading event & news coverage.',
      meta_events_videos_page_title: 'Cheerleading Events | Videos & Competitions',
      meta_events_videos_page_type: 'event',
      meta_films_page_description:
        'Cheerleading films, events, videos, news, & articles. Watch & stream live cheerleading competitions. Professional Cheerleading event & news coverage.',
      meta_films_page_title: 'Cheerleading Films | Videos, News, & Articles',
      meta_home_page_description:
        'Cheerleading events, videos, news, & articles. Watch & stream live cheerleading competitions. Professional Cheerleading event & news coverage.',
      meta_home_page_title: 'Cheerleading | Videos, News & Articles',
      meta_login_page_description:
        'Cheerleading events, videos, news, & articles. Watch & stream live cheerleading competitions. Professional Cheerleading event & news coverage.',
      meta_login_page_title: 'Cheerleading Events | Videos, Competitions, & News',
      meta_not_found_page_description: 'Page not found for whatever reason!',
      meta_not_found_page_title: 'Page not found',
      meta_pay_page_description:
        'Cheerleading events, videos, news, & articles. Watch & stream live cheerleading competitions. Professional Cheerleading event & news coverage.',
      meta_pay_page_title: 'Cheerleading Events | Videos, Competitions, & News - Join Today',
      meta_ranking_page_description:
        'Cheerleading events, videos, news, & articles. Watch & stream live cheerleading competitions. Professional Cheerleading event & news coverage.',
      meta_ranking_page_title: 'Cheerleading Events | Rankings & Videos',
      meta_ranking_page_type: 'rankings',
      meta_result_page_description:
        'Cheerleading events, videos, news, & articles. Watch & stream live cheerleading competitions. Professional Cheerleading event & news coverage.',
      meta_result_page_title: 'Cheerleading Events | Results & Videos',
      meta_search_page_description:
        'Cheerleading events, videos, news, & articles. Watch & stream live cheerleading competitions. Professional Cheerleading event & news coverage.',
      meta_search_page_title: 'Cheerleading | Videos, News & Articles',
      meta_signup_page_description:
        'Cheerleading events, videos, news, & articles. Watch & stream live cheerleading competitions. Professional Cheerleading event & news coverage.',
      meta_signup_page_title: 'Cheerleading Events | Videos, Competitions, & News - Join Today',
      meta_sport_name: 'Competitive Cheerleading',
      meta_training_page_description:
        'Cheerleading training, events, videos, news, & articles. Watch & stream live cheerleading competitions. Professional Cheerleading event & news coverage.',
      meta_training_page_title: 'Cheerleading Training | Videos, News, & Articles',
      meta_twitter_card_type: 'summary_large_image',
      meta_videos_page_description:
        'Cheerleading videos, events, news, & articles. Watch & stream live cheerleading competitions. Professional Cheerleading event & news coverage.',
      meta_videos_page_page_type: 'video.other',
      meta_videos_page_title: 'Cheerleading Videos | Events & Highlights',
      ooyala_master_ad_set: '3e7837b972684b8abdca2072ec5af11d',
      ooyala_player_id: 'e0798993365348c58b8e71befc2860e6',
      primary_color: '#FF140F',
      privacy_url: 'https://www.flosports.tv/privacy/',
      segment_api_key: 'O2z5yf0CAa1K8WgWU3gCpDMdKKdeX5Pv',
      site_id: 10,
      site_name: 'FloCheer',
      sport_name: 'Cheer & Dance',
      tos_url: 'https://www.flosports.tv/terms-of-service/',
      training_videos_name: 'Training',
      twitter_page_url: 'https://twitter.com/FloCheer',
      youtube_page_url: 'https://www.youtube.com/channel/UCllSlj86iOudwHb-7Svg9wg',
      gift_url: '/gift'
    }
  ],
  [
    SiteCode.Elite,
    {
      api_url: 'https://api.floelite.com',
      california_privacy_url: 'https://www.flosports.tv/california-privacy-policy/',
      careers_url: 'https://www.flosports.tv/work-with-us',
      contact_url: 'https://support.flosports.tv/',
      core_site_url: 'https://www.floelite.com',
      facebook_app_id: '451809041670499',
      facebook_page_url: 'https://www.facebook.com/FloElite',
      faq_url: 'https://support.flosports.tv/',
      favicon_url: 'https://d6fm3yzmawlcs.cloudfront.net/favicons/new-favicon/',
      flosports_url: 'https://www.flosports.tv/',
      google_client_id: '149982521418-5fnfv7rs1dkbea4e3h9b2av30l3d8n94.apps.googleusercontent.com',
      instagram_page_url: 'https://instagram.com/floelite/',
      meta_articles_page_description:
        'Fitness articles, videos, news, & competitions. Watch & stream live fitness events. Elite Fitness, Olympic Weightlifting, Powerlifting & Strongman coverage.',
      meta_articles_page_title: 'Fitness | Videos, News & Articles',
      meta_articles_page_type: 'article',
      meta_default_image: 'https://d6fm3yzmawlcs.cloudfront.net/ogImages/Elite-1920x1080.jpg',
      meta_default_type: 'website',
      meta_events_entries_page_description:
        'Watch & stream live fitness events. Fitness competitions, videos, news, & articles.  Elite Fitness, Olympic Weightlifting, Powerlifting & Strongman coverage.',
      meta_events_entries_page_title: 'Fitness Competitions | Entries & Videos',
      meta_events_entries_page_type: 'events',
      meta_events_news_page_description:
        'Fitness articles, videos, news, & competitions. Watch & stream live fitness events. Elite Fitness, Olympic Weightlifting, Powerlifting & Strongman coverage.',
      meta_events_news_page_title: 'Fitness Competitions | Videos & Events',
      meta_events_news_page_type: 'event',
      meta_events_page_description:
        'Watch & stream live fitness events. Fitness competitions, videos, news, & articles.  Elite Fitness, Olympic Weightlifting, Powerlifting & Strongman coverage.',
      meta_events_page_title: 'Fitness Competitions | Videos & Events',
      meta_events_page_type: 'event',
      meta_events_photo_page_type: 'event',
      meta_events_photos_page_description:
        'Watch & stream live fitness events. Fitness competitions, videos, news, & articles.  Elite Fitness, Olympic Weightlifting, Powerlifting & Strongman coverage.',
      meta_events_photos_page_title: 'Fitness Competitions | Fitness Event Photos',
      meta_events_schedule_page_description:
        'Watch & stream live fitness events. Fitness competitions, videos, news, & articles.  Elite Fitness, Olympic Weightlifting, Powerlifting & Strongman coverage.',
      meta_events_schedule_page_title: 'Fitness Competitions | Schedule & Videos',
      meta_events_schedule_page_type: 'event',
      meta_events_videos_page_description:
        'Fitness videos, competitions, news, & articles. Watch & stream live fitness events. Elite Fitness, Olympic Weightlifting, Powerlifting & Strongman coverage.',
      meta_events_videos_page_title: 'Fitness Competitions | Videos & Events',
      meta_events_videos_page_type: 'event',
      meta_films_page_description:
        'Fitness films, competitions, news, & articles. Watch & stream live fitness events. Elite Fitness, Olympic Weightlifting, Powerlifting & Strongman coverage.',
      meta_films_page_title: 'Fitness Films | Videos, News, & Articles',
      meta_home_page_description:
        'Fitness competitions, videos, news, & articles. Watch & stream live fitness events. Elite Fitness, Olympic Weightlifting, Powerlifting & Strongman coverage.',
      meta_home_page_title: 'Fitness | Videos, News & Articles',
      meta_login_page_description:
        'Fitness competitions, videos, news, & articles. Watch & stream live fitness events. Elite Fitness, Olympic Weightlifting, Powerlifting & Strongman coverage.',
      meta_login_page_title: 'Fitness Competitions | Videos, Events, & News',
      meta_not_found_page_description: 'Page not found for whatever reason!',
      meta_not_found_page_title: 'Page not found',
      meta_pay_page_description:
        'Fitness competitions, videos, news, & articles. Watch & stream live fitness events. Elite Fitness, Olympic Weightlifting, Powerlifting & Strongman coverage.',
      meta_pay_page_title: 'Fitness Competitions | Videos, Events, & News - Join Today',
      meta_ranking_page_description:
        'Watch & stream live fitness events. Fitness competitions, videos, news, & articles.  Elite Fitness, Olympic Weightlifting, Powerlifting & Strongman coverage.',
      meta_ranking_page_title: 'Fitness Competitions | Rankings & Videos',
      meta_ranking_page_type: 'rankings',
      meta_result_page_description:
        'Watch & stream live fitness events. Fitness competitions, videos, news, & articles.  Elite Fitness, Olympic Weightlifting, Powerlifting & Strongman coverage.',
      meta_result_page_title: 'Fitness Competitions | Results & Videos',
      meta_search_page_description:
        'Fitness competitions, videos, news, & articles. Watch & stream live fitness events. Elite Fitness, Olympic Weightlifting, Powerlifting & Strongman coverage.',
      meta_search_page_title: 'Fitness | Videos, News & Articles',
      meta_signup_page_description:
        'Fitness competitions, videos, news, & articles. Watch & stream live fitness events. Elite Fitness, Olympic Weightlifting, Powerlifting & Strongman coverage.',
      meta_signup_page_title: 'Fitness Competitions | Videos, Events, & News - Join FloElite.com',
      meta_sport_name: 'Crossfit, Strongman, & Weightlifting',
      meta_training_page_description:
        'Fitness training videos, competitions, news, & articles. Watch & stream live fitness events. Elite Fitness, Olympic Weightlifting, Powerlifting & Strongman coverage.',
      meta_training_page_title: 'Fitness Training | Videos, News, & Articles',
      meta_twitter_card_type: 'summary_large_image',
      meta_videos_page_description:
        'Fitness videos, competitions, news, & articles. Watch & stream live fitness events. Elite Fitness, Olympic Weightlifting, Powerlifting & Strongman coverage.',
      meta_videos_page_page_type: 'video.other',
      meta_videos_page_title: 'Fitness Videos | Events & Highlights',
      ooyala_master_ad_set: '240d081332c84a57af7cdffe2839da4d',
      ooyala_player_id: 'e0798993365348c58b8e71befc2860e6',
      primary_color: '#FF140F',
      privacy_url: 'https://www.flosports.tv/privacy/',
      segment_api_key: 'V3QLSXVuDMbgL7HrBIfDFN05KleXWr3O',
      site_id: 12,
      site_name: 'FloElite',
      sport_name: 'Elite Fitness',
      tos_url: 'https://www.flosports.tv/terms-of-service/',
      training_videos_name: 'Training',
      twitter_page_url: 'https://twitter.com/FloElite',
      youtube_page_url: 'https://www.youtube.com/channel/UCJeMIYjZLELFf1xMFUZEmzQ',
      gift_url: '/gift'
    }
  ],
  [
    SiteCode.Universal,
    {
      api_url: 'https://api.flosports.tv',
      california_privacy_url: 'https://www.flosports.tv/california-privacy-policy/',
      careers_url: 'https://www.flosports.tv/work-with-us',
      contact_url: 'https://www.flosports.tv/contact/',
      core_site_url: 'https://api.flosports.tv',
      facebook_app_id: '1980979028801713',
      facebook_page_url: 'https://www.facebook.com/flosports/',
      faq_url: 'https://www.flosports.tv/faq/',
      favicon_url: 'https://dvsfd86tdlcfa.cloudfront.net/assets/2016111719441264/bundles/app/images/floslam/favicon/',
      flosports_url: 'https://www.flosports.tv/',
      google_client_id: null,
      instagram_page_url: 'https://www.instagram.com/explore/locations/921189021340396/flosports/',
      meta_articles_page_description:
        'Stay up-to-date on all the news in the FloSports world with the latest articles, delivered daily.',
      meta_articles_page_title: 'The most up-to-date FloSports news & articles!',
      meta_articles_page_type: 'article',
      meta_default_image: 'http://static-assets.flosports.local/photo/58a1f091d8ff6.png?width=300',
      meta_default_type: 'website',
      meta_events_entries_page_description: 'Watch & stream FloSports live events. Events are our thing. Enjoy',
      meta_events_entries_page_title: 'Watch & stream FloSports events.',
      meta_events_entries_page_type: 'events',
      meta_events_news_page_description: 'Watch & stream FloSports live events. Events are our thing. Enjoy.',
      meta_events_news_page_title: 'Watch & stream FloSports events.',
      meta_events_news_page_type: 'event',
      meta_events_page_description: 'Watch & stream FloSports live events. Events are our thing. Enjoy.',
      meta_events_page_title: 'Watch & stream FloSports events.',
      meta_events_page_type: 'event',
      meta_events_photo_page_type: 'event',
      meta_events_photos_page_description: 'Watch & stream FloSports live events. Events are our thing. Enjoy',
      meta_events_photos_page_title: 'Watch & stream FloSports events',
      meta_events_schedule_page_description: 'Watch & stream FloSports live events. Events are our thing. Enjoy.',
      meta_events_schedule_page_title: 'Watch & stream FloSports events.',
      meta_events_schedule_page_type: 'event',
      meta_events_videos_page_description: 'Watch & stream FloSports live events. Events are our thing. Enjoy.',
      meta_events_videos_page_title: 'Watch & stream FloSports events.',
      meta_events_videos_page_type: 'event',
      meta_films_page_description: 'Watch Films and Documentaries',
      meta_films_page_title: 'Films and Documentaries',
      meta_home_page_description: 'Get the latest  FloSports news, videos, & events. All the info, all the time.',
      meta_home_page_title: 'The latest FloSports news & videos!',
      meta_login_page_description:
        'Log in to get the latest FloSports news, videos, & events. All the info, all the time.',
      meta_login_page_title: 'Log in now to check out exclusive FloSports content!',
      meta_not_found_page_description: 'Page not found for whatever reason!',
      meta_not_found_page_title: 'Page not found',
      meta_pay_page_description: 'Get the latest FloSports news, videos, & events. All the info, all the time.',
      meta_pay_page_title: 'Subscribe & get access to the latest FloSports news, films, and events!',
      meta_ranking_page_description: "Who's the best of the best? Get current FloSports rankings here.",
      meta_ranking_page_title: 'Get the most current FloSports rankings!',
      meta_ranking_page_type: 'rankings',
      meta_result_page_description: 'Check out the latest FloSports scores, direct  the results headquarters.',
      meta_result_page_title: 'Check out the FloSports results!',
      meta_search_page_description: 'Search the latest FloSports news, videos, & events. All the info, all the time.',
      meta_search_page_title: 'Search the latest FloSports news & videos!',
      meta_signup_page_description: 'Get the latest FloSports news, videos, & events. All the info, all the time.',
      meta_signup_page_title: 'Subscribe & get access to the latest FloSports news, films, and events!',
      meta_sport_name: null,
      meta_training_page_description: 'Watch training and technique videos',
      meta_training_page_title: 'Training and Technique Videos',
      meta_twitter_card_type: 'summary_large_image',
      meta_videos_page_description: 'Watch the latest FloSports videos. All videos, all the time.',
      meta_videos_page_page_type: 'video.other',
      meta_videos_page_title: 'Watch the latest FloSports videos!',
      ooyala_master_ad_set: null,
      ooyala_player_id: 'e0798993365348c58b8e71befc2860e6',
      primary_color: '#FF140F',
      privacy_url: 'https://www.flosports.tv/privacy/',
      segment_api_key: 'Dl7QfNJvHFpnM13p0FxYZ9ijKEJ14zcw',
      site_id: 13,
      site_name: 'FloSports',
      sport_name: null,
      tos_url: 'https://www.flosports.tv/terms-of-service/',
      training_videos_name: 'Training',
      twitter_page_url: 'https://twitter.com/flosports',
      youtube_page_url: 'https://www.youtube.com/user/Flocasts',
      gift_url: '/gift'
    }
  ],
  [
    SiteCode.Softball,
    {
      api_url: 'https://api.flosoftball.com',
      california_privacy_url: 'https://www.flosports.tv/california-privacy-policy/',
      careers_url: 'https://www.flosports.tv/work-with-us',
      contact_url: 'https://support.flosports.tv/',
      core_site_url: 'https://www.flosoftball.com',
      facebook_app_id: '887128328032901',
      facebook_page_url: 'https://www.facebook.com/FloSoftball',
      faq_url: 'https://support.flosports.tv/',
      favicon_url: 'https://d6fm3yzmawlcs.cloudfront.net/favicons/new-favicon/',
      flosports_url: 'https://www.flosports.tv/',
      google_client_id: '678920541895-mb4oms8btvdj0jf9qqklgeoog48q027a.apps.googleusercontent.com',
      instagram_page_url: 'https://www.instagram.com/flosoftball/',
      meta_articles_page_description:
        'Softball articles games, videos, & news. Watch & stream live softball matches on FloSoftball.com. High school & college softball coverage.',
      meta_articles_page_title: 'Softball News | Videos, Highlights & Articles',
      meta_articles_page_type: 'article',
      meta_default_image: 'https://d6fm3yzmawlcs.cloudfront.net/ogImages/Softball-1920x1080.jpg',
      meta_default_type: 'website',
      meta_events_entries_page_description:
        'Watch & stream live softball matches on FloSoftball.com. Softball games, videos, news, & articles. High school & college softball coverage.',
      meta_events_entries_page_title: 'Softball Games | Rosters & Live Softball',
      meta_events_entries_page_type: 'events',
      meta_events_news_page_description:
        'Watch & stream live softball matches on FloSoftball.com. Softball games, videos, news, & articles. High school & college softball coverage.',
      meta_events_news_page_title: 'Softball Games | News & Highlights',
      meta_events_news_page_type: 'event',
      meta_events_page_description:
        'Watch & stream live softball matches on FloSoftball.com. Softball games, videos, news, & articles. High school & college softball coverage.',
      meta_events_page_title: 'Softball Games | Videos & Highlights',
      meta_events_page_type: 'event',
      meta_events_photo_page_type: 'event',
      meta_events_photos_page_description:
        'Watch & stream live softball matches on FloSoftball.com. Softball games, videos, news, & articles. High school & college softball coverage.',
      meta_events_photos_page_title: 'Softball Games | Photos & Highlights',
      meta_events_schedule_page_description:
        'Watch & stream live softball matches on FloSoftball.com. Softball games, videos, news, & articles. High school & college softball coverage.',
      meta_events_schedule_page_title: 'Softball Games | Schedule & Live Softball',
      meta_events_schedule_page_type: 'event',
      meta_events_videos_page_description:
        'Watch & stream live softball matches on FloSoftball.com. Softball games, videos, news, & articles. High school & college softball coverage.',
      meta_events_videos_page_title: 'Softball Games | Videos & Highlights',
      meta_events_videos_page_type: 'event',
      meta_films_page_description:
        'Softball films, videos, games, news, & articles. Watch & stream live softball matches on FloSoftball.com. High school & college softball coverage.',
      meta_films_page_title: 'Softball Films | Videos, News, & Articles',
      meta_home_page_description:
        'Softball games, videos, news, & articles. Watch & stream live softball matches on FloSoftball.com. High school & college softball coverage.',
      meta_home_page_title: 'Softball | Articles, Videos & News',
      meta_login_page_description:
        'Softball games, videos, news, & articles. Watch & stream live softball matches on FloSoftball.com. High school & college softball coverage.',
      meta_login_page_title: 'Softball Games | Live Softball & Highlights',
      meta_not_found_page_description: 'Page not found for whatever reason!',
      meta_not_found_page_title: 'Page not found',
      meta_pay_page_description:
        'Softball games, videos, news, & articles. Watch & stream live softball matches on FloSoftball.com. High school & college softball coverage.',
      meta_pay_page_title: 'Softball Games | Live Softball & Highlights - Join Today',
      meta_ranking_page_description:
        'Watch & stream live softball matches on FloSoftball.com. Softball games, videos, news, & articles. High school & college softball coverage.',
      meta_ranking_page_title: 'Softball Games | Rankings & Videos',
      meta_ranking_page_type: 'rankings',
      meta_result_page_description:
        'Watch & stream live softball matches on FloSoftball.com. Softball games, videos, news, & articles. High school & college softball coverage.',
      meta_result_page_title: 'Softball Games | Results & Videos',
      meta_search_page_description:
        'Softball games, videos, news, & articles. Watch & stream live softball matches on FloSoftball.com. High school & college softball coverage.',
      meta_search_page_title: 'Softball | Articles, Videos & News',
      meta_signup_page_description:
        'Softball games, videos, news, & articles. Watch & stream live softball matches on FloSoftball.com. High school & college softball coverage.',
      meta_signup_page_title: 'Softball Games | Live Softball & Highlights - Join Today',
      meta_sport_name: 'softball',
      meta_training_page_description:
        'Softball training videos, games, news, & articles. Watch & stream live softball matches on FloSoftball.com. High school & college softball coverage.',
      meta_training_page_title: 'Softball Training | Videos, News, & Articles',
      meta_twitter_card_type: 'summary_large_image',
      meta_videos_page_description:
        'Softball videos, games, news, & articles. Watch & stream live softball matches on FloSoftball.com. High school & college softball coverage.',
      meta_videos_page_page_type: 'video.other',
      meta_videos_page_title: 'Softball Videos | Softball Games & Highlights',
      ooyala_master_ad_set: 'e34d8cd32d294b589cc281585aaadd00',
      ooyala_player_id: 'e0798993365348c58b8e71befc2860e6',
      primary_color: '#FF140F',
      privacy_url: 'https://www.flosports.tv/privacy/',
      segment_api_key: 'qYwxj9qA2mNHbtFclfCmDt9t3mWokvyi',
      site_id: 14,
      site_name: 'FloSoftball',
      sport_name: 'Softball',
      tos_url: 'https://www.flosports.tv/terms-of-service/',
      training_videos_name: 'Training',
      twitter_page_url: 'https://twitter.com/flosoftball',
      youtube_page_url: 'https://www.youtube.com/channel/UCjupYfxVriN_hc1Mo5qW-kw',
      gift_url: '/gift'
    }
  ],
  [
    SiteCode.MileSplit,
    {
      api_url: 'https://api30.milesplit.com',
      california_privacy_url: 'https://www.flosports.tv/california-privacy-policy/',
      careers_url: 'https://www.flosports.tv/work-with-us',
      contact_url: 'https://www.flosports.tv/contact/',
      core_site_url: 'https://accounts.milesplit.com',
      facebook_app_id: '261198561567',
      facebook_page_url: 'https://www.facebook.com/MileSplit/',
      faq_url: 'https://www.flosports.tv/faq/',
      favicon_url: 'https://d6fm3yzmawlcs.cloudfront.net/favicons/milesplit/',
      flosports_url: 'https://www.flosports.tv/',
      google_client_id: '350052275552-ehu9s8cabqf0reu65buk0mc0slleaq0t.apps.googleusercontent.com',
      instagram_page_url: 'https://www.instagram.com/milesplit/',
      meta_articles_page_description:
        'Stay up-to-date on all the news in the Milesplit world with the latest articles, delivered daily.',
      meta_articles_page_title: 'The most up-to-date Milesplit news &amp; articles!',
      meta_articles_page_type: 'article',
      meta_default_image: 'https://d6fm3yzmawlcs.cloudfront.net/ogImages/MileSplit-1920x1080.jpg',
      meta_default_type: 'website',
      meta_events_entries_page_description: 'Watch &amp; stream Milesplit live events. Events are our thing. Enjoy',
      meta_events_entries_page_title: 'Watch &amp; stream Milesplit events.',
      meta_events_entries_page_type: 'events',
      meta_events_news_page_description: 'Watch &amp; stream Milesplit live events. Events are our thing. Enjoy.',
      meta_events_news_page_title: 'Watch &amp; stream Milesplit events.',
      meta_events_news_page_type: 'event',
      meta_events_page_description: 'Watch &amp; stream Milesplit live events. Events are our thing. Enjoy.',
      meta_events_page_title: 'Watch &amp; stream Milesplit events.',
      meta_events_page_type: 'event',
      meta_events_photo_page_type: 'event',
      meta_events_photos_page_description: 'Watch &amp; stream Milesplit live events. Events are our thing. Enjoy',
      meta_events_photos_page_title: 'Watch &amp; stream Milesplit events',
      meta_events_schedule_page_description: 'Watch &amp; stream Milesplit live events. Events are our thing. Enjoy.',
      meta_events_schedule_page_title: 'Watch &amp; stream Milesplit events.',
      meta_events_schedule_page_type: 'event',
      meta_events_videos_page_description: 'Watch &amp; stream Milesplit live events. Events are our thing. Enjoy.',
      meta_events_videos_page_title: 'Watch &amp; stream Milesplit events.',
      meta_events_videos_page_type: 'event',
      meta_films_page_description: 'Watch Films and Documentaries',
      meta_films_page_title: 'Films and Documentaries',
      meta_home_page_description: 'Get the latest  Milesplit news, videos, &amp; events. All the info, all the time.',
      meta_home_page_title: 'The latest Milesplit news &amp; videos!',
      meta_login_page_description:
        'Log in to get the latest Milesplit news, videos, &amp; events. All the info, all the time.',
      meta_login_page_title: 'Log in now to check out exclusive Milesplit content!',
      meta_not_found_page_description: 'Page not found for whatever reason!',
      meta_not_found_page_title: 'Page not found',
      meta_pay_page_description: 'Get the latest Milesplit news, videos, &amp; events. All the info, all the time.',
      meta_pay_page_title: 'Subscribe &amp; get access to the latest Milesplit news, films, and events!',
      meta_ranking_page_description: "Who's the best of the best? Get current Milesplit rankings here.",
      meta_ranking_page_title: 'Get the most current Milesplit rankings!',
      meta_ranking_page_type: 'rankings',
      meta_result_page_description: 'Check out the latest Milesplit scores, direct  the results headquarters.',
      meta_result_page_title: 'Check out the Milesplit results!',
      meta_search_page_description:
        'Search the latest Milesplit news, videos, &amp; events. All the info, all the time.',
      meta_search_page_title: 'Search the latest Milesplit news &amp; videos!',
      meta_signup_page_description: 'Get the latest Milesplit news, videos, &amp; events. All the info, all the time.',
      meta_signup_page_title: 'Subscribe &amp; get access to the latest Milesplit news, films, and events!',
      meta_sport_name: 'Milesplit',
      meta_training_page_description: 'Watch training and technique videos',
      meta_training_page_title: 'Training and Technique Videos',
      meta_twitter_card_type: 'summary_large_image',
      meta_videos_page_description: 'Watch the latest Milesplit videos. All videos, all the time.',
      meta_videos_page_page_type: 'video.other',
      meta_videos_page_title: 'Watch the latest Milesplit videos!',
      ooyala_master_ad_set: null,
      ooyala_player_id: 'e0798993365348c58b8e71befc2860e6',
      primary_color: '#C80000',
      privacy_url: 'https://www.flosports.tv/privacy/',
      segment_api_key: 'aNJHVzqtABqlCj8RMdLp4YsCVZ51nbs3',
      site_id: 15,
      site_name: 'Milesplit',
      site_styles:
        '.logo .logo-text-mile {fill: #000062;}, .logo .logo-text-split {fill: #c80000;}, .logo.dark .logo-text-mile {fill: #fff;}, .logo.dark .logo-text-split {fill: #fff;}\r\nflo-header { background: #272a2b !important; }\r\n@media (max-width: 992px) { ul li.mobile-menu { background: #c80000; }}',
      sport_name: null,
      tos_url: 'https://www.flosports.tv/terms-of-service/',
      training_videos_name: 'Training',
      twitter_page_url: 'https://twitter.com/milesplit',
      youtube_page_url: 'https://www.youtube.com/channel/UCX7MXflg3DxDJTZi5mJRiOw',
      gift_url: '/gift'
    }
  ],
  [
    SiteCode.Varsity,
    {
      api_url: 'https://tv-admin.varsity.com',
      brands_privacy_url: 'https://www.varsitybrands.com/privacy-policy/',
      california_privacy_url: 'https://www.flosports.tv/california-privacy-policy/',
      careers_url: 'https://www.flosports.tv/work-with-us',
      contact_url: 'https://www.flosports.tv/varsity-contact/',
      core_site_url: 'https://tv.varsity.com',
      facebook_app_id: '598962243593285',
      facebook_page_url: 'https://www.facebook.com/VarsitySpirit/',
      faq_url: 'https://support.flosports.tv/',
      favicon_url: 'https://d6fm3yzmawlcs.cloudfront.net/favicons/varsity/',
      flosports_url: 'https://www.flosports.tv/',
      google_client_id: '400600143740-fsjuo9rms1caamcnd700gj6b6c8shnhe.apps.googleusercontent.com',
      instagram_page_url: 'https://www.instagram.com/varsityspirit/',
      meta_articles_page_description:
        'Stay up-to-date on all the news in the Varsity TV world with the latest articles, delivered daily.',
      meta_articles_page_title: 'The most up-to-date Varsity TV news  articles!',
      meta_articles_page_type: 'article',
      meta_default_image: 'https://d6fm3yzmawlcs.cloudfront.net/ogImages/EventThumbnail-VTV-Generic_2020.jpg',
      meta_default_type: 'website',
      meta_events_entries_page_description: 'Watch  stream Varsity TV live events. Events are our thing. Enjoy',
      meta_events_entries_page_title: 'Watch  stream Varsity TV events.',
      meta_events_entries_page_type: 'events',
      meta_events_news_page_description: 'Watch  stream Varsity TV live events. Events are our thing. Enjoy.',
      meta_events_news_page_title: 'Watch  stream Varsity TV events.',
      meta_events_news_page_type: 'event',
      meta_events_page_description: 'Watch  stream Varsity TV live events. Events are our thing. Enjoy.',
      meta_events_page_title: 'Watch  stream Varsity TV events.',
      meta_events_page_type: 'event',
      meta_events_photo_page_type: 'event',
      meta_events_photos_page_description: 'Watch  stream Varsity TV live events. Events are our thing. Enjoy',
      meta_events_photos_page_title: 'Watch  stream Varsity TV events',
      meta_events_schedule_page_description: 'Watch  stream Varsity TV live events. Events are our thing. Enjoy.',
      meta_events_schedule_page_title: 'Watch  stream Varsity TV events.',
      meta_events_schedule_page_type: 'event',
      meta_events_videos_page_description: 'Watch  stream Varsity TV live events. Events are our thing. Enjoy.',
      meta_events_videos_page_title: 'Watch  stream Varsity TV events.',
      meta_events_videos_page_type: 'event',
      meta_films_page_description: 'Watch Films and Documentaries',
      meta_films_page_title: 'Films and Documentaries',
      meta_home_page_description: 'Get the latest Varsity TV news, videos,  events. All the info, all the time.',
      meta_home_page_title: 'The latest Varsity TV news  videos!',
      meta_login_page_description:
        'Log in to get the latest Varsity TV news, videos,  events. All the info, all the time.',
      meta_login_page_title: 'Log in now to check out exclusive Varsity TV content!',
      meta_not_found_page_description: 'Page not found for whatever reason!',
      meta_not_found_page_title: 'Page not found',
      meta_pay_page_description: 'Get the latest Varsity TV news, videos,  events. All the info, all the time.',
      meta_pay_page_title: 'Subscribe  get access to the latest Varsity TV news, films, and events!',
      meta_ranking_page_description: "Who's the best of the best? Get current Varsity TV rankings here.",
      meta_ranking_page_title: 'Get the most current Varsity TV rankings!',
      meta_ranking_page_type: 'rankings',
      meta_result_page_description: 'Check out the latest Varsity TV scores, direct  the results headquarters.',
      meta_result_page_title: 'Check out the Varsity TV results!',
      meta_search_page_description: 'Search the latest Varsity TV news, videos,  events. All the info, all the time.',
      meta_search_page_title: 'Search the latest Varsity TV news  videos!',
      meta_signup_page_description: 'Get the latest Varsity TV news, videos,  events. All the info, all the time.',
      meta_signup_page_title: 'Subscribe  get access to the latest Varsity TV news, films, and events!',
      meta_sport_name: 'cheerleading',
      meta_training_page_description: 'Watch training and technique videos',
      meta_training_page_title: 'Training and Technique Videos',
      meta_twitter_card_type: 'summary_large_image',
      meta_videos_page_description: 'Watch the latest Varsity TV videos. All videos, all the time.',
      meta_videos_page_page_type: 'video.other',
      meta_videos_page_title: 'Watch the latest Varsity TV videos!',
      ooyala_master_ad_set: '23343907bdc244b5a655083f94a4892d',
      ooyala_player_id: 'e0798993365348c58b8e71befc2860e6',
      primary_color: '#247BB8',
      privacy_url: 'https://www.flosports.tv/privacy/',
      segment_api_key: 'kC6rBe8i7wKlWfe2K4rU5ZyTlMcjewbw',
      site_id: 20,
      site_name: 'Varsity TV',
      sport_name: 'Cheer & Dance',
      tos_url: 'https://www.flosports.tv/terms-of-service/',
      tou_url: 'https://www.varsitybrands.com/terms-of-use/',
      training_videos_name: 'Fitness',
      twitter_page_url: 'https://twitter.com/VarsitySpirit',
      youtube_page_url: 'https://www.youtube.com/user/cheerleadingvideo',
      gift_url: '/gift'
    }
  ],
  [
    SiteCode.Volleyball,
    {
      api_url: 'https://api.flovolleyball.tv',
      california_privacy_url: 'https://www.flosports.tv/california-privacy-policy/',
      careers_url: 'https://www.flosports.tv/work-with-us',
      contact_url: 'https://support.flosports.tv/',
      core_site_url: 'https://www.flovolleyball.tv',
      facebook_app_id: '1572653523024515',
      facebook_page_url: 'https://www.facebook.com/FloVolleyball/',
      faq_url: 'https://support.flosports.tv/',
      favicon_url: 'https://d6fm3yzmawlcs.cloudfront.net/favicons/new-favicon/',
      flosports_url: 'https://www.flosports.tv/',
      google_client_id: '431732664053-2podu2e28h8rtbouio4artpppbgkfg9q.apps.googleusercontent.com',
      instagram_page_url: 'https://www.instagram.com/flovolleyball/',
      meta_articles_page_description:
        'Volleyball news, games, videos, & articles. Watch & stream live volleyball competitions on FloVolleyball.tv. College, professional & international coverage.',
      meta_articles_page_title: 'Volleyball News | Videos, Highlights & Articles',
      meta_articles_page_type: 'article',
      meta_default_image: 'https://d6fm3yzmawlcs.cloudfront.net/ogImages/Volleyball-1920x1080.jpg',
      meta_default_type: 'website',
      meta_events_entries_page_description:
        'Watch & stream live volleyball competitions on FloVolleyball.tv. Volleyball games, videos, news, & articles. College, professional & international coverage.',
      meta_events_entries_page_title: 'Volleyball Games | Rosters & Live Volleyball',
      meta_events_entries_page_type: 'events',
      meta_events_news_page_description:
        'Watch & stream live volleyball competitions on FloVolleyball.tv. Volleyball games, videos, news, & articles. College, professional & international coverage.',
      meta_events_news_page_title: 'Volleyball Games | Live Volleyball & Highlights',
      meta_events_news_page_type: 'event',
      meta_events_page_description:
        'Watch & stream live volleyball competitions on FloVolleyball.tv. Volleyball games, videos, news, & articles. College, professional & international coverage.',
      meta_events_page_title: 'Volleyball Games | Live Volleyball & Highlights',
      meta_events_page_type: 'event',
      meta_events_photo_page_type: 'event',
      meta_events_photos_page_description:
        'Watch & stream live volleyball competitions on FloVolleyball.tv. Volleyball games, videos, news, & articles. College, professional & international coverage.',
      meta_events_photos_page_title: 'Volleyball Games | Photos & Highlights',
      meta_events_schedule_page_description:
        'Watch & stream live volleyball competitions on FloVolleyball.tv. Volleyball games, videos, news, & articles. College, professional & international coverage.',
      meta_events_schedule_page_title: 'Volleyball Games | Schedule & Live Volleyball',
      meta_events_schedule_page_type: 'event',
      meta_events_videos_page_description:
        'Watch & stream live volleyball competitions on FloVolleyball.tv. Volleyball games, videos, news, & articles. College, professional & international coverage.',
      meta_events_videos_page_title: 'Volleyball Games | Live Volleyball & Highlights',
      meta_events_videos_page_type: 'event',
      meta_films_page_description: 'Watch Films and Documentaries',
      meta_films_page_title: 'Films and Documentaries',
      meta_home_page_description:
        'Volleyball games, videos, news, & articles. Watch & stream live volleyball competitions on FloVolleyball.tv. College, professional & international coverage.',
      meta_home_page_title: 'Volleyball | News, Videos & Articles',
      meta_login_page_description:
        'Volleyball games, videos, news, & articles. Watch & stream live volleyball competitions on FloVolleyball.tv. College, professional & international coverage.',
      meta_login_page_title: 'Volleyball Games | Live Volleyball & Highlights',
      meta_not_found_page_description: 'Page not found for whatever reason!',
      meta_not_found_page_title: 'Page not found',
      meta_pay_page_description:
        'Volleyball games, videos, news, & articles. Watch & stream live volleyball competitions on FloVolleyball.tv. College, professional & international coverage.',
      meta_pay_page_title: 'Volleyball Games | Live Volleyball & Highlights - Join Today',
      meta_ranking_page_description:
        'Watch & stream live volleyball competitions on FloVolleyball.tv. Volleyball games, videos, news, & articles. College, professional & international coverage.',
      meta_ranking_page_title: 'Volleyball Games | Rankings & Videos',
      meta_ranking_page_type: 'rankings',
      meta_result_page_description:
        'Watch & stream live volleyball competitions on FloVolleyball.tv. Volleyball games, videos, news, & articles. College, professional & international coverage.',
      meta_result_page_title: 'Volleyball Games | Results & Videos',
      meta_search_page_description:
        'Volleyball games, videos, news, & articles. Watch & stream live volleyball competitions on FloVolleyball.tv. College, professional & international coverage.',
      meta_search_page_title: 'Volleyball | News, Videos & Articles',
      meta_signup_page_description:
        'Volleyball games, videos, news, & articles. Watch & stream live volleyball competitions on FloVolleyball.tv. College, professional & international coverage.',
      meta_signup_page_title: 'Volleyball Games | Live Volleyball & Highlights - Join Today',
      meta_sport_name: 'Volleyball',
      meta_training_page_description: 'Watch training and technique videos',
      meta_training_page_title: 'Training and Technique Videos',
      meta_twitter_card_type: 'summary_large_image',
      meta_videos_page_description:
        'Volleyball videos, games, news, & articles. Watch & stream live volleyball competitions on FloVolleyball.tv. College, professional & international coverage.',
      meta_videos_page_page_type: 'video.other',
      meta_videos_page_title: 'Volleyball Videos | Volleyball Games & Highlights',
      ooyala_master_ad_set: 'fee8ba33c28c4f439df6739c7f65a891',
      ooyala_player_id: 'e0798993365348c58b8e71befc2860e6',
      primary_color: '#FF140F',
      privacy_url: 'https://www.flosports.tv/privacy/',
      segment_api_key: 'bSxczMOM2tAfSrne4fY2lmuX1gFOyz52',
      site_id: 22,
      site_name: 'FloVolleyball',
      sport_name: 'Volleyball',
      tos_url: 'https://www.flosports.tv/terms-of-service/',
      training_videos_name: 'Training',
      twitter_page_url: 'https://twitter.com/flovolleyball',
      youtube_page_url: 'https://www.youtube.com/channel/UCjl8UhCmj3gFmtDe5_MiGgg',
      gift_url: '/gift'
    }
  ],
  [
    SiteCode.Combat,
    {
      api_url: 'https://api.flocombat.com',
      california_privacy_url: 'https://www.flosports.tv/california-privacy-policy/',
      careers_url: 'https://www.flosports.tv/work-with-us',
      contact_url: 'https://support.flosports.tv/',
      core_site_url: 'https://www.flocombat.com',
      facebook_app_id: '483947368455753',
      facebook_page_url: 'https://www.facebook.com/FloCombat',
      faq_url: 'https://support.flosports.tv/',
      favicon_url: 'https://d6fm3yzmawlcs.cloudfront.net/favicons/new-favicon/',
      flosports_url: 'https://www.flosports.tv/',
      google_client_id: '705505072565-jlltvdpq3iq7ro6omt3a7t5erd7bp59a.apps.googleusercontent.com',
      instagram_page_url: 'https://www.instagram.com/flocombat/',
      meta_articles_page_description:
        'Combat articles, videos, news, & events. Watch & stream live combat competitions on FloCombat.com. Professional & amateur combat event & news coverage.',
      meta_articles_page_title: 'Combat News | Combat Videos & Results',
      meta_articles_page_type: 'article',
      meta_default_image: 'https://d6fm3yzmawlcs.cloudfront.net/ogImages/Combat-1920x1080.jpg',
      meta_default_type: 'website',
      meta_events_entries_page_description:
        'Watch & stream live combat competitions on FloCombat.com. Combat events, videos, news, & articles. Professional & amateur combat event & news coverage.',
      meta_events_entries_page_title: 'Combat Events | Combat Schedule',
      meta_events_entries_page_type: 'events',
      meta_events_news_page_description:
        'Watch & stream live combat competitions on FloCombat.com.  events, videos, news, & articles. Professional & amateur combat event & news coverage.',
      meta_events_news_page_title: 'Combat News | Combat Videos & Results',
      meta_events_news_page_type: 'event',
      meta_events_page_description:
        'Watch & stream live combat competitions on FloCombat.com. combat events, videos, news, & articles. Professional & amateur combat event & news coverage.',
      meta_events_page_title: 'Combat Events | Combat Videos & Streams',
      meta_events_page_type: 'event',
      meta_events_photo_page_type: 'event',
      meta_events_photos_page_description:
        'Watch & stream live combat competitions on FloCombat.com. Combat events, videos, news, & articles. Professional & amateur combat event & news coverage.',
      meta_events_photos_page_title: 'Combat Events | Combat Event Photos',
      meta_events_schedule_page_description:
        'Watch & stream live combat competitions on FloCombat.com. Combat events, videos, news, & articles. Professional & amateur combat event & news coverage.',
      meta_events_schedule_page_title: 'Combat Schedule | Combat Events',
      meta_events_schedule_page_type: 'event',
      meta_events_videos_page_description:
        'Watch & stream live combat competitions on FloCombat.com. Combat events, videos, news, & articles. Professional & amateur combat event & news coverage.',
      meta_events_videos_page_title: 'Combat Videos | Combat Events & Streams',
      meta_events_videos_page_type: 'event',
      meta_films_page_description: 'Watch Films and Documentaries',
      meta_films_page_title: 'Films and Documentaries',
      meta_home_page_description:
        'Combat events, videos, news, & articles. Watch & stream live combat competitions on FloCombat.com. Professional & amateur combat event & news coverage.',
      meta_home_page_title: 'Combat | News, Videos & Articles',
      meta_login_page_description:
        'Combat events, videos, news, & articles. Watch & stream live combat competitions on FloCombat.com. Professional & amateur combat event & news coverage.',
      meta_login_page_title: 'Combat Events | Combat News, Videos & Articles',
      meta_not_found_page_description: 'Page not found for whatever reason!',
      meta_not_found_page_title: 'Page not found',
      meta_pay_page_description:
        'Combat events, videos, news, & articles. Watch & stream live combat competitions on FloCombat.com. Professional & amateur combat event & news coverage.',
      meta_pay_page_title: 'Combat Events | Combat News, Videos & Articles - Join Today',
      meta_ranking_page_description:
        'Watch & stream live combat competitions on FloCombat.com. Combat events, videos, news, & articles. Professional & amateur combat event & news coverage.',
      meta_ranking_page_title: 'Combat Rankings | Combat News, Videos & Articles',
      meta_ranking_page_type: 'rankings',
      meta_result_page_description:
        'Combat events, videos, news, & articles. Watch & stream live combat competitions on FloCombat.com. Professional & amateur combat event & news coverage.',
      meta_result_page_title: 'Combat Results | Combat News, Videos & Articles',
      meta_search_page_description:
        'Combat events, videos, news, & articles. Watch & stream live combat competitions on FloCombat.com. Professional & amateur combat event & news coverage.',
      meta_search_page_title: 'Combat | News, Videos & Articles',
      meta_signup_page_description:
        'Combat events, videos, news, & articles. Watch & stream live combat competitions on FloCombat.com. Professional & amateur combat event & news coverage.',
      meta_signup_page_title: 'Combat Events | Combat News, Videos & Articles - Join Today',
      meta_sport_name: 'Combat',
      meta_training_page_description: 'Watch training and technique videos',
      meta_training_page_title: 'Training and Technique Videos',
      meta_twitter_card_type: 'summary_large_image',
      meta_videos_page_description:
        'Combat videos, events, news, & articles. Watch & stream live combat competitions on FloCombat.com. Professional & amateur combat event & news coverage.',
      meta_videos_page_page_type: 'video.other',
      meta_videos_page_title: 'Combat Videos | Combat Events & Streams',
      ooyala_master_ad_set: '30c2b366f5fd4bf5834830793f293d24',
      ooyala_player_id: 'e0798993365348c58b8e71befc2860e6',
      primary_color: '#FF140F',
      privacy_url: 'https://www.flosports.tv/privacy/',
      segment_api_key: 'eKYReXLUgMW29rlzpSz1ub0YgwfkNZyi',
      site_id: 23,
      site_name: 'FloCombat',
      sport_name: 'MMA',
      tos_url: 'https://www.flosports.tv/terms-of-service/',
      training_videos_name: 'Training',
      twitter_page_url: 'https://twitter.com/FloCombat',
      youtube_page_url: 'https://www.youtube.com/channel/UCGX_r3XOkjuvaw_86teUmCQ',
      gift_url: '/gift'
    }
  ],
  [
    SiteCode.Marching,
    {
      api_url: 'https://api.flomarching.com',
      california_privacy_url: 'https://www.flosports.tv/california-privacy-policy/',
      careers_url: 'https://www.flosports.tv/work-with-us',
      contact_url: 'https://support.flosports.tv/',
      core_site_url: 'https://www.flomarching.com',
      facebook_app_id: '259161254470922',
      facebook_page_url: 'https://www.facebook.com/FloMarching',
      faq_url: 'https://support.flosports.tv/',
      favicon_url: 'https://d6fm3yzmawlcs.cloudfront.net/favicons/new-favicon/',
      flosports_url: 'https://www.flosports.tv/',
      google_client_id: '941286239586-u9vdjj3otg53v36j1jms7bqmup4jekjg.apps.googleusercontent.com',
      instagram_page_url: 'https://www.instagram.com/flomarching/',
      meta_articles_page_description:
        'Marching news, competitions, videos,  articles. Watch  stream live marching events on FloMarching.com. High school  professional marching band coverage.',
      meta_articles_page_title: 'Marching News | Videos, Highlights  Articles',
      meta_articles_page_type: 'article',
      meta_default_image: 'https://d6fm3yzmawlcs.cloudfront.net/ogImages/Marching-1920x1080.jpg',
      meta_default_type: 'website',
      meta_events_entries_page_description:
        'Watch  stream live marching events on FloMarching.com. Marching competitions, videos, news,  articles. High school  professional marching band coverage.',
      meta_events_entries_page_title: 'Marching Competition | Marching Entries  Schedules',
      meta_events_entries_page_type: 'events',
      meta_events_news_page_description:
        'Watch  stream live marching events on FloMarching.com. Marching competitions, videos, news,  articles. High school  professional marching band coverage.',
      meta_events_news_page_title: 'Marching Competition | Videos, Highlights  Articles',
      meta_events_news_page_type: 'event',
      meta_events_page_description:
        'Watch  stream live marching events on FloMarching.com. Marching competitions, videos, news,  articles. High school  professional marching band coverage.',
      meta_events_page_title: 'Marching Competition | Videos  Highlights',
      meta_events_page_type: 'event',
      meta_events_photo_page_type: 'event',
      meta_events_photos_page_description:
        'Watch  stream live marching events on FloMarching.com. Marching competitions, videos, news,  articles. High school  professional marching band coverage.',
      meta_events_photos_page_title: 'Marching Competition | Photos  Highlights',
      meta_events_schedule_page_description:
        'Watch  stream live marching events on FloMarching.com. Marching competitions, videos, news,  articles. High school  professional marching band coverage.',
      meta_events_schedule_page_title: 'Marching Competition | Schedule  Videos',
      meta_events_schedule_page_type: 'event',
      meta_events_videos_page_description:
        'Watch  stream live marching events on FloMarching.com. Marching competitions, videos, news,  articles. High school  professional marching band coverage.',
      meta_events_videos_page_title: 'Marching Competition | Videos  Highlights',
      meta_events_videos_page_type: 'event',
      meta_films_page_description:
        'Marching films, videos, competitions, news,  articles. Watch  stream live marching events on FloMarching.com. High school  professional marching band coverage.',
      meta_films_page_title: 'Marching Films | Videos, News,  Articles',
      meta_home_page_description:
        'Marching competitions, videos, news,  articles. Watch  stream live marching events on FloMarching.com. High school  professional marching band coverage.',
      meta_home_page_title: 'Marching | News, Videos  Articles',
      meta_login_page_description:
        'Marching competitions, videos, news,  articles. Watch  stream live marching events on FloMarching.com. High school  professional marching band coverage.',
      meta_login_page_title: 'Marching News | Marching Competition  Videos',
      meta_not_found_page_description: 'Page not found for whatever reason!',
      meta_not_found_page_title: 'Page not found',
      meta_pay_page_description:
        'Marching competitions, videos, news,  articles. Watch  stream live marching events on FloMarching.com. High school  professional marching band coverage.',
      meta_pay_page_title: 'Marching News | Marching Competition  Videos - Join Today',
      meta_ranking_page_description:
        'Watch  stream live marching events on FloMarching.com. Marching competitions, videos, news,  articles. High school  professional marching band coverage.',
      meta_ranking_page_title: 'Marching News | Marching Rankings  Highlights',
      meta_ranking_page_type: 'rankings',
      meta_result_page_description:
        'Watch  stream live marching events on FloMarching.com. Marching competitions, videos, news,  articles. High school  professional marching band coverage.',
      meta_result_page_title: 'Marching Scores | Marching News  Results',
      meta_search_page_description:
        'Marching competitions, videos, news,  articles. Watch  stream live marching events on FloMarching.com. High school  professional marching band coverage.',
      meta_search_page_title: 'Marching | News, Videos  Articles',
      meta_signup_page_description:
        'Marching competitions, videos, news,  articles. Watch  stream live marching events on FloMarching.com. High school  professional marching band coverage.',
      meta_signup_page_title: 'Marching News | Marching Competition  Videos - Join Today',
      meta_sport_name: 'Marching Arts',
      meta_training_page_description:
        'Marching training videos, competitions, news,  articles. Watch  stream live marching events on FloMarching.com. High school  professional marching band coverage.',
      meta_training_page_title: 'Marching Training | Videos, News,  Articles',
      meta_twitter_card_type: 'summary_large_image',
      meta_videos_page_description:
        'Marching videos, competitions, news,  articles. Watch  stream live marching events on FloMarching.com. High school  professional marching band coverage.',
      meta_videos_page_page_type: 'video.other',
      meta_videos_page_title: 'Marching Videos | Marching Competition  Highlights',
      ooyala_master_ad_set: '62a1fbc5a4094c47a696f6e71f00bd1f',
      ooyala_player_id: 'e0798993365348c58b8e71befc2860e6',
      primary_color: '#FF140F',
      privacy_url: 'https://www.flosports.tv/privacy/',
      segment_api_key: '6VZ9qas6vcOK17MwJKsGwjun0Ps5PrGG',
      site_id: 27,
      site_name: 'FloMarching',
      sport_name: 'Marching Arts',
      tos_url: 'https://www.flosports.tv/terms-of-service/',
      training_videos_name: 'Training',
      twitter_page_url: 'https://twitter.com/FloMarching',
      youtube_page_url: 'https://www.youtube.com/channel/UCOmJ_7uzQpO804NAOWvFVkg',
      gift_url: '/gift'
    }
  ],
  [
    SiteCode.Swimming,
    {
      api_url: 'https://api.floswimming.com',
      california_privacy_url: 'https://www.flosports.tv/california-privacy-policy/',
      careers_url: 'https://www.flosports.tv/work-with-us',
      contact_url: 'https://support.flosports.tv/',
      core_site_url: 'https://www.floswimming.com',
      facebook_app_id: '1166020863454883',
      facebook_page_url: 'https://www.facebook.com/FloSwimming',
      faq_url: 'https://support.flosports.tv/',
      favicon_url: 'https://d6fm3yzmawlcs.cloudfront.net/favicons/new-favicon/',
      flosports_url: 'https://www.flosports.tv/',
      google_client_id: '76562558908-nhk4mf8cmlc44qgcrc7icq68008cfr0i.apps.googleusercontent.com',
      instagram_page_url: 'https://www.instagram.com/floswimming/',
      meta_articles_page_description:
        'Swim articles, videos, news, & meets. Watch & stream live swim competitions on FloSwimming.com. College & professional swimming coverage.',
      meta_articles_page_title: 'Swimming News | Swimming Articles',
      meta_articles_page_type: 'article',
      meta_default_image: 'https://d6fm3yzmawlcs.cloudfront.net/ogImages/Swimming-1920x1080.jpg',
      meta_default_type: 'website',
      meta_events_entries_page_description:
        'Watch & stream live swim competitions on FloSwimming.com. Swim meets, videos, news, & articles. College & professional swimming coverage.',
      meta_events_entries_page_title: 'Swimming Events | Swimming Schedule & Entries',
      meta_events_entries_page_type: 'events',
      meta_events_news_page_description:
        'Watch & stream live swim competitions on FloSwimming.com. Swim meets, videos, news, & articles. College & professional swimming coverage.',
      meta_events_news_page_title: 'Swimming News | Swimming Articles',
      meta_events_news_page_type: 'event',
      meta_events_page_description:
        'Watch & stream live swim competitions on FloSwimming.com. Swim meets, videos, news, & articles. College & professional swimming coverage.',
      meta_events_page_title: 'Swimming Events | Swim Meets & Highlights',
      meta_events_page_type: 'event',
      meta_events_photo_page_type: 'event',
      meta_events_photos_page_description:
        'Watch & stream live swim competitions on FloSwimming.com. Swim meets, videos, news, & articles. College & professional swimming coverage.',
      meta_events_photos_page_title: 'Swimming Events | Swimming Meet Photos',
      meta_events_schedule_page_description:
        'Watch & stream live swim competitions on FloSwimming.com. Swim meets, videos, news, & articles. College & professional swimming coverage.',
      meta_events_schedule_page_title: 'Swimming Schedule | Swimming Entries & Events',
      meta_events_schedule_page_type: 'event',
      meta_events_videos_page_description:
        'Watch & stream live swim competitions on FloSwimming.com. Swim meets, videos, news, & articles. College & professional swimming coverage.',
      meta_events_videos_page_title: 'Swimming Videos | Swim Meets & Highlights',
      meta_events_videos_page_type: 'event',
      meta_films_page_description:
        'Swim films, videos, meets, news, & articles. Watch & stream live swim competitions on FloSwimming.com. College & professional swimming coverage.',
      meta_films_page_title: 'Swimming Films | Videos, News, & Articles',
      meta_home_page_description:
        'Swim meets, videos, news, & articles. Watch & stream live swim competitions on FloSwimming.com. College & professional swimming coverage.',
      meta_home_page_title: 'Swimming | News, Events, & Articles',
      meta_login_page_description:
        'Swim meets, videos, news, & articles. Watch & stream live swim competitions on FloSwimming.com. College & professional swimming coverage.',
      meta_login_page_title: 'Swimming | News, Articles, & Live Swim Meets - Join Today',
      meta_not_found_page_description: 'Page not found for whatever reason!',
      meta_not_found_page_title: 'Page not found',
      meta_pay_page_description:
        'Swim meets, videos, news, & articles. Watch & stream live swim competitions on FloSwimming.com. College & professional swimming coverage.',
      meta_pay_page_title: 'Swimming | News, Articles, & Live Swim Meets - Join Today',
      meta_ranking_page_description:
        'Watch & stream live swim competitions on FloSwimming.com. Swim meets, videos, news, & articles. College & professional swimming coverage.',
      meta_ranking_page_title: 'Swimming | Rankings & Live Swim Meets',
      meta_ranking_page_type: 'rankings',
      meta_result_page_description:
        'Watch & stream live swim competitions on FloSwimming.com. Swim meets, videos, news, & articles. College & professional swimming coverage.',
      meta_result_page_title: 'Swim Results | Swim Results, Meets, & Coverage',
      meta_search_page_description:
        'Swim meets, videos, news, & articles. Watch & stream live swim competitions on FloSwimming.com. College & professional swimming coverage.',
      meta_search_page_title: 'Swimming | News, Events, & Articles',
      meta_signup_page_description:
        'Swim meets, videos, news, & articles. Watch & stream live swim competitions on FloSwimming.com. College & professional swimming coverage.',
      meta_signup_page_title: 'Swimming | News, Articles, & Live Swim Meets - Join Today',
      meta_sport_name: 'Swimming',
      meta_training_page_description:
        'Swim training videos, meets, news, & articles. Watch & stream live swim competitions on FloSwimming.com. College & professional swimming coverage.',
      meta_training_page_title: 'Swimming Training | Videos, News, & Articles',
      meta_twitter_card_type: 'summary_large_image',
      meta_videos_page_description:
        'Swim videos, meets, news, & articles. Watch & stream live swim competitions on FloSwimming.com. College & professional swimming coverage.',
      meta_videos_page_page_type: 'video.other',
      meta_videos_page_title: 'Swimming Videos | Meets & Highlights',
      ooyala_master_ad_set: 'cccd83ca586049218519c79e692d7592',
      ooyala_player_id: 'e0798993365348c58b8e71befc2860e6',
      primary_color: '#FF140F',
      privacy_url: 'https://www.flosports.tv/privacy/',
      segment_api_key: '70pu1kbzYKL47S9YDNTDCwGdxY2enULx',
      site_id: 28,
      site_name: 'FloSwimming',
      sport_name: 'Swimming',
      tos_url: 'https://www.flosports.tv/terms-of-service/',
      training_videos_name: 'Training',
      twitter_page_url: 'https://twitter.com/floswimming',
      youtube_page_url: 'https://www.youtube.com/channel/UCAnzXT5pmV8phtMsnavN7Qg',
      gift_url: '/gift'
    }
  ],
  [
    SiteCode.Hockey,
    {
      api_url: 'https://api.flohockey.tv',
      california_privacy_url: 'https://www.flosports.tv/california-privacy-policy/',
      careers_url: 'https://www.flosports.tv/work-with-us',
      contact_url: 'https://support.flosports.tv/',
      core_site_url: 'https://www.flohockey.tv',
      facebook_app_id: '1191164334233126',
      facebook_page_url: 'https://www.facebook.com/FloHockey',
      faq_url: 'https://support.flosports.tv/',
      favicon_url: 'https://d6fm3yzmawlcs.cloudfront.net/favicons/new-favicon/',
      flosports_url: 'https://www.flosports.tv/',
      google_client_id: '360147687037-ca8i2nmmfp9ouh3b2glrch546fr49v7g.apps.googleusercontent.com',
      instagram_page_url: 'https://www.instagram.com/flohockey/',
      meta_articles_page_description:
        'Hockey articles, games, news, & videos. Watch & stream live hockey games on FloHockey.tv. Junior, college, & professional hockey games & news coverage.',
      meta_articles_page_title: 'Hockey News | Videos, Highlights & Articles',
      meta_articles_page_type: 'article',
      meta_default_image: 'https://d6fm3yzmawlcs.cloudfront.net/ogImages/Hockey-1920x1080.jpg',
      meta_default_type: 'website',
      meta_events_entries_page_description:
        'Watch & stream live hockey games on FloHockey.tv. Hockey games, videos, news, & articles. Junior, college, & professional hockey games & news coverage.',
      meta_events_entries_page_title: 'Hockey Games | Hockey Schedules',
      meta_events_entries_page_type: 'events',
      meta_events_news_page_description:
        'Watch & stream live hockey games on FloHockey.tv. Hockey games, videos, news, & articles. Junior, college, & professional hockey games & news coverage.',
      meta_events_news_page_title: 'Hockey Games | Videos, Highlights & Articles',
      meta_events_news_page_type: 'event',
      meta_events_page_description:
        'Watch & stream live hockey games on FloHockey.tv. Hockey games, videos, news, & articles. Junior, college, & professional hockey games & news coverage.',
      meta_events_page_title: 'Hockey Games | Videos & Highlights',
      meta_events_page_type: 'event',
      meta_events_photo_page_type: 'event',
      meta_events_photos_page_description:
        'Watch & stream live hockey games on FloHockey.tv. Hockey games, videos, news, & articles. Junior, college, & professional hockey games & news coverage.',
      meta_events_photos_page_title: 'Hockey Games | Photos & Highlights',
      meta_events_schedule_page_description:
        'Watch & stream live hockey games on FloHockey.tv. Hockey games, videos, news, & articles. Junior, college, & professional hockey games & news coverage.',
      meta_events_schedule_page_title: 'Hockey Games | Schedule & Videos',
      meta_events_schedule_page_type: 'event',
      meta_events_videos_page_description:
        'Watch & stream live hockey games on FloHockey.tv. Hockey games, videos, news, & articles. Junior, college, & professional hockey games & news coverage.',
      meta_events_videos_page_title: 'Hockey Games | Videos & Highlights',
      meta_events_videos_page_type: 'event',
      meta_films_page_description: 'Watch Films and Documentaries',
      meta_films_page_title: 'Films and Documentaries',
      meta_home_page_description:
        'Hockey games, videos, news, & articles. Watch & stream live hockey games on FloHockey.tv. Junior, college, & professional hockey games & news coverage.',
      meta_home_page_title: 'Hockey | Videos, News & Articles',
      meta_login_page_description:
        'Hockey games, videos, news, & articles. Watch & stream live hockey games on FloHockey.tv. Junior, college, & professional hockey games & news coverage.',
      meta_login_page_title: 'Hockey News | Hockey Games & Videos',
      meta_not_found_page_description: 'Page not found for whatever reason!',
      meta_not_found_page_title: 'Page not found',
      meta_pay_page_description:
        'Hockey games, videos, news, & articles. Watch & stream live hockey games on FloHockey.tv. Junior, college, & professional hockey games & news coverage.',
      meta_pay_page_title: 'Hockey News | Hockey Games & Videos - Join FloHockey.tv',
      meta_ranking_page_description:
        'Hockey games, videos, news, & articles. Watch & stream live hockey games on FloHockey.tv. Junior, college, & professional hockey games & news coverage.',
      meta_ranking_page_title: 'Hockey News | Hockey Rankings & Highlights',
      meta_ranking_page_type: 'rankings',
      meta_result_page_description:
        'Hockey games, videos, news, & articles. Watch & stream live hockey games on FloHockey.tv. Junior, college, & professional hockey games & news coverage.',
      meta_result_page_title: 'Hockey Scores | Hockey News & Results',
      meta_search_page_description:
        'Hockey games, videos, news, & articles. Watch & stream live hockey games on FloHockey.tv. Junior, college, & professional hockey games & news coverage.',
      meta_search_page_title: 'Hockey | Videos, News & Articles',
      meta_signup_page_description:
        'Hockey games, videos, news, & articles. Watch & stream live hockey games on FloHockey.tv. Junior, college, & professional hockey games & news coverage.',
      meta_signup_page_title: 'Hockey News | Hockey Games & Videos - Join FloHockey.tv',
      meta_sport_name: 'Hockey',
      meta_training_page_description: 'Watch training and technique videos',
      meta_training_page_title: 'Training and Technique Videos',
      meta_twitter_card_type: 'summary_large_image',
      meta_videos_page_description:
        'Hockey videos, games, news, & articles. Watch & stream live hockey games on FloHockey.tv. Junior, college, & professional hockey games & news coverage.',
      meta_videos_page_page_type: 'video.other',
      meta_videos_page_title: 'Hockey Videos | Hockey Games & Highlights',
      ooyala_master_ad_set: 'b9abf59d0fbc465984ba5b6455440ac1',
      ooyala_player_id: 'e0798993365348c58b8e71befc2860e6',
      primary_color: '#FF140F',
      privacy_url: 'https://www.flosports.tv/privacy/',
      segment_api_key: 'ubmqUAkSyyfBEdQVImiqM7h1Ewv5NE68',
      site_id: 29,
      site_name: 'FloHockey',
      sport_name: 'Hockey',
      tos_url: 'https://www.flosports.tv/terms-of-service/',
      training_videos_name: 'Training',
      twitter_page_url: 'https://twitter.com/FloHockey',
      youtube_page_url: 'https://www.youtube.com/channel/UCoDZ1gwkbsZ9KGD2VdzG6DA',
      gift_url: '/gift'
    }
  ],
  [
    SiteCode.Rodeo,
    {
      api_url: 'https://api.florodeo.com',
      california_privacy_url: 'https://www.flosports.tv/california-privacy-policy/',
      careers_url: 'https://www.flosports.tv/work-with-us',
      contact_url: 'https://support.flosports.tv/',
      core_site_url: 'https://www.florodeo.com',
      facebook_app_id: '180180222319059',
      facebook_page_url: 'https://www.facebook.com/FloRodeo',
      faq_url: 'https://support.flosports.tv/',
      favicon_url: 'https://d6fm3yzmawlcs.cloudfront.net/favicons/new-favicon/',
      flosports_url: 'https://www.flosports.tv/',
      google_client_id: '801064030168-e854jvo0r8hc5s8dbi5eld6mdojbi1kh.apps.googleusercontent.com',
      instagram_page_url: 'https://www.instagram.com/florodeo/',
      meta_articles_page_description:
        'Rodeo articles, events, videos, & news. Watch & stream live rodeo competitions on FloRodeo.com. Youth & professional rodeo coverage.',
      meta_articles_page_title: 'Rodeo News | Events, Videos & Highlights',
      meta_articles_page_type: 'article',
      meta_default_image: 'https://d6fm3yzmawlcs.cloudfront.net/ogImages/Rodeo-1920x1080.jpg',
      meta_default_type: 'website',
      meta_events_entries_page_description:
        'Watch & stream live rodeo competitions on FloRodeo.com. Rodeo events, videos, news, & articles. Youth & professional rodeo coverage.',
      meta_events_entries_page_title: 'Rodeo Lineup | Rodeo Events & Schedules',
      meta_events_entries_page_type: 'events',
      meta_events_news_page_description:
        'Watch & stream live rodeo competitions on FloRodeo.com. Rodeo events, videos, news, & articles. Youth & professional rodeo coverage.',
      meta_events_news_page_title: 'Rodeo News | Events, Videos & Highlights',
      meta_events_news_page_type: 'event',
      meta_events_page_description:
        'Watch & stream live rodeo competitions on FloRodeo.com. Rodeo events, videos, news, & articles. Youth & professional rodeo coverage.',
      meta_events_page_title: 'Rodeo Events | Videos & Highlights',
      meta_events_page_type: 'event',
      meta_events_photo_page_type: 'event',
      meta_events_photos_page_description:
        'Watch & stream live rodeo competitions on FloRodeo.com. Rodeo events, videos, news, & articles. Youth & professional rodeo coverage.',
      meta_events_photos_page_title: 'Rodeo Events | Photos & Highlights',
      meta_events_schedule_page_description:
        'Watch & stream live rodeo competitions on FloRodeo.com. Rodeo events, videos, news, & articles. Youth & professional rodeo coverage.',
      meta_events_schedule_page_title: 'Rodeo Events | Schedule & Videos',
      meta_events_schedule_page_type: 'event',
      meta_events_videos_page_description:
        'Watch & stream live rodeo competitions on FloRodeo.com. Rodeo events, videos, news, & articles. Youth & professional rodeo coverage.',
      meta_events_videos_page_title: 'Rodeo Events | Videos & Highlights',
      meta_events_videos_page_type: 'event',
      meta_films_page_description: 'Watch Films and Documentaries',
      meta_films_page_title: 'Films and Documentaries',
      meta_home_page_description:
        'Rodeo events, videos, news, & articles. Watch & stream live rodeo competitions on FloRodeo.com. Youth & professional rodeo coverage.',
      meta_home_page_title: 'Rodeo News | Events, Videos & Highlights',
      meta_login_page_description:
        'Rodeo events, videos, news, & articles. Watch & stream live rodeo competitions on FloRodeo.com. Youth & professional rodeo coverage.',
      meta_login_page_title: 'Rodeo News | Rodeo Events & Videos',
      meta_not_found_page_description: 'Page not found for whatever reason!',
      meta_not_found_page_title: 'Page not found',
      meta_pay_page_description:
        'Rodeo events, videos, news, & articles. Watch & stream live rodeo competitions on FloRodeo.com. Youth & professional rodeo coverage.',
      meta_pay_page_title: 'Rodeo News | Rodeo Events & Videos - Join Today',
      meta_ranking_page_description:
        'Watch & stream live rodeo competitions on FloRodeo.com. Rodeo events, videos, news, & articles. Youth & professional rodeo coverage.',
      meta_ranking_page_title: 'Rodeo News | Rodeo Rankings & Highlights',
      meta_ranking_page_type: 'rankings',
      meta_result_page_description:
        'Watch & stream live rodeo competitions on FloRodeo.com. Rodeo events, videos, news, & articles. Youth & professional rodeo coverage.',
      meta_result_page_title: 'Rodeo Results | Rodeo News & Highlights',
      meta_search_page_description:
        'Rodeo events, videos, news, & articles. Watch & stream live rodeo competitions on FloRodeo.com. Youth & professional rodeo coverage.',
      meta_search_page_title: 'Rodeo News | Events, Videos & Highlights',
      meta_signup_page_description:
        'Rodeo events, videos, news, & articles. Watch & stream live rodeo competitions on FloRodeo.com. Youth & professional rodeo coverage.',
      meta_signup_page_title: 'Rodeo News | Rodeo Events & Videos - Join Today',
      meta_sport_name: 'Rodeo',
      meta_training_page_description: 'Watch training and technique videos',
      meta_training_page_title: 'Training and Technique Videos',
      meta_twitter_card_type: 'summary_large_image',
      meta_videos_page_description:
        'Rodeo videos, events, news, & articles. Watch & stream live rodeo competitions on FloRodeo.com. Youth & professional rodeo coverage.',
      meta_videos_page_page_type: 'video.other',
      meta_videos_page_title: 'Rodeo Videos | Rodeo Events & Highlights',
      ooyala_master_ad_set: '791b18ea9ebe4c99ae39bfa16d6022de',
      ooyala_player_id: 'e0798993365348c58b8e71befc2860e6',
      primary_color: '#FF140F',
      privacy_url: 'https://www.flosports.tv/privacy/',
      segment_api_key: 'Y1WqadD7D8GVFqXnpNmfIg5shlo3m1Ke',
      site_id: 30,
      site_name: 'FloRodeo',
      sport_name: 'Rodeo',
      tos_url: 'https://www.flosports.tv/terms-of-service/',
      training_videos_name: 'Training',
      twitter_page_url: 'https://twitter.com/FloRodeo',
      youtube_page_url: 'https://www.youtube.com/channel/UCbcJDshcWmYzvYofmqFOT8Q',
      gift_url: '/gift'
    }
  ],
  [
    SiteCode.Racing,
    {
      api_url: 'https://api.floracing.com',
      california_privacy_url: 'https://www.flosports.tv/california-privacy-policy/',
      careers_url: 'https://www.flosports.tv/work-with-us',
      contact_url: 'https://support.flosports.tv/',
      core_site_url: 'https://www.floracing.com',
      facebook_app_id: '1872171863058252',
      facebook_page_url: 'https://www.facebook.com/FloRacing.tv',
      faq_url: 'https://support.flosports.tv/',
      favicon_url: 'https://d6fm3yzmawlcs.cloudfront.net/favicons/new-favicon/',
      flosports_url: 'https://www.flosports.tv/',
      google_client_id: '658742238972-2l7tr5jhuo1is7cn7vhkqot1ep7u571t.apps.googleusercontent.com',
      instagram_page_url: 'https://www.instagram.com/floracing',
      meta_articles_page_description:
        'Racing news, events, videos, & articles. Watch & stream live racing competitions on FloRacing.com. Professional Dirt Track & Oval Racing coverage.',
      meta_articles_page_title: 'Racing News | Videos, Highlights & Articles',
      meta_articles_page_type: 'article',
      meta_default_image: 'https://d2779tscntxxsw.cloudfront.net/Racing-Logo-Overlay.png',
      meta_default_type: 'website',
      meta_events_entries_page_description:
        'Watch & stream live racing competitions on FloRacing.com. Racing events, videos, news, & articles. Professional Dirt Track & Oval Racing coverage.',
      meta_events_entries_page_title: 'Racing Events | Racing Entries & Schedules',
      meta_events_entries_page_type: 'events',
      meta_events_news_page_description:
        'Watch & stream live racing competitions on FloRacing.com. Racing events, videos, news, & articles. Professional Dirt Track & Oval Racing coverage.',
      meta_events_news_page_title: 'Racing Events | Videos, Highlights & Articles',
      meta_events_news_page_type: 'event',
      meta_events_page_description:
        'Watch & stream live racing competitions on FloRacing.com. Racing events, videos, news, & articles. Professional Dirt Track & Oval Racing coverage.',
      meta_events_page_title: 'Racing Events | Videos & Highlights',
      meta_events_page_type: 'event',
      meta_events_photo_page_type: 'event',
      meta_events_photos_page_description:
        'Watch & stream live racing competitions on FloRacing.com. Racing events, videos, news, & articles. Professional Dirt Track & Oval Racing coverage.',
      meta_events_photos_page_title: 'Racing Events | Photos & Highlights',
      meta_events_schedule_page_description:
        'Watch & stream live racing competitions on FloRacing.com. Racing events, videos, news, & articles. Professional Dirt Track & Oval Racing coverage.',
      meta_events_schedule_page_title: 'Racing Events | Schedule & Videos',
      meta_events_schedule_page_type: 'event',
      meta_events_videos_page_description:
        'Watch & stream live racing competitions on FloRacing.com. Racing events, videos, news, & articles. Professional Dirt Track & Oval Racing coverage.',
      meta_events_videos_page_title: 'Racing Events | Videos & Highlights',
      meta_events_videos_page_type: 'event',
      meta_films_page_description: 'Watch Films and Documentaries',
      meta_films_page_title: 'Films and Documentaries',
      meta_home_page_description:
        'Racing events, videos, news, & articles. Watch & stream live racing competitions on FloRacing.com. Professional Dirt Track & Oval Racing coverage.',
      meta_home_page_title: 'Racing | News, Videos & Articles',
      meta_login_page_description:
        'Racing events, videos, news, & articles. Watch & stream live racing competitions on FloRacing.com. Professional Dirt Track & Oval Racing coverage.',
      meta_login_page_title: 'Racing News | Racing Events & Videos',
      meta_not_found_page_description: 'Page not found for whatever reason!',
      meta_not_found_page_title: 'Page not found',
      meta_pay_page_description:
        'Racing events, videos, news, & articles. Watch & stream live racing competitions on FloRacing.com. Professional Dirt Track & Oval Racing coverage.',
      meta_pay_page_title: 'Racing News | Racing Events & Videos - Join Today',
      meta_ranking_page_description:
        'Watch & stream live racing competitions on FloRacing.com. Racing events, videos, news, & articles. Professional Dirt Track & Oval Racing coverage.',
      meta_ranking_page_title: 'Racing News | Racing Rankings & Highlights',
      meta_ranking_page_type: 'rankings',
      meta_result_page_description:
        'Watch & stream live racing competitions on FloRacing.com. Racing events, videos, news, & articles. Professional Dirt Track & Oval Racing coverage.',
      meta_result_page_title: 'Racing Results | Racing News & Highlights',
      meta_search_page_description:
        'Racing events, videos, news, & articles. Watch & stream live racing competitions on FloRacing.com. Professional Dirt Track & Oval Racing coverage.',
      meta_search_page_title: 'Racing | News, Videos & Articles',
      meta_signup_page_description:
        'Racing events, videos, news, & articles. Watch & stream live racing competitions on FloRacing.com. Professional Dirt Track & Oval Racing coverage.',
      meta_signup_page_title: 'Racing News | Racing Events & Videos - Join Today',
      meta_sport_name: 'Dirt Track & Oval Racing',
      meta_training_page_description: 'Watch training and technique videos',
      meta_training_page_title: 'Training and Technique Videos',
      meta_twitter_card_type: 'summary_large_image',
      meta_videos_page_description:
        'Racing videos, events, news, & articles. Watch & stream live racing competitions on FloRacing.com. Professional Dirt Track & Oval Racing coverage.',
      meta_videos_page_page_type: 'video.other',
      meta_videos_page_title: 'Racing Videos | Racing Events & Highlights',
      ooyala_master_ad_set: '68b3990482da4b6fb38e89eeca30b3ef',
      ooyala_player_id: 'e0798993365348c58b8e71befc2860e6',
      primary_color: '#FF140F',
      privacy_url: 'https://www.flosports.tv/privacy/',
      segment_api_key: 'uWqXXIN8MmtLebPADhtTCFE21tZPeb7L',
      site_id: 32,
      site_name: 'FloRacing',
      sport_name: 'Racing',
      tos_url: 'https://www.flosports.tv/terms-of-service/',
      training_videos_name: 'Training',
      twitter_page_url: 'https://twitter.com/FloRacing',
      youtube_page_url: 'https://www.youtube.com/channel/UCsBpaO5MA7_eXMabkdzT8ZA',
      gift_url: '/gift'
    }
  ],
  [
    SiteCode.Voice,
    {
      api_url: 'https://api.flovoice.com',
      california_privacy_url: 'https://www.flosports.tv/california-privacy-policy/',
      careers_url: 'https://www.flosports.tv/work-with-us',
      contact_url: 'https://support.flosports.tv/',
      core_site_url: 'https://www.flovoice.com',
      facebook_app_id: '261304260989990',
      facebook_page_url: 'https://www.facebook.com/flovoice.tv',
      faq_url: 'https://support.flosports.tv/',
      favicon_url: 'https://d6fm3yzmawlcs.cloudfront.net/favicons/new-favicon/',
      flosports_url: 'https://www.flosports.tv/',
      google_client_id: '738778853945-c13l5ia1s92t070oqap9a65e8lj9prkt.apps.googleusercontent.com',
      instagram_page_url: 'https://www.instagram.com/flovoice/',
      meta_articles_page_description:
        'Singing events, videos, news, & articles. Watch & stream live singing competitions on FloVoice.com. A cappella & show choir coverage.',
      meta_articles_page_title: 'Singing News | Videos, Highlights & Articles - FloVoice.com',
      meta_articles_page_type: 'article',
      meta_default_image: 'https://d6fm3yzmawlcs.cloudfront.net/ogImages/Voice-1920x1080.jpg',
      meta_default_type: 'website',
      meta_events_entries_page_description:
        'Watch & stream live singing competitions on FloVoice.com. Singing events, videos, news, & articles. A cappella & show choir coverage.',
      meta_events_entries_page_title: 'Singing Competitions | Singing Entries & Schedules - FloVoice.com',
      meta_events_entries_page_type: 'events',
      meta_events_news_page_description:
        'Watch & stream live singing competitions on FloVoice.com. Singing events, videos, news, & articles. A cappella & show choir coverage.',
      meta_events_news_page_title: 'Singing Competitions | Videos, Highlights & Articles - FloVoice.com',
      meta_events_news_page_type: 'event',
      meta_events_page_description:
        'Watch & stream live singing competitions on FloVoice.com. Singing events, videos, news, & articles. A cappella & show choir coverage.',
      meta_events_page_title: 'Singing Competitions | Videos & Highlights - FloVoice.com',
      meta_events_page_type: 'event',
      meta_events_photo_page_type: 'event',
      meta_events_photos_page_description:
        'Watch & stream live singing competitions on FloVoice.com. Singing events, videos, news, & articles. A cappella & show choir coverage.',
      meta_events_photos_page_title: 'Singing Competitions | Photos & Highlights - FloVoice.com',
      meta_events_schedule_page_description:
        'Watch & stream live singing competitions on FloVoice.com. Singing events, videos, news, & articles. A cappella & show choir coverage.',
      meta_events_schedule_page_title: 'Singing Competitions | Schedule & Videos - FloVoice.com',
      meta_events_schedule_page_type: 'event',
      meta_events_videos_page_description:
        'Watch & stream live singing competitions on FloVoice.com. Singing events, videos, news, & articles. A cappella & show choir coverage.',
      meta_events_videos_page_title: 'Singing Competitions | Videos & Highlights - FloVoice.com',
      meta_events_videos_page_type: 'event',
      meta_films_page_description: 'Watch Films and Documentaries',
      meta_films_page_title: 'Films and Documentaries',
      meta_home_page_description:
        'Singing events, videos, news, & articles. Watch & stream live singing competitions on FloVoice.com. A cappella & show choir coverage.',
      meta_home_page_title: 'Live Singing Events | News, Videos & Articles - FloVoice.com',
      meta_login_page_description:
        'Singing events, videos, news, & articles. Watch & stream live singing competitions on FloVoice.com. A cappella & show choir coverage.',
      meta_login_page_title: 'Singing News | Singing Competitions & Videos - FloVoice.com',
      meta_not_found_page_description: 'Page not found for whatever reason!',
      meta_not_found_page_title: 'Page not found',
      meta_pay_page_description:
        'Singing events, videos, news, & articles. Watch & stream live singing competitions on FloVoice.com. A cappella & show choir coverage.',
      meta_pay_page_title: 'Singing News | Singing Competitions & Videos - Join FloVoice.com',
      meta_ranking_page_description:
        'Watch & stream live singing competitions on FloVoice.com. Singing events, videos, news, & articles. A cappella & show choir coverage.',
      meta_ranking_page_title: 'Singing News | Singing Rankings & Highlights - FloVoice.com',
      meta_ranking_page_type: 'rankings',
      meta_result_page_description:
        'Watch & stream live singing competitions on FloVoice.com. Singing events, videos, news, & articles. A cappella & show choir coverage.',
      meta_result_page_title: 'Singing Scores | Singing News & Results - FloVoice.com',
      meta_search_page_description:
        'Singing events, videos, news, & articles. Watch & stream live singing competitions on FloVoice.com. A cappella & show choir coverage.',
      meta_search_page_title: 'Singing | News, Videos & Articles - FloVoice.com',
      meta_signup_page_description:
        'Singing events, videos, news, & articles. Watch & stream live singing competitions on FloVoice.com. A cappella & show choir coverage.',
      meta_signup_page_title: 'Singing News | Singing Competitions & Videos - Join FloVoice.com',
      meta_sport_name: 'A Cappella & Show Choir',
      meta_training_page_description: 'Watch training and technique videos',
      meta_training_page_title: 'Training and Technique Videos',
      meta_twitter_card_type: 'summary_large_image',
      meta_videos_page_description:
        'Watch & stream live singing competitions on FloVoice.com. Singing events, videos, news, & articles. A cappella & show choir coverage.',
      meta_videos_page_page_type: 'video.other',
      meta_videos_page_title: 'Singing Videos | Singing Competitions & Highlights - FloVoice.com',
      ooyala_master_ad_set: 'b3ee0a5f54cf4ada94896f3307ee87b1',
      ooyala_player_id: 'e0798993365348c58b8e71befc2860e6',
      primary_color: '#FF140F',
      privacy_url: 'https://www.flosports.tv/privacy/',
      segment_api_key: 'Z9gT3DnQ0q111aV55Bulj1wzoEtQL0KD',
      site_id: 33,
      site_name: 'FloVoice',
      sport_name: 'Singing',
      tos_url: 'https://www.flosports.tv/terms-of-service/',
      training_videos_name: 'Training',
      twitter_page_url: 'https://twitter.com/FloVoice',
      youtube_page_url: 'https://www.youtube.com/channel/UCngVN3LC9pNOOvjSq9X-lDQ',
      gift_url: '/gift'
    }
  ],
  [
    SiteCode.Rugby,
    {
      api_url: 'https://api.florugby.com',
      california_privacy_url: 'https://www.flosports.tv/california-privacy-policy/',
      careers_url: 'https://www.flosports.tv/work-with-us',
      contact_url: 'https://support.flosports.tv/',
      core_site_url: 'https://www.florugby.com',
      facebook_app_id: '316042732132190',
      facebook_page_url: 'https://www.facebook.com/FloRugby',
      faq_url: 'https://support.flosports.tv/',
      favicon_url: 'https://d6fm3yzmawlcs.cloudfront.net/favicons/new-favicon/',
      flosports_url: 'https://www.flosports.tv/',
      google_client_id: '960255671857-31o6rnuo72q9ngjr4vct8ek64lrivfvr.apps.googleusercontent.com',
      instagram_page_url: 'https://www.instagram.com/florugby',
      meta_articles_page_description:
        'Rugby news, videos, games, & articles. Watch & stream live rugby matches on FloRugby.com. Youth & professional rugby coverage.',
      meta_articles_page_title: 'Rugby News | Games, Videos & Highlights',
      meta_articles_page_type: 'article',
      meta_default_image: 'https://d6fm3yzmawlcs.cloudfront.net/ogImages/Rugby-1920x1080.jpg',
      meta_default_type: 'website',
      meta_events_entries_page_description:
        'Watch & stream live rugby matches on FloRugby.com.  Rugby games, videos, news, & articles. Youth & professional rugby coverage.',
      meta_events_entries_page_title: 'Rugby Lineup | Rugby Games & Schedules',
      meta_events_entries_page_type: 'events',
      meta_events_news_page_description:
        'Watch & stream live rugby matches on FloRugby.com.  Rugby games, videos, news, & articles. Youth & professional rugby coverage.',
      meta_events_news_page_title: 'Rugby News | Games, Videos & Highlights',
      meta_events_news_page_type: 'event',
      meta_events_page_description:
        'Watch & stream live rugby matches on FloRugby.com.  Rugby games, videos, news, & articles. Youth & professional rugby coverage.',
      meta_events_page_title: 'Rugby Games | Videos & Highlights',
      meta_events_page_type: 'event',
      meta_events_photo_page_type: 'event',
      meta_events_photos_page_description:
        'Watch & stream live rugby matches on FloRugby.com.  Rugby games, videos, news, & articles. Youth & professional rugby coverage.',
      meta_events_photos_page_title: 'Rugby Games | Photos & Highlights',
      meta_events_schedule_page_description:
        'Watch & stream live rugby matches on FloRugby.com.  Rugby games, videos, news, & articles. Youth & professional rugby coverage.',
      meta_events_schedule_page_title: 'Rugby Games | Schedule & Videos',
      meta_events_schedule_page_type: 'event',
      meta_events_videos_page_description:
        'Watch & stream live rugby matches on FloRugby.com.  Rugby games, videos, news, & articles. Youth & professional rugby coverage.',
      meta_events_videos_page_title: 'Rugby Games | Videos & Highlights',
      meta_events_videos_page_type: 'event',
      meta_films_page_description: 'Watch Films and Documentaries',
      meta_films_page_title: 'Films and Documentaries',
      meta_home_page_description:
        'Rugby games, videos, news, & articles. Watch & stream live rugby matches on FloRugby.com. Youth & professional rugby coverage.',
      meta_home_page_title: 'Rugby News | Games, Videos & Highlights',
      meta_login_page_description:
        'Rugby games, videos, news, & articles. Watch & stream live rugby matches on FloRugby.com. Youth & professional rugby coverage.',
      meta_login_page_title: 'Rugby News | Rugby Games & Videos',
      meta_not_found_page_description: 'Page not found for whatever reason!',
      meta_not_found_page_title: 'Page not found',
      meta_pay_page_description:
        'Rugby games, videos, news, & articles. Watch & stream live rugby matches on FloRugby.com. Youth & professional rugby coverage.',
      meta_pay_page_title: 'Rugby News | Rugby Games & Videos - Join Today',
      meta_ranking_page_description:
        'Watch & stream live rugby matches on FloRugby.com.  Rugby games, videos, news, & articles. Youth & professional rugby coverage.',
      meta_ranking_page_title: 'Rugby News | Rugby Rankings & Highlights',
      meta_ranking_page_type: 'rankings',
      meta_result_page_description:
        'Watch & stream live rugby matches on FloRugby.com.  Rugby games, videos, news, & articles. Youth & professional rugby coverage.',
      meta_result_page_title: 'Rugby Results | Rugby News & Highlights',
      meta_search_page_description:
        'Rugby games, videos, news, & articles. Watch & stream live rugby matches on FloRugby.com. Youth & professional rugby coverage.',
      meta_search_page_title: 'Rugby News | Games, Videos & Highlights',
      meta_signup_page_description:
        'Rugby games, videos, news, & articles. Watch & stream live rugby matches on FloRugby.com. Youth & professional rugby coverage.',
      meta_signup_page_title: 'Rugby News | Rugby Games & Videos - Join Today',
      meta_sport_name: 'Rugby',
      meta_training_page_description: 'Watch training and technique videos',
      meta_training_page_title: 'Training and Technique Videos',
      meta_twitter_card_type: 'summary_large_image',
      meta_videos_page_description:
        'Rugby videos, games, news, & articles. Watch & stream live rugby matches on FloRugby.com. Youth & professional rugby coverage.',
      meta_videos_page_page_type: 'video.other',
      meta_videos_page_title: 'Rugby News | Rugby Games & Videos',
      ooyala_master_ad_set: 'f63205c01453478f90156600c58bc751',
      ooyala_player_id: 'e0798993365348c58b8e71befc2860e6',
      primary_color: '#FF140F',
      privacy_url: 'https://www.flosports.tv/privacy/',
      segment_api_key: 'IFdAPs3ucdn722kb6zfskG451OvFckxn',
      site_id: 34,
      site_name: 'FloRugby',
      sport_name: 'Rugby',
      tos_url: 'https://www.flosports.tv/terms-of-service/',
      training_videos_name: 'Training',
      twitter_page_url: 'https://twitter.com/florugby',
      youtube_page_url: 'https://www.youtube.com/channel/UC3Mj0nm-7grOYZuqgo-LhmQ',
      gift_url: '/gift'
    }
  ],
  [
    SiteCode.Live,
    {
      api_url: 'https://api.flolive.tv',
      california_privacy_url: 'https://www.flosports.tv/california-privacy-policy/',
      careers_url: 'https://www.flosports.tv/work-with-us',
      contact_url: 'https://support.flosports.tv/',
      core_site_url: 'https://www.flolive.tv',
      facebook_app_id: '218535058622175',
      facebook_page_url: 'https://www.facebook.com/FloLive-922028627936618/',
      faq_url: 'https://support.flosports.tv/',
      favicon_url: 'https://d6fm3yzmawlcs.cloudfront.net/favicons/new-favicon/',
      flosports_url: 'https://www.flosports.tv/',
      google_client_id: '607351419127-ku9d4np6vlgaimpen6a2faq3i55ccfvh.apps.googleusercontent.com',
      instagram_page_url: 'https://www.instagram.com/flolive',
      meta_articles_page_description:
        'Sports articles, events, videos, & news. Watch & stream live sport games on Flolive.tv. Youth, college, & professional sporting event & news coverage.',
      meta_articles_page_title: 'Live Sports News | Live Sports Articles',
      meta_articles_page_type: 'article',
      meta_default_image: 'https://d6fm3yzmawlcs.cloudfront.net/ogImages/FloLive-1920x1080.jpg',
      meta_default_type: 'website',
      meta_events_entries_page_description:
        'Watch & stream live sport games on Flolive.tv Sports events, videos, news, & articles. Youth, college, & professional sporting event & news coverage.',
      meta_events_entries_page_title: 'Live Sports Games | Live Sports Roster',
      meta_events_entries_page_type: 'events',
      meta_events_news_page_description:
        'Watch & stream live sport games on Flolive.tv Sports events, videos, news, & articles. Youth, college, & professional sporting event & news coverage.',
      meta_events_news_page_title: 'Live Sports News | Live Sports Articles',
      meta_events_news_page_type: 'event',
      meta_events_page_description:
        'Watch & stream live sport games on Flolive.tv Sports events, videos, news, & articles. Youth, college, & professional sporting event & news coverage.',
      meta_events_page_title: 'Live Sports Games | Live Sports Live Games',
      meta_events_page_type: 'event',
      meta_events_photo_page_type: 'event',
      meta_events_photos_page_description:
        'Watch & stream live sport games on Flolive.tv Sports events, videos, news, & articles. Youth, college, & professional sporting event & news coverage.',
      meta_events_photos_page_title: 'Live Sports Games | Live Sports Game Photos',
      meta_events_schedule_page_description:
        'Watch & stream live sport games on Flolive.tv Sports events, videos, news, & articles. Youth, college, & professional sporting event & news coverage.',
      meta_events_schedule_page_title: 'Live Sports Schedule | Live Sports Game Times',
      meta_events_schedule_page_type: 'event',
      meta_events_videos_page_description:
        'Watch & stream live sport games on Flolive.tv Sports events, videos, news, & articles. Youth, college, & professional sporting event & news coverage.',
      meta_events_videos_page_title: 'Live Sports Videos | Live Sports Highlights & Games',
      meta_events_videos_page_type: 'event',
      meta_films_page_description: 'Watch Films and Documentaries',
      meta_films_page_title: 'Films and Documentaries',
      meta_home_page_description:
        'Sports events, videos, news, & articles. Watch & stream live sport games on Flolive.tv. Youth, college, & professional sporting event & news coverage.',
      meta_home_page_title: 'Live Sports | Games, News, & Articles',
      meta_login_page_description:
        'Sports events, videos, news, & articles. Watch & stream live sport games on Flolive.tv. Youth, college, & professional sporting event & news coverage.',
      meta_login_page_title: 'Live Sports | Stream Games, News, & Articles - Join Today',
      meta_not_found_page_description: 'Page not found for whatever reason!',
      meta_not_found_page_title: 'Page not found',
      meta_pay_page_description:
        'Sports events, videos, news, & articles. Watch & stream live sport games on Flolive.tv. Youth, college, & professional sporting event & news coverage.',
      meta_pay_page_title: 'Live Sports | Stream Games, News, & Articles - Join Today',
      meta_ranking_page_description:
        'Watch & stream live sport games on Flolive.tv Sports events, videos, news, & articles. Youth, college, & professional sporting event & news coverage.',
      meta_ranking_page_title: 'Live Sports | Rankings & Live Sports',
      meta_ranking_page_type: 'rankings',
      meta_result_page_description:
        'Watch & stream live sport games on Flolive.tv Sports events, videos, news, & articles. Youth, college, & professional sporting event & news coverage.',
      meta_result_page_title: 'Live Sports Scores | Live Sports Results & Games',
      meta_search_page_description:
        'Sports events, videos, news, & articles. Watch & stream live sport games on Flolive.tv. Youth, college, & professional sporting event & news coverage.',
      meta_search_page_title: 'Live Sports | Games, News, & Articles',
      meta_signup_page_description:
        'Sports events, videos, news, & articles. Watch & stream live sport games on Flolive.tv. Youth, college, & professional sporting event & news coverage.',
      meta_signup_page_title: 'Live Sports | Stream Games, News, & Articles - Join Today',
      meta_sport_name: 'Live Sports',
      meta_training_page_description: 'Watch training and technique videos',
      meta_training_page_title: 'Training and Technique Videos',
      meta_twitter_card_type: 'summary_large_image',
      meta_videos_page_description:
        'Sports videos, events, news, & articles. Watch & stream live sport games on Flolive.tv. Youth, college, & professional sporting event & news coverage.',
      meta_videos_page_page_type: 'video.other',
      meta_videos_page_title: 'Live Sports Videos | Games & Highlights',
      ooyala_master_ad_set: null,
      ooyala_player_id: 'e0798993365348c58b8e71befc2860e6',
      primary_color: '#FF140F',
      privacy_url: 'https://www.flosports.tv/privacy/',
      segment_api_key: 'RQLEmD486RUQxbWGZZh3f5XWXefwgRVO',
      site_id: 35,
      site_name: 'FloLive',
      sport_name: null,
      tos_url: 'https://www.flosports.tv/terms-of-service/',
      training_videos_name: 'Training',
      twitter_page_url: 'https://twitter.com/flolive',
      youtube_page_url: 'https://www.youtube.com/flolive',
      gift_url: '/gift'
    }
  ],
  [
    SiteCode.Dance,
    {
      api_url: 'https://api.flodance.com',
      california_privacy_url: 'https://www.flosports.tv/california-privacy-policy/',
      careers_url: 'https://www.flosports.tv/work-with-us',
      contact_url: 'https://support.flosports.tv/',
      core_site_url: 'https://www.flodance.com',
      facebook_app_id: '1658254970856815',
      facebook_page_url: 'https://www.facebook.com/FloDance.tv',
      faq_url: 'https://support.flosports.tv/',
      favicon_url: 'https://d6fm3yzmawlcs.cloudfront.net/favicons/new-favicon/',
      flosports_url: 'https://www.flosports.tv/',
      google_client_id: '994780048765-1a6urjdeoilaf9fu5m3ig1panuv1253f.apps.googleusercontent.com',
      instagram_page_url: 'https://www.instagram.com/flodance/',
      meta_articles_page_description:
        'Dance articles, videos, news, & competitions. Watch & stream live dance events. Ballroom, Country Western, & Contemporary dance style coverage.',
      meta_articles_page_title: 'Dance | Videos, News & Articles',
      meta_articles_page_type: 'article',
      meta_default_image: 'https://d6fm3yzmawlcs.cloudfront.net/ogImages/Dance-1920x1080.jpg',
      meta_default_type: 'website',
      meta_events_entries_page_description:
        'Watch & stream live dance events. Dance competitions, videos, news, & articles. Ballroom, Country Western, & Contemporary dance style coverage.',
      meta_events_entries_page_title: 'Dance Competitions | Entries & Videos',
      meta_events_entries_page_type: 'events',
      meta_events_news_page_description:
        'Watch & stream live dance events. Dance competitions, videos, news, & articles. Ballroom, Country Western, & Contemporary dance style coverage.',
      meta_events_news_page_title: 'Dance Competitions | Videos & Events',
      meta_events_news_page_type: 'event',
      meta_events_page_description:
        'Watch & stream live dance events. Dance competitions, videos, news, & articles. Ballroom, Country Western, & Contemporary dance style coverage.',
      meta_events_page_title: 'Dance Competitions | Videos & Events',
      meta_events_page_type: 'event',
      meta_events_photo_page_type: 'event',
      meta_events_photos_page_description:
        'Watch & stream live dance events. Dance competitions, videos, news, & articles. Ballroom, Country Western, & Contemporary dance style coverage.',
      meta_events_photos_page_title: 'Dance Competitions | Dance Event Photos',
      meta_events_schedule_page_description:
        'Watch & stream live dance events. Dance competitions, videos, news, & articles. Ballroom, Country Western, & Contemporary dance style coverage.',
      meta_events_schedule_page_title: 'Dance Competitions | Schedule & Videos',
      meta_events_schedule_page_type: 'event',
      meta_events_videos_page_description:
        'Watch & stream live dance events. Dance competitions, videos, news, & articles. Ballroom, Country Western, & Contemporary dance style coverage.',
      meta_events_videos_page_title: 'Dance Competitions | Videos & Events',
      meta_events_videos_page_type: 'event',
      meta_films_page_description: 'Watch Films and Documentaries',
      meta_films_page_title: 'Films and Documentaries',
      meta_home_page_description:
        'Dance competitions, videos, news, & articles. Watch & stream live dance events. Ballroom, Country Western, & Contemporary dance style coverage.',
      meta_home_page_title: 'Dance | Videos, News & Articles',
      meta_login_page_description:
        'Dance competitions, videos, news, & articles. Watch & stream live dance events. Ballroom, Country Western, & Contemporary dance style coverage.',
      meta_login_page_title: 'Dance Competitions | Videos, Events, & News',
      meta_not_found_page_description: 'Page not found for whatever reason!',
      meta_not_found_page_title: 'Page not found',
      meta_pay_page_description:
        'Dance competitions, videos, news, & articles. Watch & stream live dance events. Ballroom, Country Western, & Contemporary dance style coverage.',
      meta_pay_page_title: 'Dance Competitions | Videos, Events, & News - Join Today',
      meta_ranking_page_description:
        'Watch & stream live dance events. Dance competitions, videos, news, & articles. Ballroom, Country Western, & Contemporary dance style coverage.',
      meta_ranking_page_title: 'Dance Competitions | Rankings & Videos',
      meta_ranking_page_type: 'rankings',
      meta_result_page_description:
        'Watch & stream live dance events. Dance competitions, videos, news, & articles. Ballroom, Country Western, & Contemporary dance style coverage.',
      meta_result_page_title: 'Dance Competitions | Results & Videos',
      meta_search_page_description:
        'Dance competitions, videos, news, & articles. Watch & stream live dance events. Ballroom, Country Western, & Contemporary dance style coverage.',
      meta_search_page_title: 'Dance | Videos, News & Articles',
      meta_signup_page_description:
        'Dance competitions, videos, news, & articles. Watch & stream live dance events. Ballroom, Country Western, & Contemporary dance style coverage.',
      meta_signup_page_title: 'Dance Competitions | Videos, Events, & News - Join Today',
      meta_sport_name: 'Dance',
      meta_training_page_description: 'Watch training and technique videos',
      meta_training_page_title: 'Training and Technique Videos',
      meta_twitter_card_type: 'summary_large_image',
      meta_videos_page_description:
        'Dance videos, competitions, news, & articles. Watch & stream live dance events. Ballroom, Country Western, & Contemporary dance style coverage.',
      meta_videos_page_page_type: 'video.other',
      meta_videos_page_title: 'Dance Videos | Events & Highlights',
      ooyala_master_ad_set: '65752e4e3c8946ad86e1fdb5e35453af',
      ooyala_player_id: '4a0f369b8cb14fcd97f73bb690b9f352',
      primary_color: '#FF140F',
      privacy_url: 'https://www.flosports.tv/privacy/',
      segment_api_key: '4hJnZanwxAnVCo3YxLuYkQhudaBQHREW',
      site_id: 36,
      site_name: 'FloDance',
      sport_name: 'Dance',
      tos_url: 'https://www.flosports.tv/terms-of-service/',
      training_videos_name: 'Training',
      twitter_page_url: 'https://twitter.com/FloDance',
      youtube_page_url: 'https://www.youtube.com/channel/UCj8-BAD2gi7Cn4ZuAns8QJg',
      gift_url: '/gift'
    }
  ],
  [
    SiteCode.Bikes,
    {
      api_url: 'https://api.flobikes.com',
      california_privacy_url: 'https://www.flosports.tv/california-privacy-policy/',
      careers_url: 'https://www.flosports.tv/work-with-us',
      contact_url: 'https://support.flosports.tv/',
      core_site_url: 'https://www.flobikes.com',
      facebook_app_id: '457332847942059',
      facebook_page_url: 'https://www.facebook.com/flobikes',
      faq_url: 'https://support.flosports.tv/',
      favicon_url: 'https://d6fm3yzmawlcs.cloudfront.net/favicons/new-favicon/',
      flosports_url: 'https://www.flosports.tv/',
      google_client_id: '197576172139-l75drjj1m3njc8p1q2tnr6r1lnl04usq.apps.googleusercontent.com',
      instagram_page_url: 'https://www.instagram.com/flobikes/',
      meta_articles_page_description:
        'Cycling articles, competitions, news, & videos. Watch & stream live cycling events. Professional Road Cycling event & news coverage.',
      meta_articles_page_title: 'Cycling Articles | Cycling News',
      meta_articles_page_type: 'article',
      meta_default_image: 'https://d6fm3yzmawlcs.cloudfront.net/ogImages/Bikes-1920x1080.jpg',
      meta_default_type: 'website',
      meta_events_entries_page_description:
        'Watch & stream live cycling events. Cycling videos, competitions, news, & articles. Professional Road Cycling event & news coverage.',
      meta_events_entries_page_title: 'Cycling Events | Cycling Event Entries',
      meta_events_entries_page_type: 'events',
      meta_events_news_page_description:
        'Watch & stream live cycling events. Cycling videos, competitions, news, & articles. Professional Road Cycling event & news coverage.',
      meta_events_news_page_title: 'Cycling News | Cycling Articles',
      meta_events_news_page_type: 'event',
      meta_events_page_description:
        'Watch & stream live cycling events. Cycling videos, competitions, news, & articles. Professional Road Cycling event & news coverage.',
      meta_events_page_title: 'Cycling Events | Upcoming Cycling Events',
      meta_events_page_type: 'event',
      meta_events_photo_page_type: 'event',
      meta_events_photos_page_description:
        'Watch & stream live cycling events. Cycling videos, competitions, news, & articles. Professional Road Cycling event & news coverage.',
      meta_events_photos_page_title: 'Cycling Events | Cycling Event Photos',
      meta_events_schedule_page_description:
        'Watch & stream live cycling events. Cycling videos, competitions, news, & articles. Professional Road Cycling event & news coverage.',
      meta_events_schedule_page_title: 'Cycling Events | Cycling Event Schedules',
      meta_events_schedule_page_type: 'event',
      meta_events_videos_page_description:
        'Watch & stream live cycling events. Cycling videos, competitions, news, & articles. Professional Road Cycling event & news coverage.',
      meta_events_videos_page_title: 'Cycling Events | Cycling Event Videos',
      meta_events_videos_page_type: 'event',
      meta_films_page_description: 'Watch Films and Documentaries',
      meta_films_page_title: 'Films and Documentaries',
      meta_home_page_description:
        'Cycling competitions, videos, news, & articles. Watch & stream live cycling events. Professional Road Cycling event & news coverage.',
      meta_home_page_title: 'Cycling | Events, News, & Articles',
      meta_login_page_description:
        'Cycling competitions, videos, news, & articles. Watch & stream live cycling events. Professional Road Cycling event & news coverage.',
      meta_login_page_title: 'FloBikes Login | Access Your FloBikes Account For Exclusive Content',
      meta_not_found_page_description: 'Page not found for whatever reason!',
      meta_not_found_page_title: 'Page not found',
      meta_pay_page_description:
        'Cycling competitions, videos, news, & articles. Watch & stream live cycling events. Professional Road Cycling event & news coverage.',
      meta_pay_page_title: 'Cycling | Events, News, & Articles - Join Today',
      meta_ranking_page_description:
        'Watch & stream live cycling events. Cycling videos, competitions, news, & articles. Professional Road Cycling event & news coverage.',
      meta_ranking_page_title: 'Cycling | Rankings & Event Coverage',
      meta_ranking_page_type: 'rankings',
      meta_result_page_description:
        'Watch & stream live cycling events. Cycling videos, competitions, news, & articles. Professional Road Cycling event & news coverage.',
      meta_result_page_title: 'Cycling | Results & Event Coverage',
      meta_search_page_description:
        'Cycling competitions, videos, news, & articles. Watch & stream live cycling events. Professional Road Cycling event & news coverage.',
      meta_search_page_title: 'Cycling | Events, News, & Articles',
      meta_signup_page_description:
        'Cycling competitions, videos, news, & articles. Watch & stream live cycling events. Professional Road Cycling event & news coverage.',
      meta_signup_page_title: 'Cycling | Events, News, & Articles - Join Today',
      meta_sport_name: 'Cycling',
      meta_training_page_description: 'Watch training and technique videos',
      meta_training_page_title: 'Training and Technique Videos',
      meta_twitter_card_type: 'summary_large_image',
      meta_videos_page_description:
        'Cycling videos, competitions, news, & articles. Watch & stream live cycling events. Professional Road Cycling event & news coverage.',
      meta_videos_page_page_type: 'video.other',
      meta_videos_page_title: 'Cycling Videos | Event Videos & Recaps',
      ooyala_master_ad_set: '18363e4174ea49c4ada4303643446b30',
      ooyala_player_id: '29577def37cd40f98ae3495b4b5465fc',
      primary_color: '#FF140F',
      privacy_url: 'https://www.flosports.tv/privacy/',
      segment_api_key: 'oUA4Iah23700O39NFBjnLVTZViYdhbP3',
      site_id: 37,
      site_name: 'FloBikes',
      sport_name: 'Cycling',
      tos_url: 'https://www.flosports.tv/terms-of-service/',
      training_videos_name: 'Training',
      twitter_page_url: 'https://twitter.com/FloBikes',
      youtube_page_url: 'https://www.youtube.com/channel/UCljVdpux_uz7NydDWYEeSIA',
      gift_url: '/gift'
    }
  ],
  [
    SiteCode.Football,
    {
      api_url: 'https://api.flofootball.com',
      california_privacy_url: 'https://www.flosports.tv/california-privacy-policy/',
      careers_url: 'https://www.flosports.tv/work-with-us',
      contact_url: 'https://support.flosports.tv/',
      core_site_url: 'https://www.flofootball.com',
      facebook_app_id: '1468736733193063',
      facebook_page_url: 'https://www.facebook.com/FloFootball/',
      faq_url: 'https://support.flosports.tv/',
      favicon_url: 'https://d6fm3yzmawlcs.cloudfront.net/favicons/new-favicon/',
      flosports_url: 'http://www.flosports.tv',
      google_client_id: '562141902480-t9bkc1cgu4n7o15etb8arn0qoskkvf2t.apps.googleusercontent.com',
      instagram_page_url: 'https://www.instagram.com/flofootball',
      meta_articles_page_description:
        'Football articles, videos, news, & games. Watch & stream live Football games on FloFootball.com. High School & 7 on 7 games & news coverage.',
      meta_articles_page_title: 'Football News | Videos, Highlights & Articles',
      meta_articles_page_type: 'article',
      meta_default_image: 'https://d6fm3yzmawlcs.cloudfront.net/ogImages/Football-1920x1080.jpg',
      meta_default_type: 'website',
      meta_events_entries_page_description:
        'Watch & stream live Football games on FloFootball.com. Football games, videos, news, & articles. High School & 7 on 7 games & news coverage.',
      meta_events_entries_page_title: 'Football Games | Rosters & Live Football',
      meta_events_entries_page_type: 'events',
      meta_events_news_page_description:
        'Watch & stream live Football games on FloFootball.com. Football games, videos, news, & articles. High School & 7 on 7 games & news coverage.',
      meta_events_news_page_title: 'Football Games | Live Football & Highlights',
      meta_events_news_page_type: 'event',
      meta_events_page_description:
        'Watch & stream live Football games on FloFootball.com. Football games, videos, news, & articles. High School & 7 on 7 games & news coverage.',
      meta_events_page_title: 'Football Games | Live Football & Highlights',
      meta_events_page_type: 'event',
      meta_events_photo_page_type: 'event',
      meta_events_photos_page_description:
        'Watch & stream live Football games on FloFootball.com. Football games, videos, news, & articles. High School & 7 on 7 games & news coverage.',
      meta_events_photos_page_title: 'Football Games | Photos & Highlights',
      meta_events_schedule_page_description:
        'Watch & stream live Football games on FloFootball.com. Football games, videos, news, & articles. High School & 7 on 7 games & news coverage.',
      meta_events_schedule_page_title: 'Football Games | Schedule & Live Football',
      meta_events_schedule_page_type: 'event',
      meta_events_videos_page_description:
        'Watch & stream live Football games on FloFootball.com. Football games, videos, news, & articles. High School & 7 on 7 games & news coverage.',
      meta_events_videos_page_title: 'Football Games | Live Football & Highlights',
      meta_events_videos_page_type: 'event',
      meta_films_page_description: 'Watch Films and Documentaries',
      meta_films_page_title: 'Films and Documentaries',
      meta_home_page_description:
        'Football games, videos, news, & articles. Watch & stream live Football games on FloFootball.com. High School & 7 on 7 games & news coverage.',
      meta_home_page_title: 'Football | News, Videos & Articles',
      meta_login_page_description:
        'Football games, videos, news, & articles. Watch & stream live Football games on FloFootball.com. High School & 7 on 7 games & news coverage.',
      meta_login_page_title: 'Football Games | Live Football & Highlights',
      meta_not_found_page_description: 'Page not found for whatever reason!',
      meta_not_found_page_title: 'Page not found',
      meta_pay_page_description:
        'Football games, videos, news, & articles. Watch & stream live Football games on FloFootball.com. High School & 7 on 7 games & news coverage.',
      meta_pay_page_title: 'Football Games | Live Football & Highlights - Join Today',
      meta_ranking_page_description:
        'Watch & stream live Football games on FloFootball.com. Football games, videos, news, & articles. High School & 7 on 7 games & news coverage.',
      meta_ranking_page_title: 'Football Games | Rankings & Videos',
      meta_ranking_page_type: 'rankings',
      meta_result_page_description:
        'Watch & stream live Football games on FloFootball.com. Football games, videos, news, & articles. High School & 7 on 7 games & news coverage.',
      meta_result_page_title: 'Football Games | Results & Videos',
      meta_search_page_description:
        'Football games, videos, news, & articles. Watch & stream live Football games on FloFootball.com. High School & 7 on 7 games & news coverage.',
      meta_search_page_title: 'Football | News, Videos & Articles',
      meta_signup_page_description:
        'Football games, videos, news, & articles. Watch & stream live Football games on FloFootball.com. High School & 7 on 7 games & news coverage.',
      meta_signup_page_title: 'Football Games | Live Football & Highlights - Join FloFootball.com',
      meta_sport_name: 'High School & 7 On 7 Football',
      meta_training_page_description: 'Watch training and technique videos',
      meta_training_page_title: 'Training and Technique Videos',
      meta_twitter_card_type: 'summary_large_image',
      meta_videos_page_description:
        'Football videos, articles, news, & games. Watch & stream live Football games on FloFootball.com. High School & 7 on 7 games & news coverage.',
      meta_videos_page_page_type: 'video.other',
      meta_videos_page_title: 'Football Videos | Football Games & Highlights',
      ooyala_master_ad_set: 'f14f283277c442449cd8532e1a4462a2',
      ooyala_player_id: 'e0798993365348c58b8e71befc2860e6',
      primary_color: '#FF140F',
      privacy_url: 'https://www.flosports.tv/privacy/',
      segment_api_key: 'bb2AqVbk3gvAi0hBawnIwDn6GLIvdjCV',
      site_id: 38,
      site_name: 'FloFootball',
      sport_name: 'Football',
      tos_url: 'https://www.flosports.tv/terms-of-service/',
      training_videos_name: 'Training',
      twitter_page_url: 'https://twitter.com/FloFootball',
      youtube_page_url: 'https://www.youtube.com/channel/UCXKEH7zOL0qIJY0MT4YSZqA',
      gift_url: '/gift'
    }
  ],
  [
    SiteCode.Bowling,
    {
      api_url: 'https://api.flobowling.com',
      california_privacy_url: 'https://www.flosports.tv/california-privacy-policy/',
      careers_url: 'https://www.flosports.tv/work-with-us',
      contact_url: 'https://support.flosports.tv/',
      core_site_url: 'https://www.flobowling.com',
      facebook_app_id: '366069947247709',
      facebook_page_url: 'https://www.facebook.com/FloBowling/',
      faq_url: 'https://support.flosports.tv/',
      favicon_url: 'https://d6fm3yzmawlcs.cloudfront.net/favicons/new-favicon/',
      flosports_url: 'https://www.flosports.tv/',
      google_client_id: '346848914731-ph5hmv7e7g383q48fad4077i4s8hc6a6.apps.googleusercontent.com',
      instagram_page_url: 'https://www.instagram.com/flobowling/',
      meta_articles_page_description:
        'Bowling articles, videos, news, & games. Watch & stream live bowling games on FloBowling.com. Professional bowling tournaments & news coverage.',
      meta_articles_page_title: 'Bowling News | Videos, Highlights & Articles',
      meta_articles_page_type: 'article',
      meta_default_image: 'https://d6fm3yzmawlcs.cloudfront.net/ogImages/Bowling-1920x1080.jpg',
      meta_default_type: 'website',
      meta_events_entries_page_description:
        'Watch & stream live bowling games on FloBowling.com. Bowling games, videos, news, & articles. Professional bowling tournaments & news coverage.',
      meta_events_entries_page_title: 'Bowling Games | Rosters & Live Bowling',
      meta_events_entries_page_type: 'events',
      meta_events_news_page_description:
        'Watch & stream live bowling games on FloBowling.com. Bowling games, videos, news, & articles. Professional bowling tournaments & news coverage.',
      meta_events_news_page_title: 'Bowling Games | Live Bowling & Highlights',
      meta_events_news_page_type: 'event',
      meta_events_page_description:
        'Watch & stream live bowling games on FloBowling.com. Bowling games, videos, news, & articles. Professional bowling tournaments & news coverage.',
      meta_events_page_title: 'Bowling Games | Live Bowling & Highlights',
      meta_events_page_type: 'event',
      meta_events_photo_page_type: 'event',
      meta_events_photos_page_description:
        'Watch & stream live bowling games on FloBowling.com. Bowling games, videos, news, & articles. Professional bowling tournaments & news coverage.',
      meta_events_photos_page_title: 'Bowling Games | Photos & Highlights',
      meta_events_schedule_page_description:
        'Watch & stream live bowling games on FloBowling.com. Bowling games, videos, news, & articles. Professional bowling tournaments & news coverage.',
      meta_events_schedule_page_title: 'Bowling Games | Schedule & Live Bowling',
      meta_events_schedule_page_type: 'event',
      meta_events_videos_page_description:
        'Watch & stream live bowling games on FloBowling.com. Bowling games, videos, news, & articles. Professional bowling tournaments & news coverage.',
      meta_events_videos_page_title: 'Bowling Games | Live Bowling & Highlights',
      meta_events_videos_page_type: 'event',
      meta_films_page_description:
        'Bowling films, videos, events, news, & articles. Bowling games, videos, news, & articles. Professional bowling tournaments & news coverage.',
      meta_films_page_title: 'Bowling Films | Videos, News, & Articles',
      meta_home_page_description:
        'Bowling games, videos, news, & articles. Watch & stream live bowling games on FloBowling.com. Professional bowling tournaments & news coverage.',
      meta_home_page_title: 'Bowling | News, Videos & Articles',
      meta_login_page_description:
        'Bowling games, videos, news, & articles. Watch & stream live bowling games on FloBowling.com. Professional bowling tournaments & news coverage.',
      meta_login_page_title: 'Bowling Games | Live Bowling & Highlights',
      meta_not_found_page_description: 'Page not found for whatever reason!',
      meta_not_found_page_title: 'Page not found',
      meta_pay_page_description:
        'Bowling games, videos, news, & articles. Watch & stream live bowling games on FloBowling.com. Professional bowling tournaments & news coverage.',
      meta_pay_page_title: 'Bowling Games | Live Bowling & Highlights - Join FloBowling.com',
      meta_ranking_page_description:
        'Watch & stream live bowling games on FloBowling.com. Bowling games, videos, news, & articles. Professional bowling tournaments & news coverage.',
      meta_ranking_page_title: 'Bowling Games | Rankings & Videos',
      meta_ranking_page_type: 'rankings',
      meta_result_page_description:
        'Watch & stream live bowling games on FloBowling.com. Bowling games, videos, news, & articles. Professional bowling tournaments & news coverage.',
      meta_result_page_title: 'Bowling Games | Results & Videos',
      meta_search_page_description:
        'Bowling games, videos, news, & articles. Watch & stream live bowling games on FloBowling.com. Professional bowling tournaments & news coverage.',
      meta_search_page_title: 'Bowling | News, Videos & Articles',
      meta_signup_page_description:
        'Bowling games, videos, news, & articles. Watch & stream live bowling games on FloBowling.com. Professional bowling tournaments & news coverage.',
      meta_signup_page_title: 'Bowling Games | Live Bowling & Highlights - Join FloBowling.com',
      meta_sport_name: 'Professional Bowling',
      meta_training_page_description:
        'Bowling training videos, events, news, & articles. Bowling games, videos, news, & articles. Professional bowling tournaments & news coverage.',
      meta_training_page_title: 'Bowling Training | Videos, News, & Articles',
      meta_twitter_card_type: 'summary_large_image',
      meta_videos_page_description:
        'Bowling videos, articles, news, & games. Watch & stream live bowling games on FloBowling.com. Professional bowling tournaments & news coverage.',
      meta_videos_page_page_type: 'video.other',
      meta_videos_page_title: 'Bowling Videos | Bowling Games & Highlights',
      ooyala_master_ad_set: 'dad0494f0ccc4b6abcd68f2bea0aed05',
      ooyala_player_id: '7cd89be0ab0e494398fd8a945cb15805',
      primary_color: '#FF140F',
      privacy_url: 'https://www.flosports.tv/privacy/',
      segment_api_key: 'Ti5w71qkAk56nVtciiJZbt62zCr1Wo1u',
      site_id: 41,
      site_name: 'FloBowling',
      sport_name: 'Bowling',
      tos_url: 'https://www.flosports.tv/terms-of-service/',
      training_videos_name: 'Training',
      twitter_page_url: 'https://twitter.com/flobowling',
      youtube_page_url: 'https://www.youtube.com/FloBowling',
      gift_url: '/gift'
    }
  ],
  [
    SiteCode.Baseball,
    {
      api_url: 'https://api.flobaseball.tv',
      california_privacy_url: 'https://www.flosports.tv/california-privacy-policy/',
      careers_url: 'https://www.flosports.tv/work-with-us',
      contact_url: 'https://support.flosports.tv/',
      core_site_url: 'https://www.flobaseball.tv',
      facebook_app_id: '176120040390857',
      facebook_page_url: 'https://www.facebook.com/FloBaseball',
      faq_url: 'https://support.flosports.tv/',
      favicon_url: 'https://d6fm3yzmawlcs.cloudfront.net/favicons/new-favicon/',
      flosports_url: 'https://www.flosports.tv/',
      google_client_id: '725441156888-7omk04iprracmmh1be832orb4lgtdsb5.apps.googleusercontent.com',
      instagram_page_url: 'https://instagram.com/flobaseball',
      meta_articles_page_description:
        'Baseball news, competitions, videos, & articles. Watch & stream live baseball events on FloBaseball.tv. Minor League and College Baseball coverage.',
      meta_articles_page_title: 'Baseball News | Videos, Highlights, & Articles',
      meta_articles_page_type: 'article',
      meta_default_image: 'https://d6fm3yzmawlcs.cloudfront.net/ogImages/Baseball-1920x1080.jpg',
      meta_default_type: 'website',
      meta_events_entries_page_description: 'Watch & stream baseball live events. Events are our thing. Enjoy.',
      meta_events_entries_page_title: 'Baseball Events | Baseball Entries & Schedule',
      meta_events_entries_page_type: 'events',
      meta_events_news_page_description:
        'Baseball Event News - schedule, replays, and videos. Minor League and College Baseball coverage.',
      meta_events_news_page_title: 'Baseball Event News | Schedule, Replays, & Videos',
      meta_events_news_page_type: 'event',
      meta_events_page_description:
        'Watch & stream baseball live events. Baseball schedule, videos, and articles. Minor League and College Baseball coverage.',
      meta_events_page_title: 'Baseball Events | Schedule, Videos, & Articles',
      meta_events_page_type: 'event',
      meta_events_photo_page_type: 'event',
      meta_events_photos_page_description:
        'Find event photos from live baseball streams broadcasted on FloBaseball.tv.',
      meta_events_photos_page_title: 'Baseball Event Photos | Pictures from Baseball Live Events',
      meta_events_schedule_page_description: 'Find the start and end time for live baseball events on FloBaseball.tv.',
      meta_events_schedule_page_title: 'Live Baseball Event Schedule | Start & End Times',
      meta_events_schedule_page_type: 'event',
      meta_events_videos_page_description:
        'Watch & stream baseball live events including baseball videos, interviews, highlights, and replays.',
      meta_events_videos_page_title: 'Baseball Events | Videos, Interviews, & Highlights',
      meta_events_videos_page_type: 'event',
      meta_films_page_description:
        'Watch baseball films, movies, and documentaries available exclusively on FloBaseball.com.',
      meta_films_page_title: 'FloBaseball Films | Baseball Movies & Documentaries',
      meta_home_page_description:
        'Baseball games, videos, news, & articles. Watch & stream live baseball games on FloBaseball.com. Minor League and College Baseball coverage.',
      meta_home_page_title: 'Baseball | Live Games, Articles, Videos & News',
      meta_login_page_description:
        'Log in to get the latest baseball news, videos, & events. All the info, all the time.',
      meta_login_page_title: 'Log in now to check out exclusive baseball content!',
      meta_not_found_page_description: 'Page not found for whatever reason!',
      meta_not_found_page_title: 'Page Not Found',
      meta_pay_page_description:
        'Enter your payment information to receive full access to premium content and live baseball streams on FloBaseball.tv.',
      meta_pay_page_title: 'FloBaseball Payment Page | Live Baseball Streams & Premium Access',
      meta_ranking_page_description: "Who's the best of the best? Get current baseball rankings here.",
      meta_ranking_page_title: 'Baseball Rankings | Current Rankings for Baseball',
      meta_ranking_page_type: 'rankings',
      meta_result_page_description:
        'Find the results and scores to the live baseball events streamed on FloBaseball.tv.',
      meta_result_page_title: 'Baseball Results & Scores',
      meta_search_page_description: 'Search the latest baseball news, videos, & events. All the info, all the time.',
      meta_search_page_title: 'Search The Latest Baseball News & Videos!',
      meta_signup_page_description:
        'Signup with FloBaseball.tv to receive exclusive access to live baseball streams, premium content, and more.',
      meta_signup_page_title: 'FloBaseball Signup | Live Baseball Streams & Premium Access',
      meta_sport_name: 'Baseball',
      meta_training_page_description: 'Watch video training for baseball only available on FloBaseball.tv.',
      meta_training_page_title: 'Baseball Training | Watch Video Trainings For Baseball',
      meta_twitter_card_type: 'summary_large_image',
      meta_videos_page_description:
        'Marching videos, competitions, news, & articles. Watch & stream live baseball events on FloBaseball.tv. Minor League and College Baseball coverage.',
      meta_videos_page_page_type: 'video.other',
      meta_videos_page_title: 'Baseball Videos | Baseball Competition & Highlights',
      ooyala_master_ad_set: null,
      ooyala_player_id: null,
      primary_color: '#FF140F',
      privacy_url: 'https://www.flosports.tv/privacy/',
      segment_api_key: 'JKBOAto31a0ViCGJI3L3kEJOkkP8v6Hf',
      site_id: 42,
      site_name: 'FloBaseball',
      sport_name: 'Baseball',
      tos_url: 'https://www.flosports.tv/terms-of-service/',
      training_videos_name: 'Training',
      twitter_page_url: 'https://twitter.com/FloBaseball',
      youtube_page_url: 'https://www.youtube.com/channel/UC61qfDamnMB3j1Qo4vDY26w?view_as=subscriber',
      gift_url: '/gift'
    }
  ],
  [
    SiteCode.Soccer,
    {
      api_url: 'https://api.flofc.com',
      california_privacy_url: 'https://www.flosports.tv/california-privacy-policy/',
      careers_url: 'https://www.flosports.tv/work-with-us',
      contact_url: 'https://support.flosports.tv/',
      core_site_url: 'https://www.flofc.com',
      facebook_app_id: '111287849817430',
      facebook_page_url: 'https://www.facebook.com/FloFutbol',
      faq_url: 'https://support.flosports.tv/',
      favicon_url: 'https://d6fm3yzmawlcs.cloudfront.net/favicons/new-favicon/',
      flosports_url: 'https://www.flosports.tv/',
      google_client_id: '382889032134-o4jkqsj4oi8jlh3ku593vj814m064osq.apps.googleusercontent.com',
      instagram_page_url: 'https://www.instagram.com/flofc',
      meta_articles_page_description:
        'Stay up-to-date on all the news in the pro soccer world with the latest articles, delivered daily.',
      meta_articles_page_title: 'The most up-to-date FloFC Professional Soccer News & Articles!',
      meta_articles_page_type: 'article',
      meta_default_image: 'https://d6fm3yzmawlcs.cloudfront.net/ogImages/Soccer-1920x1080.jpg',
      meta_default_type: 'website',
      meta_events_entries_page_description: 'Watch & stream pro soccer live events. Events are our thing. Enjoy',
      meta_events_entries_page_title: 'Watch & stream Professional Soccer FloFC events.',
      meta_events_entries_page_type: 'events',
      meta_events_news_page_description: 'Watch & stream pro soccer live events. Events are our thing. Enjoy.',
      meta_events_news_page_title: 'Watch & stream FloFC Professional Soccer events.',
      meta_events_news_page_type: 'event',
      meta_events_page_description: 'Watch & stream pro soccer live events. Events are our thing. Enjoy.',
      meta_events_page_title: 'Watch & Stream FloFC Professional Soccer Events',
      meta_events_page_type: 'event',
      meta_events_photo_page_type: 'event',
      meta_events_photos_page_description: 'Watch & stream pro soccer live events. Events are our thing. Enjoy',
      meta_events_photos_page_title: 'Watch & stream Professional Soccer FloFC events',
      meta_events_schedule_page_description: 'Watch & stream pro soccer live events. Events are our thing. Enjoy.',
      meta_events_schedule_page_title: 'Watch & stream Professional Soccer FloFC events.',
      meta_events_schedule_page_type: 'event',
      meta_events_videos_page_description: 'Watch & stream pro soccer live events. Events are our thing. Enjoy.',
      meta_events_videos_page_title: 'Watch & Stream FloFC Professional Soccer Events',
      meta_events_videos_page_type: 'event',
      meta_films_page_description: 'Watch Professional Soccer Films and Documentaries',
      meta_films_page_title: 'Professional Soccer Films and Documentaries',
      meta_home_page_description: 'Get the latest pro soccer news, videos, & events. All the info, all the time.',
      meta_home_page_title: 'The latest FloFC Professional Soccer News & Videos!',
      meta_login_page_description:
        'Log in to get the latest pro soccer news, videos, & events. All the info, all the time.',
      meta_login_page_title: 'Log in now to check out exclusive Professional Soccer FloFC content!',
      meta_not_found_page_description: 'Page not found for whatever reason!',
      meta_not_found_page_title: 'Page not found',
      meta_pay_page_description: 'Get the latest pro soccer news, videos, & events. All the info, all the time.',
      meta_pay_page_title: 'Subscribe & Get Access to the latest FloFC News, Films, and Events!',
      meta_ranking_page_description: "Who's the best of the best? Get current pro soccer rankings here.",
      meta_ranking_page_title: 'Get the most current FloFC Professional Soccer rankings!',
      meta_ranking_page_type: 'rankings',
      meta_result_page_description: 'Check out the latest pro soccer scores, direct  the results headquarters.',
      meta_result_page_title: 'Check out the FloFC Professional Soccer results!',
      meta_search_page_description: 'Search the latest pro soccer news, videos, & events. All the info, all the time.',
      meta_search_page_title: 'Search the latest FloFC Professional Soccer News & Videos!',
      meta_signup_page_description: 'Get the latest pro soccer news, videos, & events. All the info, all the time.',
      meta_signup_page_title: 'Sign Up & Get Access to the latest FloFC Professional Soccer News, Films, & Events!',
      meta_sport_name: null,
      meta_training_page_description: 'Watch training and technique videos',
      meta_training_page_title: 'Professional Soccer Training and Technique Videos',
      meta_twitter_card_type: 'summary_large_image',
      meta_videos_page_description: 'Watch the latest pro soccer videos. All videos, all the time.',
      meta_videos_page_page_type: 'video.other',
      meta_videos_page_title: 'Watch the latest FloFC Professional Soccer Videos!',
      ooyala_master_ad_set: null,
      ooyala_player_id: null,
      primary_color: '#FF140F',
      privacy_url: 'https://www.flosports.tv/privacy/',
      segment_api_key: 'nPcHedte62laipgJSqKZGDh7VPu2SQ5p',
      site_id: 43,
      site_name: 'FloFC',
      sport_name: 'Soccer',
      tos_url: 'https://www.flosports.tv/terms-of-service/',
      training_videos_name: 'Training',
      twitter_page_url: 'https://twitter.com/FloFC_',
      youtube_page_url: 'https://www.youtube.com/channel/UCEXgc0EmLodQ4_WGFgLl3Ng',
      gift_url: '/gift'
    }
  ],
  [
    SiteCode.TrackWrestling,
    {
      api_url: 'https://flosports30-api.trackwrestling.com',
      california_privacy_url: 'https://www.flosports.tv/california-privacy-policy/',
      careers_url: 'https://www.flosports.tv/work-with-us',
      contact_url: 'https://www.flosports.tv/contact/',
      core_site_url: 'https://accounts.trackwrestling.com',
      facebook_app_id: '1017411902416884',
      facebook_page_url: 'https://www.facebook.com/flosports/',
      faq_url: 'https://www.flosports.tv/faq/',
      favicon_url: 'https://dvsfd86tdlcfa.cloudfront.net/assets/2016111719441264/bundles/app/images/floslam/favicon/',
      flosports_url: 'https://www.flosports.tv/',
      google_client_id: '1023656513010-s08ashcjkquanik4vkq6tqp18f886fio.apps.googleusercontent.com',
      instagram_page_url: null,
      meta_articles_page_description: null,
      meta_articles_page_title: null,
      meta_articles_page_type: null,
      meta_default_image: 'http://static-assets.flosports.local/photo/58a1f091d8ff6.png?width=300',
      meta_default_type: 'website',
      meta_events_entries_page_description: null,
      meta_events_entries_page_title: null,
      meta_events_entries_page_type: null,
      meta_events_news_page_description: null,
      meta_events_news_page_title: null,
      meta_events_news_page_type: null,
      meta_events_page_description: null,
      meta_events_page_title: null,
      meta_events_page_type: null,
      meta_events_photo_page_type: null,
      meta_events_photos_page_description: null,
      meta_events_photos_page_title: null,
      meta_events_schedule_page_description: null,
      meta_events_schedule_page_title: null,
      meta_events_schedule_page_type: null,
      meta_events_videos_page_description: null,
      meta_events_videos_page_title: null,
      meta_events_videos_page_type: null,
      meta_films_page_description: null,
      meta_films_page_title: null,
      meta_home_page_description:
        'Get the latest TrackWrestling news, videos, &amp; events. All the info, all the time.',
      meta_home_page_title: 'The latest TrackWrestling news &amp; videos!',
      meta_login_page_description:
        'Wrestling events, videos, &amp; news. Watch &amp; stream live wrestling competitions on Trackwrestling.com. High school, NCAA, &amp; elite wrestling coverage.',
      meta_login_page_title: 'Trackwrestling | Wrestling Matches &amp; Videos',
      meta_not_found_page_description: 'Page not found for whatever reason!',
      meta_not_found_page_title: 'Page not found',
      meta_pay_page_description:
        'Wrestling events, videos, &amp; news. Watch &amp; stream live wrestling competitions on Trackwrestling.com. High school, NCAA, &amp; elite wrestling coverage.',
      meta_pay_page_title: 'Trackwrestling | Wrestling Matches &amp; Videos - Join Today',
      meta_ranking_page_description: null,
      meta_ranking_page_title: null,
      meta_ranking_page_type: null,
      meta_result_page_description: null,
      meta_result_page_title: null,
      meta_search_page_description:
        'Search the latest TrackWrestling news, videos, &amp; events. All the info, all the time.',
      meta_search_page_title: 'Search the latest TrackWrestling news &amp; videos!',
      meta_signup_page_description:
        'Wrestling events, videos, &amp; news. Watch &amp; stream live wrestling competitions on Trackwrestling.com. High school, NCAA, &amp; elite wrestling coverage.',
      meta_signup_page_title: 'Trackwrestling | Wrestling Matches &amp; Videos - Join Today',
      meta_sport_name: null,
      meta_training_page_description: null,
      meta_training_page_title: null,
      meta_twitter_card_type: 'summary_large_image',
      meta_videos_page_description: null,
      meta_videos_page_page_type: null,
      meta_videos_page_title: 'Watch the latest TrackWrestling videos!',
      ooyala_master_ad_set: null,
      ooyala_player_id: null,
      primary_color: '#0070bb',
      privacy_url: 'https://www.flosports.tv/privacy/',
      segment_api_key: 'oIq71j4faVPMsnW66krWyAI91aCJJuDA',
      site_id: 44,
      site_name: 'TrackWrestling',
      site_styles:
        '/* Brand Colors*/\r\n.color-ignite, .primary-color-text { color: #0070bb !important; }\r\n.primary-color-text:hover, .primary-color-text:focus { color: #0070bb !important; transition: all 250ms }\r\n.primary-color-text-active.active .apply-text-active, .primary-color-text-active.active.apply-text-active,\r\n.nested-primary-color-text-active.active .nested-apply-text-active, .nested-primary-color-text-active.nested-active.apply-text-active { color: #0070bb !important; }\r\n.primary-color-text-hover:hover .apply-text-hover, .primary-color-text-hover:hover.apply-text-hover, .hover-text-primary:hover { color: #0070bb !important; }\r\n.primary-color-bg { background: #0070bb !important; }\r\n.primary-color-border { border-color: #0070bb !important }\r\n.primary-color-border-bottom { border-bottom-color: #0070bb !important }\r\n.primary-color-border-top { border-top-color: #0070bb !important }\r\n.primary-color-border-left { border-left-color: #0070bb !important }\r\n.primary-color-border-right { border-right-color: #0070bb !important }\r\n.primary-color-border-active.active { border-color: #0070bb !important }\r\n.primary-color-outline { outline-color: #0070bb !important }\r\n.primary-color-stroke { stroke: #0070bb !important }\r\n\r\n/* Osano */\r\n.osano-cm-info .osano-cm-button, .osano-cm-info .osano-cm-input:checked + .osano-cm-switch, .osano-cm-info .osano-cm-input:hover + .osano-cm-switch, .osano-cm-info .osano-cm-input:checked:focus + .osano-cm-switch {background-color: #0070BA !important}\r\n.osano-cm-dialog a {\r\ncolor: #0070BA !important}\r\n\r\n\r\n/* Nav */\r\n@media (max-width: 992px) { ul li.mobile-menu { background: rgb(0, 112, 187); }}\r\n\r\n/* Logo */\r\n.logo-wrapper .logo {height: 42px !important;}\r\n.logo-wrapper .logo svg { height: 35px !important; }\r\n.logo svg .text-powered { fill: #ffffff }\r\n.logo.dark-alternate svg .text-powered { fill: #64656a; }\r\n.logo svg .text-track { fill: #ffffff; }\r\n.logo.dark-alternate svg .text-track { fill: #232327; }\r\n.checkout-header-wrapper { margin: 36px auto !important; }\r\n.checkout-header-wrapper .logo svg {height: 35px !important;}\r\n.outer-margin-wrapper .logo-links .logo svg {height: 35px !important;}\r\n.radial-overlay .logo{margin: 5px 0 !important;}\r\n.radial-overlay .logo img {height: 30px !important;} @media (max-width: 768px) {.radial-overlay .logo{margin: 5px auto !important;}}\r\n\r\n/* Typography */\r\na, a.visited { color:hsl(204, 100%, 37%) }\r\na:hover { color: hsl(204, 100%, 33%) !important; }\r\n.drill-through { color: #0070bb !important; }\r\n\r\n.header ul.utility-bar li.dropdown:hover a.dropdown-toggle { background: rgb(0, 112, 187) !important; }\r\n.header ul.utility-bar .flo-9748-upgrade button.flo-9748-upgrade-button,\r\n.logo-wrapper .flo-9748-dropdown-mobile-only button.flo-9748-upgrade-button { background: #ffffff !important; color: rgb(0, 112, 187) !important; }\r\n\r\n/* Watch on Web Header*/\r\n.header ul.utility-bar .primary-color-bg-hover:hover .apply-bg-hover { background: rgb(0, 112, 187) !important; }\r\n\r\n\r\n/*Button*/\r\n.btn-primary.btn, .btn-primary-small.btn, .btn-primary-tiny.btn { background: #0070bb; border-color: #0070bb !important; }\r\n.btn-primary.btn:hover, .btn-primary-small.btn:hover, .btn-primary-tiny.btn:hover {\r\n    background-color: hsl(204, 100%, 33%) !important; border-color: hsl(204, 100%, 33%) !important; color: #fff !important;\r\n}\r\n\r\n.btn-secondary.btn, .btn-secondary-small.btn, .btn-secondary-tiny.btn { color: #0070bb; }\r\n.btn.btn-secondary, .btn.btn-secondary:active { border-color: #eeeef0 !important;}\r\n.btn-secondary.btn a, .btn-secondary-small.btn a, .btn-secondary-tiny.btn a { color: #0070bb; }\r\n.btn.btn-secondary:active { color: #0070bb !important; }\r\n.btn.btn-primary:focus, .btn.btn-secondary:focus { box-shadow: 0 0 0 .16471rem rgba(0, 112, 187, .2) !important;}\r\n.btn.btn-primary:active { background-color: #0070bb !important; }\r\n.btn.btn-primary:disabled, .btn.btn-secondary:disabled { border-color: #eeeef0 !important;}\r\n.btn-group .btn-outline-secondary.active,\r\n.btn-group .btn-outline-secondary:active { background-color: #0070bb !important; border-color: #0070bb !important; }\r\n.btn-group .btn-outline-secondary.hover,\r\n.btn-group .btn-outline-secondary:hover,\r\n.btn-group .btn-outline-secondary:hover:not([disabled]) { background-color: #0070bb !important; border-color: #0070bb !important; color: #fff !important; }\r\n.btn-secondary.btn:hover, .btn-secondary-small.btn:hover, .btn-secondary-tiny.btn:hover {\r\n    color: #0070bb !important;\r\n}\r\n\r\n/* Tabs */\r\n.tabs-container .tab-active {\r\n  border-bottom: .05882rem solid #0070bb !important;\r\n  color: #0070bb !important;\r\n}\r\n/*Play Icon */\r\n.play-icon span.play-button {background-color: #0070bb !important;}\r\n/* Nav Bar */\r\n.utility-bar span[flosvg="icon-search"],\r\n.utility-bar span[flosvg="icon-share"]\r\n { color: white !important; }\r\n @media (min-width: 992px) {\r\n  .utility-bar li:not(.dropdown) a:hover { color: white !important; }\r\n }\r\n @media (max-width: 992px) {\r\n  .primary-links li a:hover { color: white !important; }\r\n }\r\n.nav-icon.mobile.rotate a:hover { color: white !important; }\r\nul.utility-bar li.dropdown ul.user-dropdown li:hover .user-links {color: #0070bb !important;}\r\n\r\n/* SVG */\r\n.primary-color-svg svg path { fill: #0070bb; }\r\n.primary-color-svg-hover svg:hover path { fill: #0070bb; }\r\n.primary-color-svg-apply svg .primary-color-apply { fill: #0070bb; }\r\n.primary-color-svg-hover-apply svg:hover .primary-color-apply { fill: #0070bb; }',
      sport_name: 'Wrestling',
      tos_url: 'https://www.flosports.tv/terms-of-service/',
      training_videos_name: 'Training',
      twitter_page_url: 'https://twitter.com/flosports',
      youtube_page_url: 'https://www.youtube.com/user/Flocasts',
      gift_url: '/gift'
    }
  ],
  [
    SiteCode.Dogs,
    {
      api_url: 'https://api.flodogs.com',
      california_privacy_url: 'https://www.flosports.tv/california-privacy-policy/',
      careers_url: 'https://www.flosports.tv/work-with-us',
      contact_url: 'https://www.flosports.tv/contact/',
      core_site_url: 'https://www.flodogs.com',
      facebook_app_id: '821824194653094',
      facebook_page_url: 'https://www.facebook.com/flosports/',
      faq_url: 'https://www.facebook.com/flosports/',
      favicon_url: 'https://d6fm3yzmawlcs.cloudfront.net/favicons/new-favicon/',
      flosports_url: 'https://www.flosports.tv/',
      google_client_id: '758984137660-pottd3c2mv09isftnk9ghac2hu7tn4bn.apps.googleusercontent.com',
      instagram_page_url: 'https://www.instagram.com/explore/locations/921189021340396/flosports/',
      meta_articles_page_description:
        'Stay up-to-date on all the news in the FloDogs world with the latest articles, delivered daily.',
      meta_articles_page_title: 'The most up-to-date FloDogs news & articles!',
      meta_articles_page_type: 'article',
      meta_default_image: 'https://d6fm3yzmawlcs.cloudfront.net/ogImages/Voice-1920x1080.jpg',
      meta_default_type: 'website',
      meta_events_entries_page_description: 'Watch & stream FloDogs live events. Events are our thing. Enjoy',
      meta_events_entries_page_title: 'Watch & stream FloDogs events.',
      meta_events_entries_page_type: 'events',
      meta_events_news_page_description: 'Watch & stream FloDogs live events. Events are our thing. Enjoy.',
      meta_events_news_page_title: 'Watch & stream FloDogs events.',
      meta_events_news_page_type: 'event',
      meta_events_page_description: 'Watch & stream FloDogs live events. Events are our thing. Enjoy.',
      meta_events_page_title: 'Watch & stream FloDogs events.',
      meta_events_page_type: 'event',
      meta_events_photo_page_type: 'event',
      meta_events_photos_page_description: 'Watch & stream FloDogs live events. Events are our thing. Enjoy',
      meta_events_photos_page_title: 'Watch & stream FloDogs events',
      meta_events_schedule_page_description: 'Watch & stream FloDogs live events. Events are our thing. Enjoy.',
      meta_events_schedule_page_title: 'Watch & stream FloDogs events.',
      meta_events_schedule_page_type: 'event',
      meta_events_videos_page_description: 'Watch & stream FloDogs live events. Events are our thing. Enjoy.',
      meta_events_videos_page_title: 'Watch & stream FloDogs events.',
      meta_events_videos_page_type: 'event',
      meta_films_page_description: 'Watch Films and Documentaries',
      meta_films_page_title: 'Films and Documentaries',
      meta_home_page_description: 'Get the latest  FloDogs news, videos, & events. All the info, all the time.',
      meta_home_page_title: 'The latest FloDogs news & videos!',
      meta_login_page_description:
        'Log in to get the latest FloDogs news, videos, & events. All the info, all the time.',
      meta_login_page_title: 'Log in now to check out exclusive FloDogs content!',
      meta_not_found_page_description: 'Page not found for whatever reason!',
      meta_not_found_page_title: 'Page not found',
      meta_pay_page_description: 'Get the latest FloDogs news, videos, & events. All the info, all the time.',
      meta_pay_page_title: 'Subscribe & get access to the latest FloDogs news, films, and events!',
      meta_ranking_page_description: "Who's the best of the best? Get current FloDogs rankings here.",
      meta_ranking_page_title: 'Get the most current FloDogs rankings!',
      meta_ranking_page_type: 'rankings',
      meta_result_page_description: 'Check out the latest FloDogs scores, direct  the results headquarters.',
      meta_result_page_title: 'Check out the FloDogs results!',
      meta_search_page_description: 'Search the latest FloDogs news, videos, & events. All the info, all the time.',
      meta_search_page_title: 'Search the latest FloDogs news & videos!',
      meta_signup_page_description: 'Get the latest FloDogs news, videos, & events. All the info, all the time.',
      meta_signup_page_title: 'Subscribe & get access to the latest FloDogs news, films, and events!',
      meta_sport_name: 'doggo & puppers',
      meta_training_page_description: 'Watch training and technique videos',
      meta_training_page_title: 'Training and Technique Videos',
      meta_twitter_card_type: 'summary_large_image',
      meta_videos_page_description: 'Watch the latest FloDogs videos. All videos, all the time.',
      meta_videos_page_page_type: 'video.other',
      meta_videos_page_title: 'Watch the latest FloDogs videos!',
      ooyala_master_ad_set: 'c6b2851f53ac4dd6bd41f887905c32e8',
      ooyala_player_id: 'e0798993365348c58b8e71befc2860e6',
      primary_color: '#FF140F',
      privacy_url: 'https://www.flosports.tv/privacy/',
      segment_api_key: 'ZUHcnFn1thW6jxIHzpClKrkH5r7zYsFI',
      site_id: 9001,
      site_name: 'FloDogs',
      sport_name: 'Dogs',
      tos_url: 'https://www.flosports.tv/terms-of-service/',
      training_videos_name: 'Training',
      twitter_page_url: 'https://twitter.com/flosports',
      youtube_page_url: 'https://www.youtube.com/user/Flocasts',
      gift_url: '/gift'
    }
  ],
  [
    SiteCode.College,
    {
      api_url: 'https://api.flocollege.com',
      california_privacy_url: 'https://www.flosports.tv/california-privacy-policy/',
      careers_url: 'https://www.flosports.tv/work-with-us',
      contact_url: 'https://support.flosports.tv/',
      core_site_url: 'https://www.flocollege.com',
      facebook_app_id: '7940140659429790',
      facebook_page_url: null,
      faq_url: 'https://support.flosports.tv/',
      favicon_url: 'https://d6fm3yzmawlcs.cloudfront.net/favicons/new-favicon/',
      flosports_url: 'https://www.flosports.tv/',
      google_client_id: '974618297901-4j914vuh8d2t7d7gq2am00oa72r57vau.apps.googleusercontent.com',
      instagram_page_url: null,
      meta_articles_page_description:
        'Stay up-to-date on all the news in the FloSports world with the latest articles, delivered daily.',
      meta_articles_page_title: 'The most up-to-date FloSports news & articles!',
      meta_articles_page_type: 'article',
      meta_default_image: 'https://d6fm3yzmawlcs.cloudfront.net/ogImages/College-1920x1080.jpg',
      meta_default_type: 'website',
      meta_events_entries_page_description: 'Watch & stream FloSports live events. Events are our thing. Enjoy',
      meta_events_entries_page_title: 'Watch & stream FloSports events.',
      meta_events_entries_page_type: 'events',
      meta_events_news_page_description: 'Watch & stream FloSports live events. Events are our thing. Enjoy',
      meta_events_news_page_title: 'Watch & stream FloSports events.',
      meta_events_news_page_type: 'event',
      meta_events_page_description: 'Watch & stream FloSports live events. Events are our thing. Enjoy',
      meta_events_page_title: 'Watch & stream FloSports events.',
      meta_events_page_type: 'event',
      meta_events_photo_page_type: 'event',
      meta_events_photos_page_description: 'Watch & stream FloSports live events. Events are our thing. Enjoy',
      meta_events_photos_page_title: 'Watch & stream FloSports events',
      meta_events_schedule_page_description: 'Watch & stream FloSports live events. Events are our thing. Enjoy',
      meta_events_schedule_page_title: 'Watch & stream FloSports events.',
      meta_events_schedule_page_type: 'event',
      meta_events_videos_page_description: 'Watch & stream FloSports live events. Events are our thing. Enjoy.',
      meta_events_videos_page_title: 'Watch & stream FloSports events.',
      meta_events_videos_page_type: 'event',
      meta_films_page_description: null,
      meta_films_page_title: null,
      meta_home_page_description: 'Get the latest  FloSports news, videos, & events. All the info, all the time.',
      meta_home_page_title: 'The latest FloSports news & videos!',
      meta_login_page_description:
        'Log in to get the latest FloSports news, videos, & events. All the info, all the time.',
      meta_login_page_title: 'Log in now to check out exclusive FloSports content!',
      meta_not_found_page_description: 'Page not found for whatever reason!',
      meta_not_found_page_title: 'Page not found',
      meta_pay_page_description: 'Get the latest FloSports news, videos, & events. All the info, all the time.',
      meta_pay_page_title: 'Subscribe & get access to the latest FloSports news, films, and events!',
      meta_ranking_page_description: "Who's the best of the best? Get current FloSports rankings here.",
      meta_ranking_page_title: 'Get the most current FloSports rankings!',
      meta_ranking_page_type: 'rankings',
      meta_result_page_description: 'Check out the latest FloSports scores, direct  the results headquarters.',
      meta_result_page_title: 'Check out the FloSports results!',
      meta_search_page_description: 'Get the latest  FloSports news, videos, & events. All the info, all the time.',
      meta_search_page_title: 'Search the latest FloSports news & videos!',
      meta_signup_page_description: 'Get the latest FloSports news, videos, & events. All the info, all the time.',
      meta_signup_page_title: 'Subscribe & get access to the latest FloSports news, films, and events!',
      meta_sport_name: 'College Sports',
      meta_training_page_description: 'Watch training and technique videos',
      meta_training_page_title: 'Training and Technique Videos',
      meta_twitter_card_type: 'summary_large_image',
      meta_videos_page_description: 'Watch the latest FloSports videos. All videos, all the time.',
      meta_videos_page_page_type: 'video',
      meta_videos_page_title: 'The most up-to-date FloSports news & articles!',
      ooyala_master_ad_set: null,
      ooyala_player_id: 'e0798993365348c58b8e71befc2860e6',
      primary_color: '#FF140F',
      privacy_url: 'https://www.flosports.tv/privacy/',
      segment_api_key: 'zCQ9H5ImCDQTHYHmfEFVRsXn23sDcWxl',
      site_id: 45,
      site_name: 'FloCollege',
      sport_name: 'College Sports',
      tos_url: 'https://www.flosports.tv/terms-of-service/',
      training_videos_name: 'Training',
      twitter_page_url: null,
      youtube_page_url: null,
      gift_url: '/gift'
    }
  ]
])

export const SiteSettingsMapStag = new Map<string, SiteSettings>([
  [
    SiteCode.Track,
    {
      api_url: 'https://staging-api.flotrack.org',
      california_privacy_url: 'https://www.flosports.tv/california-privacy-policy/',
      careers_url: 'https://www.flosports.tv/work-with-us',
      contact_url: 'https://www.flosports.tv/contact/',
      core_site_url: 'https://staging-public.flotrack.org',
      facebook_app_id: '119215858156983',
      facebook_page_url: 'https://www.facebook.com/flosports/',
      faq_url: 'https://www.flosports.tv/faq/',
      favicon_url: 'https://d6fm3yzmawlcs.cloudfront.net/favicons/new-favicon/',
      flosports_url: 'https://www.flosports.tv/',
      google_client_id: '189220610443-287apugqvr12kq5e8hllonspr3ldi6i7.apps.googleusercontent.com',
      instagram_page_url: 'https://www.instagram.com/explore/locations/921189021340396/flosports/',
      meta_articles_page_description:
        'Stay up-to-date on all the news in the FloTrack world with the latest articles, delivered daily.',
      meta_articles_page_title: 'The most up-to-date FloTrack news  articles!',
      meta_articles_page_type: 'article',
      meta_default_image: 'https://d6fm3yzmawlcs.cloudfront.net/ogImages/Track-1920x1080.jpg',
      meta_default_type: 'website',
      meta_events_entries_page_description: 'Watch  stream FloTrack live events. Events are our thing. Enjoy',
      meta_events_entries_page_title: 'Watch  stream FloTrack events.',
      meta_events_entries_page_type: 'events',
      meta_events_news_page_description: 'Watch  stream FloTrack live events. Events are our thing. Enjoy.',
      meta_events_news_page_title: 'Watch  stream FloTrack events.',
      meta_events_news_page_type: 'event',
      meta_events_page_description: 'Watch  stream FloTrack live events. Events are our thing. Enjoy.',
      meta_events_page_title: 'Watch  stream FloTrack events.',
      meta_events_page_type: 'event',
      meta_events_photo_page_type: 'event',
      meta_events_photos_page_description: 'Watch  stream FloTrack live events. Events are our thing. Enjoy',
      meta_events_photos_page_title: 'Watch  stream FloTrack events',
      meta_events_schedule_page_description: 'Watch  stream FloTrack live events. Events are our thing. Enjoy.',
      meta_events_schedule_page_title: 'Watch  stream FloTrack events.',
      meta_events_schedule_page_type: 'event',
      meta_events_videos_page_description: 'Watch  stream FloTrack live events. Events are our thing. Enjoy.',
      meta_events_videos_page_title: 'Watch  stream FloTrack events.',
      meta_events_videos_page_type: 'event',
      meta_films_page_description: 'Watch Films and Documentaries',
      meta_films_page_title: 'Films and Documentaries',
      meta_home_page_description: 'Get the latest  FloTrack news, videos,  events. All the info, all the time.',
      meta_home_page_title: 'The latest FloTrack news  videos!',
      meta_login_page_description:
        'Log in to get the latest FloTrack news, videos,  events. All the info, all the time.',
      meta_login_page_title: 'Log in now to check out exclusive FloTrack content!',
      meta_not_found_page_description: 'Page not found for whatever reason!',
      meta_not_found_page_title: 'Page not found',
      meta_pay_page_description: 'Get the latest FloTrack news, videos,  events. All the info, all the time.',
      meta_pay_page_title: 'Subscribe  get access to the latest FloTrack news, films, and events!',
      meta_ranking_page_description: "Who's the best of the best? Get current FloTrack rankings here.",
      meta_ranking_page_title: 'Get the most current FloTrack rankings!',
      meta_ranking_page_type: 'rankings',
      meta_result_page_description: 'Check out the latest FloTrack scores, direct  the results headquarters.',
      meta_result_page_title: 'Check out the FloTrack results!',
      meta_search_page_description: 'Search the latest FloTrack news, videos,  events. All the info, all the time.',
      meta_search_page_title: 'Search the latest FloTrack news  videos!',
      meta_signup_page_description: 'Get the latest FloTrack news, videos,  events. All the info, all the time.',
      meta_signup_page_title: 'Subscribe  get access to the latest FloTrack news, films, and events!',
      meta_sport_name: 'college  professional track  field',
      meta_training_page_description: 'Watch training and technique videos',
      meta_training_page_title: 'Training and Technique Videos',
      meta_twitter_card_type: 'summary_large_image',
      meta_videos_page_description: 'Watch the latest FloTrack videos. All videos, all the time.',
      meta_videos_page_page_type: 'video.other',
      meta_videos_page_title: 'Watch the latest FloTrack videos!',
      ooyala_master_ad_set: 'b68c50e9db24587898e857a3290cb7c',
      ooyala_player_id: 'e0798993365348c58b8e71befc2860e6',
      primary_color: '#FF140F',
      privacy_url: 'https://www.flosports.tv/privacy/',
      segment_api_key: 'ZUHcnFn1thW6jxIHzpClKrkH5r7zYsFI',
      site_id: 1,
      site_name: 'FloTrack',
      sport_name: 'Track & Field',
      tos_url: 'https://www.flosports.tv/terms-and-conditions/',
      training_videos_name: 'Training',
      twitter_page_url: 'https://twitter.com/flosports',
      youtube_page_url: 'https://www.youtube.com/user/Flocasts',
      gift_url: '/gift'
    }
  ],
  [
    SiteCode.Wrestling,
    {
      api_url: 'https://staging-api.flowrestling.org',
      california_privacy_url: 'https://www.flosports.tv/california-privacy-policy/',
      careers_url: 'https://www.flosports.tv/work-with-us',
      contact_url: 'https://www.flosports.tv/contact/',
      core_site_url: 'https://staging-public.flowrestling.org',
      facebook_app_id: '177182988999383',
      facebook_page_url: 'https://www.facebook.com/flosports/',
      faq_url: 'https://www.flosports.tv/faq/',
      favicon_url: 'https://d6fm3yzmawlcs.cloudfront.net/favicons/new-favicon/',
      flosports_url: 'https://www.flosports.tv/',
      google_client_id: '854713922714-jihf7ra0rltj2e4tnpho1e03kvsuqahs.apps.googleusercontent.com',
      instagram_page_url: 'https://www.instagram.com/explore/locations/921189021340396/flosports/',
      meta_articles_page_description:
        'Stay up-to-date on all the news in the FloWrestling world with the latest articles, delivered daily.',
      meta_articles_page_title: 'The most up-to-date FloWrestling news  articles!',
      meta_articles_page_type: 'article',
      meta_default_image: 'https://d6fm3yzmawlcs.cloudfront.net/ogImages/Wrestling-1920x1080.jpg',
      meta_default_type: 'website',
      meta_events_entries_page_description: 'Watch  stream FloWrestling live events. Events are our thing. Enjoy',
      meta_events_entries_page_title: 'Watch  stream FloWrestling events.',
      meta_events_entries_page_type: 'events',
      meta_events_news_page_description: 'Watch  stream FloWrestling live events. Events are our thing. Enjoy.',
      meta_events_news_page_title: 'Watch  stream FloWrestling events.',
      meta_events_news_page_type: 'event',
      meta_events_page_description: 'Watch  stream FloWrestling live events. Events are our thing. Enjoy.',
      meta_events_page_title: 'Watch  stream FloWrestling events.',
      meta_events_page_type: 'event',
      meta_events_photo_page_type: 'event',
      meta_events_photos_page_description: 'Watch  stream FloWrestling live events. Events are our thing. Enjoy',
      meta_events_photos_page_title: 'Watch  stream FloWrestling events',
      meta_events_schedule_page_description: 'Watch  stream FloWrestling live events. Events are our thing. Enjoy.',
      meta_events_schedule_page_title: 'Watch  stream FloWrestling events.',
      meta_events_schedule_page_type: 'event',
      meta_events_videos_page_description: 'Watch  stream FloWrestling live events. Events are our thing. Enjoy.',
      meta_events_videos_page_title: 'Watch  stream FloWrestling events.',
      meta_events_videos_page_type: 'event',
      meta_films_page_description: 'Watch Films and Documentaries',
      meta_films_page_title: 'Films and Documentaries',
      meta_home_page_description: 'Get the latest  FloWrestling news, videos,  events. All the info, all the time.',
      meta_home_page_title: 'The latest FloWrestling news  videos!',
      meta_login_page_description:
        'Log in to get the latest FloWrestling news, videos,  events. All the info, all the time.',
      meta_login_page_title: 'Log in now to check out exclusive FloWrestling content!',
      meta_not_found_page_description: 'Page not found for whatever reason!',
      meta_not_found_page_title: 'Page not found',
      meta_pay_page_description: 'Get the latest FloWrestling news, videos,  events. All the info, all the time.',
      meta_pay_page_title: 'Subscribe  get access to the latest FloWrestling news, films, and events!',
      meta_ranking_page_description: "Who's the best of the best? Get current FloWrestling rankings here.",
      meta_ranking_page_title: 'Get the most current FloWrestling rankings!',
      meta_ranking_page_type: 'rankings',
      meta_result_page_description: 'Check out the latest FloWrestling scores, direct  the results headquarters.',
      meta_result_page_title: 'Check out the FloWrestling results!',
      meta_search_page_description: 'Search the latest FloWrestling news, videos,  events. All the info, all the time.',
      meta_search_page_title: 'Search the latest FloWrestling news  videos!',
      meta_signup_page_description: 'Get the latest FloWrestling news, videos,  events. All the info, all the time.',
      meta_signup_page_title: 'Subscribe  get access to the latest FloWrestling news, films, and events!',
      meta_sport_name: 'high school, NCAA,  elite wrestling',
      meta_training_page_description: 'Watch training and technique videos',
      meta_training_page_title: 'Training and Technique Videos',
      meta_twitter_card_type: 'summary_large_image',
      meta_videos_page_description: 'Watch the latest FloWrestling videos. All videos, all the time.',
      meta_videos_page_page_type: 'video.other',
      meta_videos_page_title: 'Watch the latest FloWrestling videos!',
      ooyala_master_ad_set: 'eb894ae87a004492b82fe1dbfde13bbc',
      ooyala_player_id: 'e0798993365348c58b8e71befc2860e6',
      primary_color: '#FF140F',
      privacy_url: 'https://www.flosports.tv/privacy/',
      segment_api_key: 'ZUHcnFn1thW6jxIHzpClKrkH5r7zYsFI',
      site_id: 2,
      site_name: 'FloWrestling',
      sport_name: 'Wrestling',
      tos_url: 'https://www.flosports.tv/terms-and-conditions/',
      training_videos_name: 'Training',
      twitter_page_url: 'https://twitter.com/flosports',
      youtube_page_url: 'https://www.youtube.com/user/Flocasts',
      gift_url: '/gift'
    }
  ],
  [
    SiteCode.Gymnastics,
    {
      api_url: 'https://staging-api.flogymnastics.com',
      california_privacy_url: 'https://www.flosports.tv/california-privacy-policy/',
      careers_url: 'https://www.flosports.tv/work-with-us',
      contact_url: 'https://www.flosports.tv/contact/',
      core_site_url: 'https://staging-public.flogymnastics.com',
      facebook_app_id: '1681071402129318',
      facebook_page_url: 'https://www.facebook.com/flosports/',
      faq_url: 'https://www.flosports.tv/faq/',
      favicon_url: 'https://d6fm3yzmawlcs.cloudfront.net/favicons/new-favicon/',
      flosports_url: 'https://www.flosports.tv/',
      google_client_id: '306049847281-jln17ifm929lbg7k2e46jg0ahn5qcqq8.apps.googleusercontent.com',
      instagram_page_url: 'https://www.instagram.com/explore/locations/921189021340396/flosports/',
      meta_articles_page_description:
        'Stay up-to-date on all the news in the FloGymnastics world with the latest articles, delivered daily.',
      meta_articles_page_title: 'The most up-to-date FloGymnastics news  articles!',
      meta_articles_page_type: 'article',
      meta_default_image: 'https://d6fm3yzmawlcs.cloudfront.net/ogImages/Gymnastics-1920x1080.jpg',
      meta_default_type: 'website',
      meta_events_entries_page_description: 'Watch  stream FloGymnastics live events. Events are our thing. Enjoy',
      meta_events_entries_page_title: 'Watch  stream FloGymnastics events.',
      meta_events_entries_page_type: 'events',
      meta_events_news_page_description: 'Watch  stream FloGymnastics live events. Events are our thing. Enjoy.',
      meta_events_news_page_title: 'Watch  stream FloGymnastics events.',
      meta_events_news_page_type: 'event',
      meta_events_page_description: 'Watch  stream FloGymnastics live events. Events are our thing. Enjoy.',
      meta_events_page_title: 'Watch  stream FloGymnastics events.',
      meta_events_page_type: 'event',
      meta_events_photo_page_type: 'event',
      meta_events_photos_page_description: 'Watch  stream FloGymnastics live events. Events are our thing. Enjoy',
      meta_events_photos_page_title: 'Watch  stream FloGymnastics events',
      meta_events_schedule_page_description: 'Watch  stream FloGymnastics live events. Events are our thing. Enjoy.',
      meta_events_schedule_page_title: 'Watch  stream FloGymnastics events.',
      meta_events_schedule_page_type: 'event',
      meta_events_videos_page_description: 'Watch  stream FloGymnastics live events. Events are our thing. Enjoy.',
      meta_events_videos_page_title: 'Watch  stream FloGymnastics events.',
      meta_events_videos_page_type: 'event',
      meta_films_page_description: 'Watch Films and Documentaries',
      meta_films_page_title: 'Films and Documentaries',
      meta_home_page_description: 'Get the latest  FloGymnastics news, videos,  events. All the info, all the time.',
      meta_home_page_title: 'The latest FloGymnastics news  videos!',
      meta_login_page_description:
        'Log in to get the latest FloGymnastics news, videos,  events. All the info, all the time.',
      meta_login_page_title: 'Log in now to check out exclusive FloGymnastics content!',
      meta_not_found_page_description: 'Page not found for whatever reason!!',
      meta_not_found_page_title: 'Page not found',
      meta_pay_page_description: 'Get the latest FloGymnastics news, videos,  events. All the info, all the time.',
      meta_pay_page_title: 'Subscribe  get access to the latest FloGymnastics news, films, and events!',
      meta_ranking_page_description: "Who's the best of the best? Get current FloGymnastics rankings here.",
      meta_ranking_page_title: 'Get the most current FloGymnastics rankings!',
      meta_ranking_page_type: 'rankings',
      meta_result_page_description: 'Check out the latest FloGymnastics scores, direct  the results headquarters.',
      meta_result_page_title: 'Check out the FloGymnastics results!',
      meta_search_page_description:
        'Search the latest FloGymnastics news, videos,  events. All the info, all the time.',
      meta_search_page_title: 'Search the latest FloGymnastics news  videos!',
      meta_signup_page_description: 'Get the latest FloGymnastics news, videos,  events. All the info, all the time.',
      meta_signup_page_title: 'Subscribe  get access to the latest FloGymnastics news, films, and events!',
      meta_sport_name: 'club, NCAA,  elite gymnastics',
      meta_training_page_description: 'Watch training and technique videos',
      meta_training_page_title: 'Training and Technique Videos',
      meta_twitter_card_type: 'summary_large_image',
      meta_videos_page_description: 'Watch the latest FloGymnastics videos. All videos, all the time.',
      meta_videos_page_page_type: 'video.other',
      meta_videos_page_title: 'Watch the latest FloGymnastics videos!',
      ooyala_master_ad_set: '6dd87271fd3d4b29a146f64117a090af',
      ooyala_player_id: 'e0798993365348c58b8e71befc2860e6',
      primary_color: '#FF140F',
      privacy_url: 'https://www.flosports.tv/privacy/',
      segment_api_key: 'ZUHcnFn1thW6jxIHzpClKrkH5r7zYsFI',
      site_id: 4,
      site_name: 'FloGymnastics',
      sport_name: 'Gymnastics',
      tos_url: 'https://www.flosports.tv/terms-and-conditions/',
      training_videos_name: 'Training',
      twitter_page_url: 'https://twitter.com/flosports',
      youtube_page_url: 'https://www.youtube.com/user/Flocasts',
      gift_url: '/gift'
    }
  ],
  [
    SiteCode.Hoops,
    {
      api_url: 'https://staging-api.flohoops.com',
      california_privacy_url: 'https://www.flosports.tv/california-privacy-policy/',
      careers_url: 'https://www.flosports.tv/work-with-us',
      contact_url: 'https://www.flosports.tv/contact/',
      core_site_url: 'https://staging-public.flohoops.com',
      facebook_app_id: '520901398075294',
      facebook_page_url: 'https://www.facebook.com/flosports/',
      faq_url: 'https://www.flosports.tv/faq/',
      favicon_url: 'https://d6fm3yzmawlcs.cloudfront.net/favicons/new-favicon/',
      flosports_url: 'https://www.flosports.tv/',
      google_client_id: '731157393139-6rtj6l5c02cqnnf3gnoe69vl9ri048d2.apps.googleusercontent.com',
      instagram_page_url: 'https://www.instagram.com/explore/locations/921189021340396/flosports/',
      meta_articles_page_description:
        'Stay up-to-date on all the news in the FloHoops world with the latest articles, delivered daily.',
      meta_articles_page_title: 'The most up-to-date FloHoops news  articles!',
      meta_articles_page_type: 'article',
      meta_default_image: 'https://d6fm3yzmawlcs.cloudfront.net/ogImages/Hoops-1920x1080.jpg',
      meta_default_type: 'website',
      meta_events_entries_page_description: 'Watch  stream FloHoops live events. Events are our thing. Enjoy',
      meta_events_entries_page_title: 'Watch  stream FloHoops events.',
      meta_events_entries_page_type: 'events',
      meta_events_news_page_description: 'Watch  stream FloHoops live events. Events are our thing. Enjoy.',
      meta_events_news_page_title: 'Watch  stream FloHoops events.',
      meta_events_news_page_type: 'event',
      meta_events_page_description: 'Watch  stream FloHoops live events. Events are our thing. Enjoy.',
      meta_events_page_title: 'Watch  stream FloHoops events.',
      meta_events_page_type: 'event',
      meta_events_photo_page_type: 'event',
      meta_events_photos_page_description: 'Watch  stream FloHoops live events. Events are our thing. Enjoy',
      meta_events_photos_page_title: 'Watch  stream FloHoops events',
      meta_events_schedule_page_description: 'Watch  stream FloHoops live events. Events are our thing. Enjoy.',
      meta_events_schedule_page_title: 'Watch  stream FloHoops events.',
      meta_events_schedule_page_type: 'event',
      meta_events_videos_page_description: 'Watch  stream FloHoops live events. Events are our thing. Enjoy.',
      meta_events_videos_page_title: 'Watch  stream FloHoops events.',
      meta_events_videos_page_type: 'event',
      meta_films_page_description: 'Watch Films and Documentaries',
      meta_films_page_title: 'Films and Documentaries',
      meta_home_page_description: 'Get the latest  FloHoops news, videos,  events. All the info, all the time.',
      meta_home_page_title: 'The latest FloHoops news  videos!',
      meta_login_page_description:
        'Log in to get the latest FloHoops news, videos,  events. All the info, all the time.',
      meta_login_page_title: 'Log in now to check out exclusive FloHoops content!',
      meta_not_found_page_description: 'Page not found for whatever reason!',
      meta_not_found_page_title: 'Page not found',
      meta_pay_page_description: 'Get the latest FloHoops news, videos,  events. All the info, all the time.',
      meta_pay_page_title: 'Subscribe  get access to the latest FloHoops news, films, and events!',
      meta_ranking_page_description: "Who's the best of the best? Get current FloHoops rankings here.",
      meta_ranking_page_title: 'Get the most current FloHoops rankings!',
      meta_ranking_page_type: 'rankings',
      meta_result_page_description: 'Check out the latest FloHoops scores, direct  the results headquarters.',
      meta_result_page_title: 'Check out the FloHoops results!',
      meta_search_page_description: 'Search the latest FloHoops news, videos,  events. All the info, all the time.',
      meta_search_page_title: 'Search the latest FloHoops news  videos!',
      meta_signup_page_description: 'Get the latest FloHoops news, videos,  events. All the info, all the time.',
      meta_signup_page_title: 'Subscribe  get access to the latest FloHoops news, films, and events!',
      meta_sport_name: 'high school  NCAA basketball',
      meta_training_page_description: 'Watch training and technique videos',
      meta_training_page_title: 'Training and Technique Videos',
      meta_twitter_card_type: 'summary_large_image',
      meta_videos_page_description: 'Watch the latest FloHoops videos. All videos, all the time.',
      meta_videos_page_page_type: 'video.other',
      meta_videos_page_title: 'Watch the latest FloHoops videos!',
      ooyala_master_ad_set: '2b0e8f9115ab481fbf73eadb83bb15a4',
      ooyala_player_id: 'e0798993365348c58b8e71befc2860e6',
      primary_color: '#FF140F',
      privacy_url: 'https://www.flosports.tv/privacy/',
      segment_api_key: 'ZUHcnFn1thW6jxIHzpClKrkH5r7zYsFI',
      site_id: 7,
      site_name: 'FloHoops',
      sport_name: 'Basketball',
      tos_url: 'https://www.flosports.tv/terms-and-conditions/',
      training_videos_name: 'Training',
      twitter_page_url: 'https://twitter.com/flosports',
      youtube_page_url: 'https://www.youtube.com/user/Flocasts',
      gift_url: '/gift'
    }
  ],
  [
    SiteCode.Grappling,
    {
      api_url: 'https://staging-api.flograppling.com',
      california_privacy_url: 'https://www.flosports.tv/california-privacy-policy/',
      careers_url: 'https://www.flosports.tv/work-with-us',
      contact_url: 'https://www.flosports.tv/contact/',
      core_site_url: 'https://staging-public.flograppling.com',
      facebook_app_id: '1474343309552465',
      facebook_page_url: 'https://www.facebook.com/flosports/',
      faq_url: 'https://www.flosports.tv/faq/',
      favicon_url: 'https://d6fm3yzmawlcs.cloudfront.net/favicons/new-favicon/',
      flosports_url: 'https://www.flosports.tv/',
      google_client_id: '423841874240-qd5p69t0u7l3inj0flnrg5p8plmbdmv0.apps.googleusercontent.com',
      instagram_page_url: 'https://www.instagram.com/explore/locations/921189021340396/flosports/',
      meta_articles_page_description:
        'Stay up-to-date on all the news in the FloGrappling world with the latest articles, delivered daily.',
      meta_articles_page_title: 'The most up-to-date FloGrappling news  articles!',
      meta_articles_page_type: 'article',
      meta_default_image: 'https://d6fm3yzmawlcs.cloudfront.net/ogImages/Grappling-1920x1080.jpg',
      meta_default_type: 'website',
      meta_events_entries_page_description: 'Watch  stream FloGrappling live events. Events are our thing. Enjoy',
      meta_events_entries_page_title: 'Watch  stream FloGrappling events.',
      meta_events_entries_page_type: 'events',
      meta_events_news_page_description: 'Watch  stream FloGrappling live events. Events are our thing. Enjoy.',
      meta_events_news_page_title: 'Watch  stream FloGrappling events.',
      meta_events_news_page_type: 'event',
      meta_events_page_description: 'Watch  stream FloGrappling live events. Events are our thing. Enjoy.',
      meta_events_page_title: 'Watch  stream FloGrappling events.',
      meta_events_page_type: 'event',
      meta_events_photo_page_type: 'event',
      meta_events_photos_page_description: 'Watch  stream FloGrappling live events. Events are our thing. Enjoy',
      meta_events_photos_page_title: 'Watch  stream FloGrappling events',
      meta_events_schedule_page_description: 'Watch  stream FloGrappling live events. Events are our thing. Enjoy.',
      meta_events_schedule_page_title: 'Watch  stream FloGrappling events.',
      meta_events_schedule_page_type: 'event',
      meta_events_videos_page_description: 'Watch  stream FloGrappling live events. Events are our thing. Enjoy.',
      meta_events_videos_page_title: 'Watch  stream FloGrappling events.',
      meta_events_videos_page_type: 'event',
      meta_films_page_description: 'Watch Films and Documentaries',
      meta_films_page_title: 'Films and Documentaries',
      meta_home_page_description: 'Get the latest  FloGrappling news, videos,  events. All the info, all the time.',
      meta_home_page_title: 'The latest FloGrappling news  videos!',
      meta_login_page_description:
        'Log in to get the latest FloGrappling news, videos,  events. All the info, all the time.',
      meta_login_page_title: 'Log in now to check out exclusive FloGrappling content!',
      meta_not_found_page_description: 'Page not found for whatever reason!',
      meta_not_found_page_title: 'Page not found',
      meta_pay_page_description: 'Get the latest FloGrappling news, videos,  events. All the info, all the time.',
      meta_pay_page_title: 'Subscribe  get access to the latest FloGrappling news, films, and events!',
      meta_ranking_page_description: "Who's the best of the best? Get current FloGrappling rankings here.",
      meta_ranking_page_title: 'Get the most current FloGrappling rankings!',
      meta_ranking_page_type: 'rankings',
      meta_result_page_description: 'Check out the latest FloGrappling scores, direct  the results headquarters.',
      meta_result_page_title: 'Check out the FloGrappling results!',
      meta_search_page_description: 'Search the latest FloGrappling news, videos,  events. All the info, all the time.',
      meta_search_page_title: 'Search the latest FloGrappling news  videos!',
      meta_signup_page_description: 'Get the latest FloGrappling news, videos,  events. All the info, all the time.',
      meta_signup_page_title: 'Subscribe  get access to the latest FloGrappling news, films, and events!',
      meta_sport_name: 'BJJ',
      meta_training_page_description: 'Watch training and technique videos',
      meta_training_page_title: 'Training and Technique Videos',
      meta_twitter_card_type: 'summary_large_image',
      meta_videos_page_description: 'Watch the latest FloGrappling videos. All videos, all the time.',
      meta_videos_page_page_type: 'video.other',
      meta_videos_page_title: 'Watch the latest FloGrappling videos!',
      ooyala_master_ad_set: 'f74229fd8ad04c158c2041949f3a1c86',
      ooyala_player_id: 'e0798993365348c58b8e71befc2860e6',
      primary_color: '#FF140F',
      privacy_url: 'https://www.flosports.tv/privacy/',
      segment_api_key: 'ZUHcnFn1thW6jxIHzpClKrkH5r7zYsFI',
      site_id: 8,
      site_name: 'FloGrappling',
      sport_name: 'Jiu-Jitsu',
      tos_url: 'https://www.flosports.tv/terms-and-conditions/',
      training_videos_name: 'Training',
      twitter_page_url: 'https://twitter.com/flosports',
      youtube_page_url: 'https://www.youtube.com/user/Flocasts',
      gift_url: '/gift'
    }
  ],
  [
    SiteCode.Cheer,
    {
      api_url: 'https://staging-api.flocheer.com',
      california_privacy_url: 'https://www.flosports.tv/california-privacy-policy/',
      careers_url: 'https://www.flosports.tv/work-with-us',
      contact_url: 'https://www.flosports.tv/contact/',
      core_site_url: 'https://staging-public.flocheer.com',
      facebook_app_id: '176623749339168',
      facebook_page_url: 'https://www.facebook.com/flosports/',
      faq_url: 'https://www.flosports.tv/faq/',
      favicon_url: 'https://d6fm3yzmawlcs.cloudfront.net/favicons/new-favicon/',
      flosports_url: 'https://www.flosports.tv/',
      google_client_id: '838185638796-0hh7dvgjcaaan27iqgek466jfdb5v2op.apps.googleusercontent.com',
      instagram_page_url: 'https://www.instagram.com/explore/locations/921189021340396/flosports/',
      meta_articles_page_description:
        'Stay up-to-date on all the news in the FloCheer world with the latest articles, delivered daily.',
      meta_articles_page_title: 'The most up-to-date FloCheer news  articles!',
      meta_articles_page_type: 'article',
      meta_default_image: 'https://d6fm3yzmawlcs.cloudfront.net/ogImages/Cheer-1920x1080.jpg',
      meta_default_type: 'website',
      meta_events_entries_page_description: 'Watch  stream FloCheer live events. Events are our thing. Enjoy',
      meta_events_entries_page_title: 'Watch  stream FloCheer events.',
      meta_events_entries_page_type: 'events',
      meta_events_news_page_description: 'Watch  stream FloCheer live events. Events are our thing. Enjoy.',
      meta_events_news_page_title: 'Watch  stream FloCheer events.',
      meta_events_news_page_type: 'event',
      meta_events_page_description: 'Watch  stream FloCheer live events. Events are our thing. Enjoy.',
      meta_events_page_title: 'Watch  stream FloCheer events.',
      meta_events_page_type: 'event',
      meta_events_photo_page_type: 'event',
      meta_events_photos_page_description: 'Watch  stream FloCheer live events. Events are our thing. Enjoy',
      meta_events_photos_page_title: 'Watch  stream FloCheer events',
      meta_events_schedule_page_description: 'Watch  stream FloCheer live events. Events are our thing. Enjoy.',
      meta_events_schedule_page_title: 'Watch  stream FloCheer events.',
      meta_events_schedule_page_type: 'event',
      meta_events_videos_page_description: 'Watch  stream FloCheer live events. Events are our thing. Enjoy.',
      meta_events_videos_page_title: 'Watch  stream FloCheer events.',
      meta_events_videos_page_type: 'event',
      meta_films_page_description: 'Watch Films and Documentaries',
      meta_films_page_title: 'Films and Documentaries',
      meta_home_page_description: 'Get the latest  FloCheer news, videos,  events. All the info, all the time.',
      meta_home_page_title: 'The latest FloCheer news  videos!',
      meta_login_page_description:
        'Log in to get the latest FloCheer news, videos,  events. All the info, all the time.',
      meta_login_page_title: 'Log in now to check out exclusive FloCheer content!',
      meta_not_found_page_description: 'Page not found for whatever reason!',
      meta_not_found_page_title: 'Page not found',
      meta_pay_page_description: 'Get the latest FloCheer news, videos,  events. All the info, all the time.',
      meta_pay_page_title: 'Subscribe  get access to the latest FloCheer news, films, and events!',
      meta_ranking_page_description: "Who's the best of the best? Get current FloCheer rankings here.",
      meta_ranking_page_title: 'Get the most current FloCheer rankings!',
      meta_ranking_page_type: 'rankings',
      meta_result_page_description: 'Check out the latest FloCheer scores, direct  the results headquarters.',
      meta_result_page_title: 'Check out the FloCheer results!',
      meta_search_page_description: 'Search the latest FloCheer news, videos,  events. All the info, all the time.',
      meta_search_page_title: 'Search the latest FloCheer news  videos!',
      meta_signup_page_description: 'Get the latest FloCheer news, videos,  events. All the info, all the time.',
      meta_signup_page_title: 'Subscribe  get access to the latest FloCheer news, films, and events!',
      meta_sport_name: 'Competitive cheerleading',
      meta_training_page_description: 'Watch training and technique videos',
      meta_training_page_title: 'Training and Technique Videos',
      meta_twitter_card_type: 'summary_large_image',
      meta_videos_page_description: 'Watch the latest FloCheer videos. All videos, all the time.',
      meta_videos_page_page_type: 'video.other',
      meta_videos_page_title: 'Watch the latest FloCheer videos!',
      ooyala_master_ad_set: '3e7837b972684b8abdca2072ec5af11d',
      ooyala_player_id: 'e0798993365348c58b8e71befc2860e6',
      primary_color: '#FF140F',
      privacy_url: 'https://www.flosports.tv/privacy/',
      segment_api_key: 'ZUHcnFn1thW6jxIHzpClKrkH5r7zYsFI',
      site_id: 10,
      site_name: 'FloCheer',
      sport_name: 'Cheer & Dance',
      tos_url: 'https://www.flosports.tv/terms-and-conditions/',
      training_videos_name: 'Training',
      twitter_page_url: 'https://twitter.com/flosports',
      youtube_page_url: 'https://www.youtube.com/user/Flocasts',
      gift_url: '/gift'
    }
  ],
  [
    SiteCode.Elite,
    {
      api_url: 'https://staging-api.floelite.com',
      california_privacy_url: 'https://www.flosports.tv/california-privacy-policy/',
      careers_url: 'https://www.flosports.tv/work-with-us',
      contact_url: 'https://www.flosports.tv/contact/',
      core_site_url: 'https://staging-public.floelite.com',
      facebook_app_id: '451809041670499',
      facebook_page_url: 'https://www.facebook.com/flosports/',
      faq_url: 'https://www.flosports.tv/faq/',
      favicon_url: 'https://d6fm3yzmawlcs.cloudfront.net/favicons/new-favicon/',
      flosports_url: 'https://www.flosports.tv/',
      google_client_id: '149982521418-5fnfv7rs1dkbea4e3h9b2av30l3d8n94.apps.googleusercontent.com',
      instagram_page_url: 'https://www.instagram.com/explore/locations/921189021340396/flosports/',
      meta_articles_page_description:
        'Stay up-to-date on all the news in the FloElite world with the latest articles, delivered daily.',
      meta_articles_page_title: 'The most up-to-date FloElite news  articles!',
      meta_articles_page_type: 'article',
      meta_default_image: 'https://d6fm3yzmawlcs.cloudfront.net/ogImages/Elite-1920x1080.jpg',
      meta_default_type: 'website',
      meta_events_entries_page_description: 'Watch  stream FloElite live events. Events are our thing. Enjoy',
      meta_events_entries_page_title: 'Watch  stream FloElite events.',
      meta_events_entries_page_type: 'events',
      meta_events_news_page_description: 'Watch  stream FloElite live events. Events are our thing. Enjoy.',
      meta_events_news_page_title: 'Watch  stream FloElite events.',
      meta_events_news_page_type: 'event',
      meta_events_page_description: 'Watch  stream FloElite live events. Events are our thing. Enjoy.',
      meta_events_page_title: 'Watch  stream FloElite events.',
      meta_events_page_type: 'event',
      meta_events_photo_page_type: 'event',
      meta_events_photos_page_description: 'Watch  stream FloElite live events. Events are our thing. Enjoy',
      meta_events_photos_page_title: 'Watch  stream FloElite events',
      meta_events_schedule_page_description: 'Watch  stream FloElite live events. Events are our thing. Enjoy.',
      meta_events_schedule_page_title: 'Watch  stream FloElite events.',
      meta_events_schedule_page_type: 'event',
      meta_events_videos_page_description: 'Watch  stream FloElite live events. Events are our thing. Enjoy.',
      meta_events_videos_page_title: 'Watch  stream FloElite events.',
      meta_events_videos_page_type: 'event',
      meta_films_page_description: 'Watch Films and Documentaries',
      meta_films_page_title: 'Films and Documentaries',
      meta_home_page_description: 'Get the latest  FloElite news, videos,  events. All the info, all the time.',
      meta_home_page_title: 'The latest FloElite news  videos!',
      meta_login_page_description:
        'Log in to get the latest FloElite news, videos,  events. All the info, all the time.',
      meta_login_page_title: 'Log in now to check out exclusive FloElite content!',
      meta_not_found_page_description: 'Page not found for whatever reason!',
      meta_not_found_page_title: 'Page not found',
      meta_pay_page_description: 'Get the latest FloElite news, videos,  events. All the info, all the time.',
      meta_pay_page_title: 'Subscribe  get access to the latest FloElite news, films, and events!',
      meta_ranking_page_description: "Who's the best of the best? Get current FloElite rankings here.",
      meta_ranking_page_title: 'Get the most current FloElite rankings!',
      meta_ranking_page_type: 'rankings',
      meta_result_page_description: 'Check out the latest FloElite scores, direct  the results headquarters.',
      meta_result_page_title: 'Check out the FloElite results!',
      meta_search_page_description: 'Search the latest FloElite news, videos,  events. All the info, all the time.',
      meta_search_page_title: 'Search the latest FloElite news  videos!',
      meta_signup_page_description: 'Get the latest FloElite news, videos,  events. All the info, all the time.',
      meta_signup_page_title: 'Subscribe  get access to the latest FloElite news, films, and events!',
      meta_sport_name: 'crossfit, strongman,  weightlifting',
      meta_training_page_description: 'Watch training and technique videos',
      meta_training_page_title: 'Training and Technique Videos',
      meta_twitter_card_type: 'summary_large_image',
      meta_videos_page_description: 'Watch the latest FloElite videos. All videos, all the time.',
      meta_videos_page_page_type: 'video.other',
      meta_videos_page_title: 'Watch the latest FloElite videos!',
      ooyala_master_ad_set: '240d081332c84a57af7cdffe2839da4d',
      ooyala_player_id: 'e0798993365348c58b8e71befc2860e6',
      primary_color: '#FF140F',
      privacy_url: 'https://www.flosports.tv/privacy/',
      segment_api_key: 'ZUHcnFn1thW6jxIHzpClKrkH5r7zYsFI',
      site_id: 12,
      site_name: 'FloElite',
      sport_name: 'Elite Fitness',
      tos_url: 'https://www.flosports.tv/terms-and-conditions/',
      training_videos_name: 'Training',
      twitter_page_url: 'https://twitter.com/flosports',
      youtube_page_url: 'https://www.youtube.com/user/Flocasts',
      gift_url: '/gift'
    }
  ],
  [
    SiteCode.Universal,
    {
      api_url: 'https://staging-api.flosports.tv',
      california_privacy_url: 'https://www.flosports.tv/california-privacy-policy/',
      careers_url: 'https://www.flosports.tv/work-with-us',
      contact_url: 'https://www.flosports.tv/contact/',
      core_site_url: 'https://staging-public.flosports.tv',
      facebook_app_id: '1980979028801713',
      facebook_page_url: 'https://www.facebook.com/flosports/',
      faq_url: 'https://www.flosports.tv/faq/',
      favicon_url: 'https://dvsfd86tdlcfa.cloudfront.net/assets/2016111719441264/bundles/app/images/floslam/favicon/',
      flosports_url: 'https://www.flosports.tv/',
      google_client_id: null,
      instagram_page_url: 'https://www.instagram.com/explore/locations/921189021340396/flosports/',
      meta_articles_page_description:
        'Stay up-to-date on all the news in the FloSports world with the latest articles, delivered daily.',
      meta_articles_page_title: 'The most up-to-date FloSports news  articles!',
      meta_articles_page_type: 'article',
      meta_default_image: 'http://static-assets.flosports.local/photo/58a1f091d8ff6.png?width=300',
      meta_default_type: 'website',
      meta_events_entries_page_description: 'Watch  stream FloSports live events. Events are our thing. Enjoy',
      meta_events_entries_page_title: 'Watch  stream FloSports events.',
      meta_events_entries_page_type: 'events',
      meta_events_news_page_description: 'Watch  stream FloSports live events. Events are our thing. Enjoy.',
      meta_events_news_page_title: 'Watch  stream FloSports events.',
      meta_events_news_page_type: 'event',
      meta_events_page_description: 'Watch  stream FloSports live events. Events are our thing. Enjoy.',
      meta_events_page_title: 'Watch  stream FloSports events.',
      meta_events_page_type: 'event',
      meta_events_photo_page_type: 'event',
      meta_events_photos_page_description: 'Watch  stream FloSports live events. Events are our thing. Enjoy',
      meta_events_photos_page_title: 'Watch  stream FloSports events',
      meta_events_schedule_page_description: 'Watch  stream FloSports live events. Events are our thing. Enjoy.',
      meta_events_schedule_page_title: 'Watch  stream FloSports events.',
      meta_events_schedule_page_type: 'event',
      meta_events_videos_page_description: 'Watch  stream FloSports live events. Events are our thing. Enjoy.',
      meta_events_videos_page_title: 'Watch  stream FloSports events.',
      meta_events_videos_page_type: 'event',
      meta_films_page_description: 'Watch Films and Documentaries',
      meta_films_page_title: 'Films and Documentaries',
      meta_home_page_description: 'Get the latest  FloSports news, videos,  events. All the info, all the time.',
      meta_home_page_title: 'The latest FloSports news  videos!',
      meta_login_page_description:
        'Log in to get the latest FloSports news, videos,  events. All the info, all the time.',
      meta_login_page_title: 'Log in now to check out exclusive FloSports content!',
      meta_not_found_page_description: 'Page not found for whatever reason!',
      meta_not_found_page_title: 'Page not found',
      meta_pay_page_description: 'Get the latest FloSports news, videos,  events. All the info, all the time.',
      meta_pay_page_title: 'Subscribe  get access to the latest FloSports news, films, and events!',
      meta_ranking_page_description: "Who's the best of the best? Get current FloSports rankings here.",
      meta_ranking_page_title: 'Get the most current FloSports rankings!',
      meta_ranking_page_type: 'rankings',
      meta_result_page_description: 'Check out the latest FloSports scores, direct  the results headquarters.',
      meta_result_page_title: 'Check out the FloSports results!',
      meta_search_page_description: 'Search the latest FloSports news, videos,  events. All the info, all the time.',
      meta_search_page_title: 'Search the latest FloSports news  videos!',
      meta_signup_page_description: 'Get the latest FloSports news, videos,  events. All the info, all the time.',
      meta_signup_page_title: 'Subscribe  get access to the latest FloSports news, films, and events!',
      meta_sport_name: null,
      meta_training_page_description: 'Watch training and technique videos',
      meta_training_page_title: 'Training and Technique Videos',
      meta_twitter_card_type: 'summary_large_image',
      meta_videos_page_description: 'Watch the latest FloSports videos. All videos, all the time.',
      meta_videos_page_page_type: 'video.other',
      meta_videos_page_title: 'Watch the latest FloSports videos!',
      ooyala_master_ad_set: null,
      ooyala_player_id: 'e0798993365348c58b8e71befc2860e6',
      primary_color: '#FF140F',
      privacy_url: 'https://www.flosports.tv/privacy/',
      segment_api_key: 'ZUHcnFn1thW6jxIHzpClKrkH5r7zYsFI',
      site_id: 13,
      site_name: 'FloSports',
      sport_name: null,
      tos_url: 'https://www.flosports.tv/terms-of-service/',
      training_videos_name: 'Training',
      twitter_page_url: 'https://twitter.com/flosports',
      youtube_page_url: 'https://www.youtube.com/user/Flocasts',
      gift_url: '/gift'
    }
  ],
  [
    SiteCode.Softball,
    {
      api_url: 'https://staging-api.flosoftball.com',
      california_privacy_url: 'https://www.flosports.tv/california-privacy-policy/',
      careers_url: 'https://www.flosports.tv/work-with-us',
      contact_url: 'https://www.flosports.tv/contact/',
      core_site_url: 'https://staging-public.flosoftball.com',
      facebook_app_id: '887128328032901',
      facebook_page_url: 'https://www.facebook.com/flosports/',
      faq_url: 'https://www.flosports.tv/faq/',
      favicon_url: 'https://d6fm3yzmawlcs.cloudfront.net/favicons/new-favicon/',
      flosports_url: 'https://www.flosports.tv/',
      google_client_id: '678920541895-mb4oms8btvdj0jf9qqklgeoog48q027a.apps.googleusercontent.com',
      instagram_page_url: 'https://www.instagram.com/explore/locations/921189021340396/flosports/',
      meta_articles_page_description:
        'Stay up-to-date on all the news in the FloSoftball world with the latest articles, delivered daily.',
      meta_articles_page_title: 'The most up-to-date FloSoftball news  articles!',
      meta_articles_page_type: 'article',
      meta_default_image: 'https://d6fm3yzmawlcs.cloudfront.net/ogImages/Softball-1920x1080.jpg',
      meta_default_type: 'website',
      meta_events_entries_page_description: 'Watch  stream FloSoftball live events. Events are our thing. Enjoy',
      meta_events_entries_page_title: 'Watch  stream FloSoftball events.',
      meta_events_entries_page_type: 'events',
      meta_events_news_page_description: 'Watch  stream FloSoftball live events. Events are our thing. Enjoy.',
      meta_events_news_page_title: 'Watch  stream FloSoftball events.',
      meta_events_news_page_type: 'event',
      meta_events_page_description: 'Watch  stream FloSoftball live events. Events are our thing. Enjoy.',
      meta_events_page_title: 'Watch  stream FloSoftball events.',
      meta_events_page_type: 'event',
      meta_events_photo_page_type: 'event',
      meta_events_photos_page_description: 'Watch  stream FloSoftball live events. Events are our thing. Enjoy',
      meta_events_photos_page_title: 'Watch  stream FloSoftball events',
      meta_events_schedule_page_description: 'Watch  stream FloSoftball live events. Events are our thing. Enjoy.',
      meta_events_schedule_page_title: 'Watch  stream FloSoftball events.',
      meta_events_schedule_page_type: 'event',
      meta_events_videos_page_description: 'Watch  stream FloSoftball live events. Events are our thing. Enjoy.',
      meta_events_videos_page_title: 'Watch  stream FloSoftball events.',
      meta_events_videos_page_type: 'event',
      meta_films_page_description: 'Watch Films and Documentaries',
      meta_films_page_title: 'Films and Documentaries',
      meta_home_page_description: 'Get the latest  FloSoftball news, videos,  events. All the info, all the time.',
      meta_home_page_title: 'The latest FloSoftball news  videos!',
      meta_login_page_description:
        'Log in to get the latest FloSoftball news, videos,  events. All the info, all the time.',
      meta_login_page_title: 'Log in now to check out exclusive FloSoftball content!',
      meta_not_found_page_description: 'Page not found for whatever reason!',
      meta_not_found_page_title: 'Page not found',
      meta_pay_page_description: 'Get the latest FloSoftball news, videos,  events. All the info, all the time.',
      meta_pay_page_title: 'Subscribe  get access to the latest FloSoftball news, films, and events!',
      meta_ranking_page_description: "Who's the best of the best? Get current FloSoftball rankings here.",
      meta_ranking_page_title: 'Get the most current FloSoftball rankings!',
      meta_ranking_page_type: 'rankings',
      meta_result_page_description: 'Check out the latest FloSoftball scores, direct  the results headquarters.',
      meta_result_page_title: 'Check out the FloSoftball results!',
      meta_search_page_description: 'Search the latest FloSoftball news, videos,  events. All the info, all the time.',
      meta_search_page_title: 'Search the latest FloSoftball news  videos!',
      meta_signup_page_description: 'Get the latest FloSoftball news, videos,  events. All the info, all the time.',
      meta_signup_page_title: 'Subscribe  get access to the latest FloSoftball news, films, and events!',
      meta_sport_name: 'high school  NCAA softball',
      meta_training_page_description: 'Watch training and technique videos',
      meta_training_page_title: 'Training and Technique Videos',
      meta_twitter_card_type: 'summary_large_image',
      meta_videos_page_description: 'Watch the latest FloSoftball videos. All videos, all the time.',
      meta_videos_page_page_type: 'video.other',
      meta_videos_page_title: 'Watch the latest FloSoftball videos!',
      ooyala_master_ad_set: 'e34d8cd32d294b589cc281585aaadd00',
      ooyala_player_id: 'e0798993365348c58b8e71befc2860e6',
      primary_color: '#FF140F',
      privacy_url: 'https://www.flosports.tv/privacy/',
      segment_api_key: 'ZUHcnFn1thW6jxIHzpClKrkH5r7zYsFI',
      site_id: 14,
      site_name: 'FloSoftball',
      sport_name: 'Softball',
      tos_url: 'https://www.flosports.tv/terms-and-conditions/',
      training_videos_name: 'Training',
      twitter_page_url: 'https://twitter.com/flosports',
      youtube_page_url: 'https://www.youtube.com/user/Flocasts',
      gift_url: '/gift'
    }
  ],
  [
    SiteCode.MileSplit,
    {
      api_url: 'https://staging-api30.milesplit.info',
      california_privacy_url: 'https://www.flosports.tv/california-privacy-policy/',
      careers_url: 'https://www.flosports.tv/work-with-us',
      contact_url: 'https://www.flosports.tv/contact/',
      core_site_url: 'https://staging-accounts-public.milesplit.info',
      facebook_app_id: '261198561567',
      facebook_page_url: 'https://www.facebook.com/flosports/',
      faq_url: 'https://www.flosports.tv/faq/',
      favicon_url: 'https://dvsfd86tdlcfa.cloudfront.net/assets/2016111719441264/bundles/app/images/floslam/favicon/',
      flosports_url: 'https://www.flosports.tv/',
      google_client_id: '350052275552-ehu9s8cabqf0reu65buk0mc0slleaq0t.apps.googleusercontent.com',
      instagram_page_url: 'https://www.instagram.com/explore/locations/921189021340396/flosports/',
      meta_articles_page_description:
        'Stay up-to-date on all the news in the Milesplit world with the latest articles, delivered daily.',
      meta_articles_page_title: 'The most up-to-date Milesplit news &amp; articles!',
      meta_articles_page_type: 'article',
      meta_default_image: 'http://static-assets.flosports.local/photo/58a1f091d8ff6.png?width=300',
      meta_default_type: 'website',
      meta_events_entries_page_description: 'Watch &amp; stream Milesplit live events. Events are our thing. Enjoy',
      meta_events_entries_page_title: 'Watch &amp; stream Milesplit events.',
      meta_events_entries_page_type: 'events',
      meta_events_news_page_description: 'Watch &amp; stream Milesplit live events. Events are our thing. Enjoy.',
      meta_events_news_page_title: 'Watch &amp; stream Milesplit events.',
      meta_events_news_page_type: 'event',
      meta_events_page_description: 'Watch &amp; stream Milesplit live events. Events are our thing. Enjoy.',
      meta_events_page_title: 'Watch &amp; stream Milesplit events.',
      meta_events_page_type: 'event',
      meta_events_photo_page_type: 'event',
      meta_events_photos_page_description: 'Watch &amp; stream Milesplit live events. Events are our thing. Enjoy',
      meta_events_photos_page_title: 'Watch &amp; stream Milesplit events',
      meta_events_schedule_page_description: 'Watch &amp; stream Milesplit live events. Events are our thing. Enjoy.',
      meta_events_schedule_page_title: 'Watch &amp; stream Milesplit events.',
      meta_events_schedule_page_type: 'event',
      meta_events_videos_page_description: 'Watch &amp; stream Milesplit live events. Events are our thing. Enjoy.',
      meta_events_videos_page_title: 'Watch &amp; stream Milesplit events.',
      meta_events_videos_page_type: 'event',
      meta_films_page_description: 'Watch Films and Documentaries',
      meta_films_page_title: 'Films and Documentaries',
      meta_home_page_description: 'Get the latest  Milesplit news, videos, &amp; events. All the info, all the time.',
      meta_home_page_title: 'The latest Milesplit news &amp; videos!',
      meta_login_page_description:
        'Log in to get the latest Milesplit news, videos, &amp; events. All the info, all the time.',
      meta_login_page_title: 'Log in now to check out exclusive Milesplit content!',
      meta_not_found_page_description: 'Page not found for whatever reason!',
      meta_not_found_page_title: 'Page not found',
      meta_pay_page_description: 'Get the latest Milesplit news, videos, &amp; events. All the info, all the time.',
      meta_pay_page_title: 'Subscribe &amp; get access to the latest Milesplit news, films, and events!',
      meta_ranking_page_description: "Who's the best of the best? Get current Milesplit rankings here.",
      meta_ranking_page_title: 'Get the most current Milesplit rankings!',
      meta_ranking_page_type: 'rankings',
      meta_result_page_description: 'Check out the latest Milesplit scores, direct  the results headquarters.',
      meta_result_page_title: 'Check out the Milesplit results!',
      meta_search_page_description:
        'Search the latest Milesplit news, videos, &amp; events. All the info, all the time.',
      meta_search_page_title: 'Search the latest Milesplit news &amp; videos!',
      meta_signup_page_description: 'Get the latest Milesplit news, videos, &amp; events. All the info, all the time.',
      meta_signup_page_title: 'Subscribe &amp; get access to the latest Milesplit news, films, and events!',
      meta_sport_name: null,
      meta_training_page_description: 'Watch training and technique videos',
      meta_training_page_title: 'Training and Technique Videos',
      meta_twitter_card_type: 'summary_large_image',
      meta_videos_page_description: 'Watch the latest Milesplit videos. All videos, all the time.',
      meta_videos_page_page_type: 'video.other',
      meta_videos_page_title: 'Watch the latest Milesplit videos!',
      ooyala_master_ad_set: null,
      ooyala_player_id: 'e0798993365348c58b8e71befc2860e6',
      primary_color: '#C80000',
      privacy_url: 'https://www.flosports.tv/privacy/',
      segment_api_key: 'r90fhunU3ddJmMaXcBYXLtAi2vkJHc5g',
      site_id: 15,
      site_name: 'Milesplit',
      site_styles:
        '.logo .logo-text-mile {fill: #000062;}, .logo .logo-text-split {fill: #c80000;}, .logo.dark .logo-text-mile {fill: #fff;}, .logo.dark .logo-text-split {fill: #fff;}\r\nflo-header { background: #272a2b !important; }\r\n@media (max-width: 992px) { ul li.mobile-menu { background: #c80000; }}',
      sport_name: 'Milesplit',
      tos_url: 'https://www.flosports.tv/terms-and-conditions/',
      training_videos_name: 'Training',
      twitter_page_url: 'https://twitter.com/flosports',
      youtube_page_url: 'https://www.youtube.com/user/Flocasts',
      gift_url: '/gift'
    }
  ],
  [
    SiteCode.Varsity,
    {
      api_url: 'https://staging-admin.varsity.tv',
      brands_privacy_url: 'https://www.varsitybrands.com/privacy-policy/',
      california_privacy_url: 'https://www.flosports.tv/california-privacy-policy/',
      careers_url: 'https://www.flosports.tv/work-with-us',
      contact_url: 'https://www.flosports.tv/varsity-contact/',
      core_site_url: 'https://staging-public.varsity.tv',
      facebook_app_id: '598962243593285',
      facebook_page_url: 'https://www.facebook.com/VarsitySpirit/',
      faq_url: 'https://www.flosports.tv/faq/',
      favicon_url: 'https://d6fm3yzmawlcs.cloudfront.net/favicons/varsity/',
      flosports_url: 'https://www.flosports.tv/',
      google_client_id: '400600143740-fsjuo9rms1caamcnd700gj6b6c8shnhe.apps.googleusercontent.com',
      instagram_page_url: 'https://www.instagram.com/varsityspirit/',
      meta_articles_page_description:
        'Stay up-to-date on all the news in the Varsity world with the latest articles, delivered daily.',
      meta_articles_page_title: 'The most up-to-date Varsity news  articles!',
      meta_articles_page_type: 'article',
      meta_default_image: 'http://static-assets.flosports.local/photo/58a1f091d8ff6.png?width=300',
      meta_default_type: 'website',
      meta_events_entries_page_description: 'Watch  stream Varsity live events. Events are our thing. Enjoy',
      meta_events_entries_page_title: 'Watch  stream Varsity events.',
      meta_events_entries_page_type: 'events',
      meta_events_news_page_description: 'Watch  stream Varsity live events. Events are our thing. Enjoy.',
      meta_events_news_page_title: 'Watch  stream Varsity events.',
      meta_events_news_page_type: 'event',
      meta_events_page_description: 'Watch  stream Varsity live events. Events are our thing. Enjoy.',
      meta_events_page_title: 'Watch  stream Varsity events.',
      meta_events_page_type: 'event',
      meta_events_photo_page_type: 'event',
      meta_events_photos_page_description: 'Watch  stream Varsity live events. Events are our thing. Enjoy',
      meta_events_photos_page_title: 'Watch  stream Varsity events',
      meta_events_schedule_page_description: 'Watch  stream Varsity live events. Events are our thing. Enjoy.',
      meta_events_schedule_page_title: 'Watch  stream Varsity events.',
      meta_events_schedule_page_type: 'event',
      meta_events_videos_page_description: 'Watch  stream Varsity live events. Events are our thing. Enjoy.',
      meta_events_videos_page_title: 'Watch  stream Varsity events.',
      meta_events_videos_page_type: 'event',
      meta_films_page_description: 'Watch Films and Documentaries',
      meta_films_page_title: 'Films and Documentaries',
      meta_home_page_description: 'Get the latest  Varsity news, videos,  events. All the info, all the time.',
      meta_home_page_title: 'The latest Varsity news  videos!',
      meta_login_page_description:
        'Log in to get the latest Varsity news, videos,  events. All the info, all the time.',
      meta_login_page_title: 'Log in now to check out exclusive Varsity content!',
      meta_not_found_page_description: 'Page not found for whatever reason!',
      meta_not_found_page_title: 'Page not found',
      meta_pay_page_description: 'Get the latest Varsity news, videos,  events. All the info, all the time.',
      meta_pay_page_title: 'Subscribe  get access to the latest Varsity news, films, and events!',
      meta_ranking_page_description: "Who's the best of the best? Get current Varsity rankings here.",
      meta_ranking_page_title: 'Get the most current Varsity rankings!',
      meta_ranking_page_type: 'rankings',
      meta_result_page_description: 'Check out the latest Varsity scores, direct  the results headquarters.',
      meta_result_page_title: 'Check out the Varsity results!',
      meta_search_page_description: 'Search the latest Varsity news, videos,  events. All the info, all the time.',
      meta_search_page_title: 'Search the latest Varsity news  videos!',
      meta_signup_page_description: 'Get the latest Varsity news, videos,  events. All the info, all the time.',
      meta_signup_page_title: 'Subscribe  get access to the latest Varsity news, films, and events!',
      meta_sport_name: 'cheerleading',
      meta_training_page_description: 'Watch training and technique videos',
      meta_training_page_title: 'Training and Technique Videos',
      meta_twitter_card_type: 'summary_large_image',
      meta_videos_page_description: 'Watch the latest Varsity videos. All videos, all the time.',
      meta_videos_page_page_type: 'video.other',
      meta_videos_page_title: 'Watch the latest Varsity videos!',
      ooyala_master_ad_set: '23343907bdc244b5a655083f94a4892d',
      ooyala_player_id: 'e0798993365348c58b8e71befc2860e6',
      primary_color: '#247BB8',
      privacy_url: 'https://www.flosports.tv/privacy/',
      segment_api_key: 'ZUHcnFn1thW6jxIHzpClKrkH5r7zYsFI',
      site_id: 20,
      site_name: 'Varsity TV',
      sport_name: 'Cheer & Dance',
      tos_url: 'https://www.flosports.tv/terms-and-conditions/',
      tou_url: 'https://www.varsitybrands.com/terms-of-use/',
      training_videos_name: 'Fitness',
      twitter_page_url: 'https://twitter.com/VarsitySpirit',
      youtube_page_url: 'https://www.youtube.com/user/cheerleadingvideo',
      gift_url: '/gift'
    }
  ],
  [
    SiteCode.Volleyball,
    {
      api_url: 'https://staging-api.flovolleyball.tv',
      california_privacy_url: 'https://www.flosports.tv/california-privacy-policy/',
      careers_url: 'https://www.flosports.tv/work-with-us',
      contact_url: 'https://www.flosports.tv/contact/',
      core_site_url: 'https://staging-public.flovolleyball.tv',
      facebook_app_id: '1572653523024515',
      facebook_page_url: 'https://www.facebook.com/flosports/',
      faq_url: 'https://www.flosports.tv/faq/',
      favicon_url: 'https://d6fm3yzmawlcs.cloudfront.net/favicons/new-favicon/',
      flosports_url: 'https://www.flosports.tv/',
      google_client_id: '431732664053-2podu2e28h8rtbouio4artpppbgkfg9q.apps.googleusercontent.com',
      instagram_page_url: 'https://www.instagram.com/explore/locations/921189021340396/flosports/',
      meta_articles_page_description:
        'Stay up-to-date on all the news in the FloVolleyball world with the latest articles, delivered daily.',
      meta_articles_page_title: 'The most up-to-date FloVolleyball news  articles!',
      meta_articles_page_type: 'article',
      meta_default_image: 'https://d6fm3yzmawlcs.cloudfront.net/ogImages/Volleyball-1920x1080.jpg',
      meta_default_type: 'website',
      meta_events_entries_page_description: 'Watch  stream FloVolleyball live events. Events are our thing. Enjoy',
      meta_events_entries_page_title: 'Watch  stream FloVolleyball events.',
      meta_events_entries_page_type: 'events',
      meta_events_news_page_description: 'Watch  stream FloVolleyball live events. Events are our thing. Enjoy.',
      meta_events_news_page_title: 'Watch  stream FloVolleyball events.',
      meta_events_news_page_type: 'event',
      meta_events_page_description: 'Watch  stream FloVolleyball live events. Events are our thing. Enjoy.',
      meta_events_page_title: 'Watch  stream FloVolleyball events.',
      meta_events_page_type: 'event',
      meta_events_photo_page_type: 'event',
      meta_events_photos_page_description: 'Watch  stream FloVolleyball live events. Events are our thing. Enjoy',
      meta_events_photos_page_title: 'Watch  stream FloVolleyball events',
      meta_events_schedule_page_description: 'Watch  stream FloVolleyball live events. Events are our thing. Enjoy.',
      meta_events_schedule_page_title: 'Watch  stream FloVolleyball events.',
      meta_events_schedule_page_type: 'event',
      meta_events_videos_page_description: 'Watch  stream FloVolleyball live events. Events are our thing. Enjoy.',
      meta_events_videos_page_title: 'Watch  stream FloVolleyball events.',
      meta_events_videos_page_type: 'event',
      meta_films_page_description: 'Watch Films and Documentaries',
      meta_films_page_title: 'Films and Documentaries',
      meta_home_page_description: 'Get the latest  FloVolleyball news, videos,  events. All the info, all the time.',
      meta_home_page_title: 'The latest FloVolleyball news  videos!',
      meta_login_page_description:
        'Log in to get the latest FloVolleyball news, videos,  events. All the info, all the time.',
      meta_login_page_title: 'Log in now to check out exclusive FloVolleyball content!',
      meta_not_found_page_description: 'Page not found for whatever reason!',
      meta_not_found_page_title: 'Page not found',
      meta_pay_page_description: 'Get the latest FloVolleyball news, videos,  events. All the info, all the time.',
      meta_pay_page_title: 'Subscribe  get access to the latest FloVolleyball news, films, and events!',
      meta_ranking_page_description: "Who's the best of the best? Get current FloVolleyball rankings here.",
      meta_ranking_page_title: 'Get the most current FloVolleyball rankings!',
      meta_ranking_page_type: 'rankings',
      meta_result_page_description: 'Check out the latest FloVolleyball scores, direct  the results headquarters.',
      meta_result_page_title: 'Check out the FloVolleyball results!',
      meta_search_page_description:
        'Search the latest FloVolleyball news, videos,  events. All the info, all the time.',
      meta_search_page_title: 'Search the latest FloVolleyball news  videos!',
      meta_signup_page_description: 'Get the latest FloVolleyball news, videos,  events. All the info, all the time.',
      meta_signup_page_title: 'Subscribe  get access to the latest FloVolleyball news, films, and events!',
      meta_sport_name: 'college  professional volleyball',
      meta_training_page_description: 'Watch training and technique videos',
      meta_training_page_title: 'Training and Technique Videos',
      meta_twitter_card_type: 'summary_large_image',
      meta_videos_page_description: 'Watch the latest FloVolleyball videos. All videos, all the time.',
      meta_videos_page_page_type: 'video.other',
      meta_videos_page_title: 'Watch the latest FloVolleyball videos!',
      ooyala_master_ad_set: 'fee8ba33c28c4f439df6739c7f65a891',
      ooyala_player_id: 'e0798993365348c58b8e71befc2860e6',
      primary_color: '#FF140F',
      privacy_url: 'https://www.flosports.tv/privacy/',
      segment_api_key: 'ZUHcnFn1thW6jxIHzpClKrkH5r7zYsFI',
      site_id: 22,
      site_name: 'FloVolleyball',
      sport_name: 'Volleyball',
      tos_url: 'https://www.flosports.tv/terms-and-conditions/',
      training_videos_name: 'Training',
      twitter_page_url: 'https://twitter.com/flosports',
      youtube_page_url: 'https://www.youtube.com/user/Flocasts',
      gift_url: '/gift'
    }
  ],
  [
    SiteCode.Combat,
    {
      api_url: 'https://staging-api.flocombat.com',
      california_privacy_url: 'https://www.flosports.tv/california-privacy-policy/',
      careers_url: 'https://www.flosports.tv/work-with-us',
      contact_url: 'https://www.flosports.tv/contact/',
      core_site_url: 'https://staging-public.flocombat.com',
      facebook_app_id: '483947368455753',
      facebook_page_url: 'https://www.facebook.com/flosports/',
      faq_url: 'https://www.flosports.tv/faq/',
      favicon_url: 'https://d6fm3yzmawlcs.cloudfront.net/favicons/new-favicon/',
      flosports_url: 'https://www.flosports.tv/',
      google_client_id: '705505072565-jlltvdpq3iq7ro6omt3a7t5erd7bp59a.apps.googleusercontent.com',
      instagram_page_url: 'https://www.instagram.com/explore/locations/921189021340396/flosports/',
      meta_articles_page_description:
        'Stay up-to-date on all the news in the FloCombat world with the latest articles, delivered daily.',
      meta_articles_page_title: 'The most up-to-date FloCombat news  articles!',
      meta_articles_page_type: 'article',
      meta_default_image: 'https://d6fm3yzmawlcs.cloudfront.net/ogImages/Combat-1920x1080.jpg',
      meta_default_type: 'website',
      meta_events_entries_page_description: 'Watch  stream FloCombat live events. Events are our thing. Enjoy',
      meta_events_entries_page_title: 'Watch  stream FloCombat events.',
      meta_events_entries_page_type: 'events',
      meta_events_news_page_description: 'Watch  stream FloCombat live events. Events are our thing. Enjoy.',
      meta_events_news_page_title: 'Watch  stream FloCombat events.',
      meta_events_news_page_type: 'event',
      meta_events_page_description: 'Watch  stream FloCombat live events. Events are our thing. Enjoy.',
      meta_events_page_title: 'Watch  stream FloCombat events.',
      meta_events_page_type: 'event',
      meta_events_photo_page_type: 'event',
      meta_events_photos_page_description: 'Watch  stream FloCombat live events. Events are our thing. Enjoy',
      meta_events_photos_page_title: 'Watch  stream FloCombat events',
      meta_events_schedule_page_description: 'Watch  stream FloCombat live events. Events are our thing. Enjoy.',
      meta_events_schedule_page_title: 'Watch  stream FloCombat events.',
      meta_events_schedule_page_type: 'event',
      meta_events_videos_page_description: 'Watch  stream FloCombat live events. Events are our thing. Enjoy.',
      meta_events_videos_page_title: 'Watch  stream FloCombat events.',
      meta_events_videos_page_type: 'event',
      meta_films_page_description: 'Watch Films and Documentaries',
      meta_films_page_title: 'Films and Documentaries',
      meta_home_page_description: 'Get the latest  FloCombat news, videos,  events. All the info, all the time.',
      meta_home_page_title: 'The latest FloCombat news  videos!',
      meta_login_page_description:
        'Log in to get the latest FloCombat news, videos,  events. All the info, all the time.',
      meta_login_page_title: 'Log in now to check out exclusive FloCombat content!',
      meta_not_found_page_description: 'Page not found for whatever reason!',
      meta_not_found_page_title: 'Page not found',
      meta_pay_page_description: 'Get the latest FloCombat news, videos,  events. All the info, all the time.',
      meta_pay_page_title: 'Subscribe  get access to the latest FloCombat news, films, and events!',
      meta_ranking_page_description: "Who's the best of the best? Get current FloCombat rankings here.",
      meta_ranking_page_title: 'Get the most current FloCombat rankings!',
      meta_ranking_page_type: 'rankings',
      meta_result_page_description: 'Check out the latest FloCombat scores, direct  the results headquarters.',
      meta_result_page_title: 'Check out the FloCombat results!',
      meta_search_page_description: 'Search the latest FloCombat news, videos,  events. All the info, all the time.',
      meta_search_page_title: 'Search the latest FloCombat news  videos!',
      meta_signup_page_description: 'Get the latest FloCombat news, videos,  events. All the info, all the time.',
      meta_signup_page_title: 'Subscribe  get access to the latest FloCombat news, films, and events!',
      meta_sport_name: 'professional MMA',
      meta_training_page_description: 'Watch training and technique videos',
      meta_training_page_title: 'Training and Technique Videos',
      meta_twitter_card_type: 'summary_large_image',
      meta_videos_page_description: 'Watch the latest FloCombat videos. All videos, all the time.',
      meta_videos_page_page_type: 'video.other',
      meta_videos_page_title: 'Watch the latest FloCombat videos!',
      ooyala_master_ad_set: '30c2b366f5fd4bf5834830793f293d24',
      ooyala_player_id: 'e0798993365348c58b8e71befc2860e6',
      primary_color: '#FF140F',
      privacy_url: 'https://www.flosports.tv/privacy/',
      segment_api_key: 'ZUHcnFn1thW6jxIHzpClKrkH5r7zYsFI',
      site_id: 23,
      site_name: 'FloCombat',
      sport_name: 'MMA',
      tos_url: 'https://www.flosports.tv/terms-and-conditions/',
      training_videos_name: 'Training',
      twitter_page_url: 'https://twitter.com/flosports',
      youtube_page_url: 'https://www.youtube.com/user/Flocasts',
      gift_url: '/gift'
    }
  ],
  [
    SiteCode.Marching,
    {
      api_url: 'https://staging-api.flomarching.com',
      california_privacy_url: 'https://www.flosports.tv/california-privacy-policy/',
      careers_url: 'https://www.flosports.tv/work-with-us',
      contact_url: 'https://www.flosports.tv/contact/',
      core_site_url: 'https://staging-public.flomarching.com',
      facebook_app_id: '259161254470922',
      facebook_page_url: 'https://www.facebook.com/flosports/',
      faq_url: 'https://www.flosports.tv/faq/',
      favicon_url: 'https://d6fm3yzmawlcs.cloudfront.net/favicons/new-favicon/',
      flosports_url: 'https://www.flosports.tv/',
      google_client_id: '941286239586-u9vdjj3otg53v36j1jms7bqmup4jekjg.apps.googleusercontent.com',
      instagram_page_url: 'https://www.instagram.com/explore/locations/921189021340396/flosports/',
      meta_articles_page_description:
        'Stay up-to-date on all the news in the FloMarching world with the latest articles, delivered daily.',
      meta_articles_page_title: 'The most up-to-date FloMarching news  articles!',
      meta_articles_page_type: 'article',
      meta_default_image: 'https://d6fm3yzmawlcs.cloudfront.net/ogImages/Marching-1920x1080.jpg',
      meta_default_type: 'website',
      meta_events_entries_page_description: 'Watch  stream FloMarching live events. Events are our thing. Enjoy',
      meta_events_entries_page_title: 'Watch  stream FloMarching events.',
      meta_events_entries_page_type: 'events',
      meta_events_news_page_description: 'Watch  stream FloMarching live events. Events are our thing. Enjoy.',
      meta_events_news_page_title: 'Watch  stream FloMarching events.',
      meta_events_news_page_type: 'event',
      meta_events_page_description: 'Watch  stream FloMarching live events. Events are our thing. Enjoy.',
      meta_events_page_title: 'Watch  stream FloMarching events.',
      meta_events_page_type: 'event',
      meta_events_photo_page_type: 'event',
      meta_events_photos_page_description: 'Watch  stream FloMarching live events. Events are our thing. Enjoy',
      meta_events_photos_page_title: 'Watch  stream FloMarching events',
      meta_events_schedule_page_description: 'Watch  stream FloMarching live events. Events are our thing. Enjoy.',
      meta_events_schedule_page_title: 'Watch  stream FloMarching events.',
      meta_events_schedule_page_type: 'event',
      meta_events_videos_page_description: 'Watch  stream FloMarching live events. Events are our thing. Enjoy.',
      meta_events_videos_page_title: 'Watch  stream FloMarching events.',
      meta_events_videos_page_type: 'event',
      meta_films_page_description: 'Watch Films and Documentaries',
      meta_films_page_title: 'Films and Documentaries',
      meta_home_page_description: 'Get the latest  FloMarching news, videos,  events. All the info, all the time.',
      meta_home_page_title: 'The latest FloMarching news  videos!',
      meta_login_page_description:
        'Log in to get the latest FloMarching news, videos,  events. All the info, all the time.',
      meta_login_page_title: 'Log in now to check out exclusive FloMarching content!',
      meta_not_found_page_description: 'Page not found for whatever reason!',
      meta_not_found_page_title: 'Page not found',
      meta_pay_page_description: 'Get the latest FloMarching news, videos,  events. All the info, all the time.',
      meta_pay_page_title: 'Subscribe  get access to the latest FloMarching news, films, and events!',
      meta_ranking_page_description: "Who's the best of the best? Get current FloMarching rankings here.",
      meta_ranking_page_title: 'Get the most current FloMarching rankings!',
      meta_ranking_page_type: 'rankings',
      meta_result_page_description: 'Check out the latest FloMarching scores, direct  the results headquarters.',
      meta_result_page_title: 'Check out the FloMarching results!',
      meta_search_page_description: 'Search the latest FloMarching news, videos,  events. All the info, all the time.',
      meta_search_page_title: 'Search the latest FloMarching news  videos!',
      meta_signup_page_description: 'Get the latest FloMarching news, videos,  events. All the info, all the time.',
      meta_signup_page_title: 'Subscribe  get access to the latest FloMarching news, films, and events!',
      meta_sport_name: 'high school  professional marching band',
      meta_training_page_description: 'Watch training and technique videos',
      meta_training_page_title: 'Training and Technique Videos',
      meta_twitter_card_type: 'summary_large_image',
      meta_videos_page_description: 'Watch the latest FloMarching videos. All videos, all the time.',
      meta_videos_page_page_type: 'video.other',
      meta_videos_page_title: 'Watch the latest FloMarching videos!',
      ooyala_master_ad_set: '62a1fbc5a4094c47a696f6e71f00bd1f',
      ooyala_player_id: 'e0798993365348c58b8e71befc2860e6',
      primary_color: '#FF140F',
      privacy_url: 'https://www.flosports.tv/privacy/',
      segment_api_key: 'ZUHcnFn1thW6jxIHzpClKrkH5r7zYsFI',
      site_id: 27,
      site_name: 'FloMarching',
      sport_name: 'Marching Arts',
      tos_url: 'https://www.flosports.tv/terms-and-conditions/',
      training_videos_name: 'Training',
      twitter_page_url: 'https://twitter.com/flosports',
      youtube_page_url: 'https://www.youtube.com/user/Flocasts',
      gift_url: '/gift'
    }
  ],
  [
    SiteCode.Swimming,
    {
      api_url: 'https://staging-api.floswimming.com',
      california_privacy_url: 'https://www.flosports.tv/california-privacy-policy/',
      careers_url: 'https://www.flosports.tv/work-with-us',
      contact_url: 'https://www.flosports.tv/contact/',
      core_site_url: 'https://staging-public.floswimming.com',
      facebook_app_id: '1166020863454883',
      facebook_page_url: 'https://www.facebook.com/flosports/',
      faq_url: 'https://www.flosports.tv/faq/',
      favicon_url: 'https://d6fm3yzmawlcs.cloudfront.net/favicons/new-favicon/',
      flosports_url: 'https://www.flosports.tv/',
      google_client_id: '76562558908-nhk4mf8cmlc44qgcrc7icq68008cfr0i.apps.googleusercontent.com',
      instagram_page_url: 'https://www.instagram.com/explore/locations/921189021340396/flosports/',
      meta_articles_page_description:
        'Stay up-to-date on all the news in the FloSwimming world with the latest articles, delivered daily.',
      meta_articles_page_title: 'The most up-to-date FloSwimming news  articles!',
      meta_articles_page_type: 'article',
      meta_default_image: 'https://d6fm3yzmawlcs.cloudfront.net/ogImages/Swimming-1920x1080.jpg',
      meta_default_type: 'website',
      meta_events_entries_page_description: 'Watch  stream FloSwimming live events. Events are our thing. Enjoy',
      meta_events_entries_page_title: 'Watch  stream FloSwimming events.',
      meta_events_entries_page_type: 'events',
      meta_events_news_page_description: 'Watch  stream FloSwimming live events. Events are our thing. Enjoy.',
      meta_events_news_page_title: 'Watch  stream FloSwimming events.',
      meta_events_news_page_type: 'event',
      meta_events_page_description: 'Watch  stream FloSwimming live events. Events are our thing. Enjoy.',
      meta_events_page_title: 'Watch  stream FloSwimming events.',
      meta_events_page_type: 'event',
      meta_events_photo_page_type: 'event',
      meta_events_photos_page_description: 'Watch  stream FloSwimming live events. Events are our thing. Enjoy',
      meta_events_photos_page_title: 'Watch  stream FloSwimming events',
      meta_events_schedule_page_description: 'Watch  stream FloSwimming live events. Events are our thing. Enjoy.',
      meta_events_schedule_page_title: 'Watch  stream FloSwimming events.',
      meta_events_schedule_page_type: 'event',
      meta_events_videos_page_description: 'Watch  stream FloSwimming live events. Events are our thing. Enjoy.',
      meta_events_videos_page_title: 'Watch  stream FloSwimming events.',
      meta_events_videos_page_type: 'event',
      meta_films_page_description: 'Watch Films and Documentaries',
      meta_films_page_title: 'Films and Documentaries',
      meta_home_page_description: 'Get the latest  FloSwimming news, videos,  events. All the info, all the time.',
      meta_home_page_title: 'The latest FloSwimming news  videos!',
      meta_login_page_description:
        'Log in to get the latest FloSwimming news, videos,  events. All the info, all the time.',
      meta_login_page_title: 'Log in now to check out exclusive FloSwimming content!',
      meta_not_found_page_description: 'Page not found for whatever reason!',
      meta_not_found_page_title: 'Page not found',
      meta_pay_page_description: 'Get the latest FloSwimming news, videos,  events. All the info, all the time.',
      meta_pay_page_title: 'Subscribe  get access to the latest FloSwimming news, films, and events!',
      meta_ranking_page_description: "Who's the best of the best? Get current FloSwimming rankings here.",
      meta_ranking_page_title: 'Get the most current FloSwimming rankings!',
      meta_ranking_page_type: 'rankings',
      meta_result_page_description: 'Check out the latest FloSwimming scores, direct  the results headquarters.',
      meta_result_page_title: 'Check out the FloSwimming results!',
      meta_search_page_description: 'Search the latest FloSwimming news, videos,  events. All the info, all the time.',
      meta_search_page_title: 'Search the latest FloSwimming news  videos!',
      meta_signup_page_description: 'Get the latest FloSwimming news, videos,  events. All the info, all the time.',
      meta_signup_page_title: 'Subscribe  get access to the latest FloSwimming news, films, and events!',
      meta_sport_name: 'college  professional swimming',
      meta_training_page_description: 'Watch training and technique videos',
      meta_training_page_title: 'Training and Technique Videos',
      meta_twitter_card_type: 'summary_large_image',
      meta_videos_page_description: 'Watch the latest FloSwimming videos. All videos, all the time.',
      meta_videos_page_page_type: 'video.other',
      meta_videos_page_title: 'Watch the latest FloSwimming videos!',
      ooyala_master_ad_set: 'cccd83ca586049218519c79e692d7592',
      ooyala_player_id: 'e0798993365348c58b8e71befc2860e6',
      primary_color: '#FF140F',
      privacy_url: 'https://www.flosports.tv/privacy/',
      segment_api_key: 'ZUHcnFn1thW6jxIHzpClKrkH5r7zYsFI',
      site_id: 28,
      site_name: 'FloSwimming',
      sport_name: 'Swimming',
      tos_url: 'https://www.flosports.tv/terms-and-conditions/',
      training_videos_name: 'Training',
      twitter_page_url: 'https://twitter.com/flosports',
      youtube_page_url: 'https://www.youtube.com/user/Flocasts',
      gift_url: '/gift'
    }
  ],
  [
    SiteCode.Hockey,
    {
      api_url: 'https://staging-api.flohockey.tv',
      california_privacy_url: 'https://www.flosports.tv/california-privacy-policy/',
      careers_url: 'https://www.flosports.tv/work-with-us',
      contact_url: 'https://www.flosports.tv/contact/',
      core_site_url: 'https://staging-public.flohockey.tv',
      facebook_app_id: '1191164334233126',
      facebook_page_url: 'https://www.facebook.com/flosports/',
      faq_url: 'https://www.flosports.tv/faq/',
      favicon_url: 'https://d6fm3yzmawlcs.cloudfront.net/favicons/new-favicon/',
      flosports_url: 'https://www.flosports.tv/',
      google_client_id: '360147687037-ca8i2nmmfp9ouh3b2glrch546fr49v7g.apps.googleusercontent.com',
      instagram_page_url: 'https://www.instagram.com/explore/locations/921189021340396/flosports/',
      meta_articles_page_description:
        'Stay up-to-date on all the news in the FloHockey world with the latest articles, delivered daily.',
      meta_articles_page_title: 'The most up-to-date FloHockey news  articles!',
      meta_articles_page_type: 'article',
      meta_default_image: 'https://d6fm3yzmawlcs.cloudfront.net/ogImages/Hockey-1920x1080.jpg',
      meta_default_type: 'website',
      meta_events_entries_page_description: 'Watch  stream FloHockey live events. Events are our thing. Enjoy',
      meta_events_entries_page_title: 'Watch  stream FloHockey events.',
      meta_events_entries_page_type: 'events',
      meta_events_news_page_description: 'Watch  stream FloHockey live events. Events are our thing. Enjoy.',
      meta_events_news_page_title: 'Watch  stream FloHockey events.',
      meta_events_news_page_type: 'event',
      meta_events_page_description: 'Watch  stream FloHockey live events. Events are our thing. Enjoy.',
      meta_events_page_title: 'Watch  stream FloHockey events.',
      meta_events_page_type: 'event',
      meta_events_photo_page_type: 'event',
      meta_events_photos_page_description: 'Watch  stream FloHockey live events. Events are our thing. Enjoy',
      meta_events_photos_page_title: 'Watch  stream FloHockey events',
      meta_events_schedule_page_description: 'Watch  stream FloHockey live events. Events are our thing. Enjoy.',
      meta_events_schedule_page_title: 'Watch  stream FloHockey events.',
      meta_events_schedule_page_type: 'event',
      meta_events_videos_page_description: 'Watch  stream FloHockey live events. Events are our thing. Enjoy.',
      meta_events_videos_page_title: 'Watch  stream FloHockey events.',
      meta_events_videos_page_type: 'event',
      meta_films_page_description: 'Watch Films and Documentaries',
      meta_films_page_title: 'Films and Documentaries',
      meta_home_page_description: 'Get the latest  FloHockey news, videos,  events. All the info, all the time.',
      meta_home_page_title: 'The latest FloHockey news  videos!',
      meta_login_page_description:
        'Log in to get the latest FloHockey news, videos,  events. All the info, all the time.',
      meta_login_page_title: 'Log in now to check out exclusive FloHockey content!',
      meta_not_found_page_description: 'Page not found for whatever reason!',
      meta_not_found_page_title: 'Page not found',
      meta_pay_page_description: 'Get the latest FloHockey news, videos,  events. All the info, all the time.',
      meta_pay_page_title: 'Subscribe  get access to the latest FloHockey news, films, and events!',
      meta_ranking_page_description: "Who's the best of the best? Get current FloHockey rankings here.",
      meta_ranking_page_title: 'Get the most current FloHockey rankings!',
      meta_ranking_page_type: 'rankings',
      meta_result_page_description: 'Check out the latest FloHockey scores, direct  the results headquarters.',
      meta_result_page_title: 'Check out the FloHockey results!',
      meta_search_page_description: 'Search the latest FloHockey news, videos,  events. All the info, all the time.',
      meta_search_page_title: 'Search the latest FloHockey news  videos!',
      meta_signup_page_description: 'Get the latest FloHockey news, videos,  events. All the info, all the time.',
      meta_signup_page_title: 'Subscribe  get access to the latest FloHockey news, films, and events!',
      meta_sport_name: 'junior, college,  professional hockey',
      meta_training_page_description: 'Watch training and technique videos',
      meta_training_page_title: 'Training and Technique Videos',
      meta_twitter_card_type: 'summary_large_image',
      meta_videos_page_description: 'Watch the latest FloHockey videos. All videos, all the time.',
      meta_videos_page_page_type: 'video.other',
      meta_videos_page_title: 'Watch the latest FloHockey videos!',
      ooyala_master_ad_set: 'b9abf59d0fbc465984ba5b6455440ac1',
      ooyala_player_id: 'e0798993365348c58b8e71befc2860e6',
      primary_color: '#FF140F',
      privacy_url: 'https://www.flosports.tv/privacy/',
      segment_api_key: 'ZUHcnFn1thW6jxIHzpClKrkH5r7zYsFI',
      site_id: 29,
      site_name: 'FloHockey',
      sport_name: 'Hockey',
      tos_url: 'https://www.flosports.tv/terms-and-conditions/',
      training_videos_name: 'Training',
      twitter_page_url: 'https://twitter.com/flosports',
      youtube_page_url: 'https://www.youtube.com/user/Flocasts',
      gift_url: '/gift'
    }
  ],
  [
    SiteCode.Rodeo,
    {
      api_url: 'https://staging-api.florodeo.com',
      california_privacy_url: 'https://www.flosports.tv/california-privacy-policy/',
      careers_url: 'https://www.flosports.tv/work-with-us',
      contact_url: 'https://www.flosports.tv/contact/',
      core_site_url: 'https://staging-public.florodeo.com',
      facebook_app_id: '180180222319059',
      facebook_page_url: 'https://www.facebook.com/flosports/',
      faq_url: 'https://www.flosports.tv/faq/',
      favicon_url: 'https://d6fm3yzmawlcs.cloudfront.net/favicons/new-favicon/',
      flosports_url: 'https://www.flosports.tv/',
      google_client_id: '801064030168-e854jvo0r8hc5s8dbi5eld6mdojbi1kh.apps.googleusercontent.com',
      instagram_page_url: 'https://www.instagram.com/explore/locations/921189021340396/flosports/',
      meta_articles_page_description:
        'Stay up-to-date on all the news in the FloRodeo world with the latest articles, delivered daily.',
      meta_articles_page_title: 'The most up-to-date FloRodeo news  articles!',
      meta_articles_page_type: 'article',
      meta_default_image: 'https://d6fm3yzmawlcs.cloudfront.net/ogImages/Rodeo-1920x1080.jpg',
      meta_default_type: 'website',
      meta_events_entries_page_description: 'Watch  stream FloRodeo live events. Events are our thing. Enjoy',
      meta_events_entries_page_title: 'Watch  stream FloRodeo events.',
      meta_events_entries_page_type: 'events',
      meta_events_news_page_description: 'Watch  stream FloRodeo live events. Events are our thing. Enjoy.',
      meta_events_news_page_title: 'Watch  stream FloRodeo events.',
      meta_events_news_page_type: 'event',
      meta_events_page_description: 'Watch  stream FloRodeo live events. Events are our thing. Enjoy.',
      meta_events_page_title: 'Watch  stream FloRodeo events.',
      meta_events_page_type: 'event',
      meta_events_photo_page_type: 'event',
      meta_events_photos_page_description: 'Watch  stream FloRodeo live events. Events are our thing. Enjoy',
      meta_events_photos_page_title: 'Watch  stream FloRodeo events',
      meta_events_schedule_page_description: 'Watch  stream FloRodeo live events. Events are our thing. Enjoy.',
      meta_events_schedule_page_title: 'Watch  stream FloRodeo events.',
      meta_events_schedule_page_type: 'event',
      meta_events_videos_page_description: 'Watch  stream FloRodeo live events. Events are our thing. Enjoy.',
      meta_events_videos_page_title: 'Watch  stream FloRodeo events.',
      meta_events_videos_page_type: 'event',
      meta_films_page_description: 'Watch Films and Documentaries',
      meta_films_page_title: 'Films and Documentaries',
      meta_home_page_description: 'Get the latest  FloRodeo news, videos,  events. All the info, all the time.',
      meta_home_page_title: 'The latest FloRodeo news  videos!',
      meta_login_page_description:
        'Log in to get the latest FloRodeo news, videos,  events. All the info, all the time.',
      meta_login_page_title: 'Log in now to check out exclusive FloRodeo content!',
      meta_not_found_page_description: 'Page not found for whatever reason!',
      meta_not_found_page_title: 'Page not found',
      meta_pay_page_description: 'Get the latest FloRodeo news, videos,  events. All the info, all the time.',
      meta_pay_page_title: 'Subscribe  get access to the latest FloRodeo news, films, and events!',
      meta_ranking_page_description: "Who's the best of the best? Get current FloRodeo rankings here.",
      meta_ranking_page_title: 'Get the most current FloRodeo rankings!',
      meta_ranking_page_type: 'rankings',
      meta_result_page_description: 'Check out the latest FloRodeo scores, direct  the results headquarters.',
      meta_result_page_title: 'Check out the FloRodeo results!',
      meta_search_page_description: 'Search the latest FloRodeo news, videos,  events. All the info, all the time.',
      meta_search_page_title: 'Search the latest FloRodeo news  videos!',
      meta_signup_page_description: 'Get the latest FloRodeo news, videos,  events. All the info, all the time.',
      meta_signup_page_title: 'Subscribe  get access to the latest FloRodeo news, films, and events!',
      meta_sport_name: 'youth  professional rodeo',
      meta_training_page_description: 'Watch training and technique videos',
      meta_training_page_title: 'Training and Technique Videos',
      meta_twitter_card_type: 'summary_large_image',
      meta_videos_page_description: 'Watch the latest FloRodeo videos. All videos, all the time.',
      meta_videos_page_page_type: 'video.other',
      meta_videos_page_title: 'Watch the latest FloRodeo videos!',
      ooyala_master_ad_set: '791b18ea9ebe4c99ae39bfa16d6022de',
      ooyala_player_id: 'e0798993365348c58b8e71befc2860e6',
      primary_color: '#FF140F',
      privacy_url: 'https://www.flosports.tv/privacy/',
      segment_api_key: 'ZUHcnFn1thW6jxIHzpClKrkH5r7zYsFI',
      site_id: 30,
      site_name: 'FloRodeo',
      sport_name: 'Rodeo',
      tos_url: 'https://www.flosports.tv/terms-and-conditions/',
      training_videos_name: 'Training',
      twitter_page_url: 'https://twitter.com/flosports',
      youtube_page_url: 'https://www.youtube.com/user/Flocasts',
      gift_url: '/gift'
    }
  ],
  [
    SiteCode.Racing,
    {
      api_url: 'https://staging-api.floracing.com',
      california_privacy_url: 'https://www.flosports.tv/california-privacy-policy/',
      careers_url: 'https://www.flosports.tv/work-with-us',
      contact_url: 'https://www.flosports.tv/contact/',
      core_site_url: 'https://staging-public.floracing.com',
      facebook_app_id: '1872171863058252',
      facebook_page_url: 'https://www.facebook.com/flosports/',
      faq_url: 'https://www.flosports.tv/faq/',
      favicon_url: 'https://d6fm3yzmawlcs.cloudfront.net/favicons/new-favicon/',
      flosports_url: 'https://www.flosports.tv/',
      google_client_id: '658742238972-2l7tr5jhuo1is7cn7vhkqot1ep7u571t.apps.googleusercontent.com',
      instagram_page_url: 'https://www.instagram.com/explore/locations/921189021340396/flosports/',
      meta_articles_page_description:
        'Stay up-to-date on all the news in the FloRacing world with the latest articles, delivered daily.',
      meta_articles_page_title: 'The most up-to-date FloRacing news  articles!',
      meta_articles_page_type: 'article',
      meta_default_image: 'https://d6fm3yzmawlcs.cloudfront.net/ogImages/Racing-1920x1080.jpg',
      meta_default_type: 'website',
      meta_events_entries_page_description: 'Watch  stream FloRacing live events. Events are our thing. Enjoy',
      meta_events_entries_page_title: 'Watch  stream FloRacing events.',
      meta_events_entries_page_type: 'events',
      meta_events_news_page_description: 'Watch  stream FloRacing live events. Events are our thing. Enjoy.',
      meta_events_news_page_title: 'Watch  stream FloRacing events.',
      meta_events_news_page_type: 'event',
      meta_events_page_description: 'Watch  stream FloRacing live events. Events are our thing. Enjoy.',
      meta_events_page_title: 'Watch  stream FloRacing events.',
      meta_events_page_type: 'event',
      meta_events_photo_page_type: 'event',
      meta_events_photos_page_description: 'Watch  stream FloRacing live events. Events are our thing. Enjoy',
      meta_events_photos_page_title: 'Watch  stream FloRacing events',
      meta_events_schedule_page_description: 'Watch  stream FloRacing live events. Events are our thing. Enjoy.',
      meta_events_schedule_page_title: 'Watch  stream FloRacing events.',
      meta_events_schedule_page_type: 'event',
      meta_events_videos_page_description: 'Watch  stream FloRacing live events. Events are our thing. Enjoy.',
      meta_events_videos_page_title: 'Watch  stream FloRacing events.',
      meta_events_videos_page_type: 'event',
      meta_films_page_description: 'Watch Films and Documentaries',
      meta_films_page_title: 'Films and Documentaries',
      meta_home_page_description: 'Get the latest  FloRacing news, videos,  events. All the info, all the time.',
      meta_home_page_title: 'The latest FloRacing news  videos!',
      meta_login_page_description:
        'Log in to get the latest FloRacing news, videos,  events. All the info, all the time.',
      meta_login_page_title: 'Log in now to check out exclusive FloRacing content!',
      meta_not_found_page_description: 'Page not found for whatever reason!',
      meta_not_found_page_title: 'Page not found',
      meta_pay_page_description: 'Get the latest FloRacing news, videos,  events. All the info, all the time.',
      meta_pay_page_title: 'Subscribe  get access to the latest FloRacing news, films, and events!',
      meta_ranking_page_description: "Who's the best of the best? Get current FloRacing rankings here.",
      meta_ranking_page_title: 'Get the most current FloRacing rankings!',
      meta_ranking_page_type: 'rankings',
      meta_result_page_description: 'Check out the latest FloRacing scores, direct  the results headquarters.',
      meta_result_page_title: 'Check out the FloRacing results!',
      meta_search_page_description: 'Search the latest FloRacing news, videos,  events. All the info, all the time.',
      meta_search_page_title: 'Search the latest FloRacing news  videos!',
      meta_signup_page_description: 'Get the latest FloRacing news, videos,  events. All the info, all the time.',
      meta_signup_page_title: 'Subscribe  get access to the latest FloRacing news, films, and events!',
      meta_sport_name: 'professional dirt track  oval racing',
      meta_training_page_description: 'Watch training and technique videos',
      meta_training_page_title: 'Training and Technique Videos',
      meta_twitter_card_type: 'summary_large_image',
      meta_videos_page_description: 'Watch the latest FloRacing videos. All videos, all the time.',
      meta_videos_page_page_type: 'video.other',
      meta_videos_page_title: 'Watch the latest FloRacing videos!',
      ooyala_master_ad_set: '68b3990482da4b6fb38e89eeca30b3ef',
      ooyala_player_id: 'e0798993365348c58b8e71befc2860e6',
      primary_color: '#FF140F',
      privacy_url: 'https://www.flosports.tv/privacy/',
      segment_api_key: 'ZUHcnFn1thW6jxIHzpClKrkH5r7zYsFI',
      site_id: 32,
      site_name: 'FloRacing',
      sport_name: 'Racing',
      tos_url: 'https://www.flosports.tv/terms-and-conditions/',
      training_videos_name: 'Training',
      twitter_page_url: 'https://twitter.com/flosports',
      youtube_page_url: 'https://www.youtube.com/user/Flocasts',
      gift_url: '/gift'
    }
  ],
  [
    SiteCode.Voice,
    {
      api_url: 'https://staging-api.flovoice.com',
      california_privacy_url: 'https://www.flosports.tv/california-privacy-policy/',
      careers_url: 'https://www.flosports.tv/work-with-us',
      contact_url: 'https://www.flosports.tv/contact/',
      core_site_url: 'https://staging-public.flovoice.com',
      facebook_app_id: '261304260989990',
      facebook_page_url: 'https://www.facebook.com/flosports/',
      faq_url: 'https://www.flosports.tv/faq/',
      favicon_url: 'https://d6fm3yzmawlcs.cloudfront.net/favicons/new-favicon/',
      flosports_url: 'https://www.flosports.tv/',
      google_client_id: '738778853945-c13l5ia1s92t070oqap9a65e8lj9prkt.apps.googleusercontent.com',
      instagram_page_url: 'https://www.instagram.com/explore/locations/921189021340396/flosports/',
      meta_articles_page_description:
        'Stay up-to-date on all the news in the FloVoice world with the latest articles, delivered daily.',
      meta_articles_page_title: 'The most up-to-date FloVoice news  articles!',
      meta_articles_page_type: 'article',
      meta_default_image: 'https://d6fm3yzmawlcs.cloudfront.net/ogImages/Voice-1920x1080.jpg',
      meta_default_type: 'website',
      meta_events_entries_page_description: 'Watch  stream FloVoice live events. Events are our thing. Enjoy',
      meta_events_entries_page_title: 'Watch  stream FloVoice events.',
      meta_events_entries_page_type: 'events',
      meta_events_news_page_description: 'Watch  stream FloVoice live events. Events are our thing. Enjoy.',
      meta_events_news_page_title: 'Watch  stream FloVoice events.',
      meta_events_news_page_type: 'event',
      meta_events_page_description: 'Watch  stream FloVoice live events. Events are our thing. Enjoy.',
      meta_events_page_title: 'Watch  stream FloVoice events.',
      meta_events_page_type: 'event',
      meta_events_photo_page_type: 'event',
      meta_events_photos_page_description: 'Watch  stream FloVoice live events. Events are our thing. Enjoy',
      meta_events_photos_page_title: 'Watch  stream FloVoice events',
      meta_events_schedule_page_description: 'Watch  stream FloVoice live events. Events are our thing. Enjoy.',
      meta_events_schedule_page_title: 'Watch  stream FloVoice events.',
      meta_events_schedule_page_type: 'event',
      meta_events_videos_page_description: 'Watch  stream FloVoice live events. Events are our thing. Enjoy.',
      meta_events_videos_page_title: 'Watch  stream FloVoice events.',
      meta_events_videos_page_type: 'event',
      meta_films_page_description: 'Watch Films and Documentaries',
      meta_films_page_title: 'Films and Documentaries',
      meta_home_page_description: 'Get the latest  FloVoice news, videos,  events. All the info, all the time.',
      meta_home_page_title: 'The latest FloVoice news  videos!',
      meta_login_page_description:
        'Log in to get the latest FloVoice news, videos,  events. All the info, all the time.',
      meta_login_page_title: 'Log in now to check out exclusive FloVoice content!',
      meta_not_found_page_description: 'Page not found for whatever reason!',
      meta_not_found_page_title: 'Page not found',
      meta_pay_page_description: 'Get the latest FloVoice news, videos,  events. All the info, all the time.',
      meta_pay_page_title: 'Subscribe  get access to the latest FloVoice news, films, and events!',
      meta_ranking_page_description: "Who's the best of the best? Get current FloVoice rankings here.",
      meta_ranking_page_title: 'Get the most current FloVoice rankings!',
      meta_ranking_page_type: 'rankings',
      meta_result_page_description: 'Check out the latest FloVoice scores, direct  the results headquarters.',
      meta_result_page_title: 'Check out the FloVoice results!',
      meta_search_page_description: 'Search the latest FloVoice news, videos,  events. All the info, all the time.',
      meta_search_page_title: 'Search the latest FloVoice news  videos!',
      meta_signup_page_description: 'Get the latest FloVoice news, videos,  events. All the info, all the time.',
      meta_signup_page_title: 'Subscribe  get access to the latest FloVoice news, films, and events!',
      meta_sport_name: 'a cappella  show choir',
      meta_training_page_description: 'Watch training and technique videos',
      meta_training_page_title: 'Training and Technique Videos',
      meta_twitter_card_type: 'summary_large_image',
      meta_videos_page_description: 'Watch the latest FloVoice videos. All videos, all the time.',
      meta_videos_page_page_type: 'video.other',
      meta_videos_page_title: 'Watch the latest FloVoice videos!',
      ooyala_master_ad_set: 'b3ee0a5f54cf4ada94896f3307ee87b1',
      ooyala_player_id: 'e0798993365348c58b8e71befc2860e6',
      primary_color: '#FF140F',
      privacy_url: 'https://www.flosports.tv/privacy/',
      segment_api_key: 'ZUHcnFn1thW6jxIHzpClKrkH5r7zYsFI',
      site_id: 33,
      site_name: 'FloVoice',
      sport_name: 'Singing',
      tos_url: 'https://www.flosports.tv/terms-and-conditions/',
      training_videos_name: 'Training',
      twitter_page_url: 'https://twitter.com/flosports',
      youtube_page_url: 'https://www.youtube.com/user/Flocasts',
      gift_url: '/gift'
    }
  ],
  [
    SiteCode.Rugby,
    {
      api_url: 'https://staging-api.florugby.com',
      california_privacy_url: 'https://www.flosports.tv/california-privacy-policy/',
      careers_url: 'https://www.flosports.tv/work-with-us',
      contact_url: 'https://www.flosports.tv/contact/',
      core_site_url: 'https://staging-public.florugby.com',
      facebook_app_id: '316042732132190',
      facebook_page_url: 'https://www.facebook.com/flosports/',
      faq_url: 'https://www.flosports.tv/faq/',
      favicon_url: 'https://d6fm3yzmawlcs.cloudfront.net/favicons/new-favicon/',
      flosports_url: 'https://www.flosports.tv/',
      google_client_id: '960255671857-31o6rnuo72q9ngjr4vct8ek64lrivfvr.apps.googleusercontent.com',
      instagram_page_url: 'https://www.instagram.com/explore/locations/921189021340396/flosports/',
      meta_articles_page_description:
        'Stay up-to-date on all the news in the FloRugby world with the latest articles, delivered daily.',
      meta_articles_page_title: 'The most up-to-date FloRugby news  articles!',
      meta_articles_page_type: 'article',
      meta_default_image: 'https://d6fm3yzmawlcs.cloudfront.net/ogImages/Rugby-1920x1080.jpg',
      meta_default_type: 'website',
      meta_events_entries_page_description: 'Watch  stream FloRugby live events. Events are our thing. Enjoy',
      meta_events_entries_page_title: 'Watch  stream FloRugby events.',
      meta_events_entries_page_type: 'events',
      meta_events_news_page_description: 'Watch  stream FloRugby live events. Events are our thing. Enjoy.',
      meta_events_news_page_title: 'Watch  stream FloRugby events.',
      meta_events_news_page_type: 'event',
      meta_events_page_description: 'Watch  stream FloRugby live events. Events are our thing. Enjoy.',
      meta_events_page_title: 'Watch  stream FloRugby events.',
      meta_events_page_type: 'event',
      meta_events_photo_page_type: 'event',
      meta_events_photos_page_description: 'Watch  stream FloRugby live events. Events are our thing. Enjoy',
      meta_events_photos_page_title: 'Watch  stream FloRugby events',
      meta_events_schedule_page_description: 'Watch  stream FloRugby live events. Events are our thing. Enjoy.',
      meta_events_schedule_page_title: 'Watch  stream FloRugby events.',
      meta_events_schedule_page_type: 'event',
      meta_events_videos_page_description: 'Watch  stream FloRugby live events. Events are our thing. Enjoy.',
      meta_events_videos_page_title: 'Watch  stream FloRugby events.',
      meta_events_videos_page_type: 'event',
      meta_films_page_description: 'Watch Films and Documentaries',
      meta_films_page_title: 'Films and Documentaries',
      meta_home_page_description: 'Get the latest  FloRugby news, videos,  events. All the info, all the time.',
      meta_home_page_title: 'The latest FloRugby news  videos!',
      meta_login_page_description:
        'Log in to get the latest FloRugby news, videos,  events. All the info, all the time.',
      meta_login_page_title: 'Log in now to check out exclusive FloRugby content!',
      meta_not_found_page_description: 'Page not found for whatever reason!',
      meta_not_found_page_title: 'Page not found',
      meta_pay_page_description: 'Get the latest FloRugby news, videos,  events. All the info, all the time.',
      meta_pay_page_title: 'Subscribe  get access to the latest FloRugby news, films, and events!',
      meta_ranking_page_description: "Who's the best of the best? Get current FloRugby rankings here.",
      meta_ranking_page_title: 'Get the most current FloRugby rankings!',
      meta_ranking_page_type: 'rankings',
      meta_result_page_description: 'Check out the latest FloRugby scores, direct  the results headquarters.',
      meta_result_page_title: 'Check out the FloRugby results!',
      meta_search_page_description: 'Search the latest FloRugby news, videos,  events. All the info, all the time.',
      meta_search_page_title: 'Search the latest FloRugby news  videos!',
      meta_signup_page_description: 'Get the latest FloRugby news, videos,  events. All the info, all the time.',
      meta_signup_page_title: 'Subscribe  get access to the latest FloRugby news, films, and events!',
      meta_sport_name: 'high school  professional rugby',
      meta_training_page_description: 'Watch training and technique videos',
      meta_training_page_title: 'Training and Technique Videos',
      meta_twitter_card_type: 'summary_large_image',
      meta_videos_page_description: 'Watch the latest FloRugby videos. All videos, all the time.',
      meta_videos_page_page_type: 'video.other',
      meta_videos_page_title: 'Watch the latest FloRugby videos!',
      ooyala_master_ad_set: 'f63205c01453478f90156600c58bc751',
      ooyala_player_id: 'e0798993365348c58b8e71befc2860e6',
      primary_color: '#FF140F',
      privacy_url: 'https://www.flosports.tv/privacy/',
      segment_api_key: 'ZUHcnFn1thW6jxIHzpClKrkH5r7zYsFI',
      site_id: 34,
      site_name: 'FloRugby',
      sport_name: 'Rugby',
      tos_url: 'https://www.flosports.tv/terms-and-conditions/',
      training_videos_name: 'Training',
      twitter_page_url: 'https://twitter.com/flosports',
      youtube_page_url: 'https://www.youtube.com/user/Flocasts',
      gift_url: '/gift'
    }
  ],
  [
    SiteCode.Live,
    {
      api_url: 'https://staging-api.flolive.tv',
      california_privacy_url: 'https://www.flosports.tv/california-privacy-policy/',
      careers_url: 'https://www.flosports.tv/work-with-us',
      contact_url: 'https://www.flosports.tv/contact/',
      core_site_url: 'https://staging-public.flolive.tv',
      facebook_app_id: '218535058622175',
      facebook_page_url: 'https://www.facebook.com/flosports/',
      faq_url: 'https://www.flosports.tv/faq/',
      favicon_url: 'https://d6fm3yzmawlcs.cloudfront.net/favicons/new-favicon/',
      flosports_url: 'https://www.flosports.tv/',
      google_client_id: '607351419127-ku9d4np6vlgaimpen6a2faq3i55ccfvh.apps.googleusercontent.com',
      instagram_page_url: 'https://www.instagram.com/explore/locations/921189021340396/flosports/',
      meta_articles_page_description:
        'Stay up-to-date on all the news in the FloLive world with the latest articles, delivered daily.',
      meta_articles_page_title: 'The most up-to-date FloLive news  articles!',
      meta_articles_page_type: 'article',
      meta_default_image: 'https://d6fm3yzmawlcs.cloudfront.net/ogImages/FloLive-1920x1080.jpg',
      meta_default_type: 'website',
      meta_events_entries_page_description: 'Watch  stream FloLive live events. Events are our thing. Enjoy',
      meta_events_entries_page_title: 'Watch  stream FloLive events.',
      meta_events_entries_page_type: 'events',
      meta_events_news_page_description: 'Watch  stream FloLive live events. Events are our thing. Enjoy.',
      meta_events_news_page_title: 'Watch  stream FloLive events.',
      meta_events_news_page_type: 'event',
      meta_events_page_description: 'Watch  stream FloLive live events. Events are our thing. Enjoy.',
      meta_events_page_title: 'Watch  stream FloLive events.',
      meta_events_page_type: 'event',
      meta_events_photo_page_type: 'event',
      meta_events_photos_page_description: 'Watch  stream FloLive live events. Events are our thing. Enjoy',
      meta_events_photos_page_title: 'Watch  stream FloLive events',
      meta_events_schedule_page_description: 'Watch  stream FloLive live events. Events are our thing. Enjoy.',
      meta_events_schedule_page_title: 'Watch  stream FloLive events.',
      meta_events_schedule_page_type: 'event',
      meta_events_videos_page_description: 'Watch  stream FloLive live events. Events are our thing. Enjoy.',
      meta_events_videos_page_title: 'Watch  stream FloLive events.',
      meta_events_videos_page_type: 'event',
      meta_films_page_description: 'Watch Films and Documentaries',
      meta_films_page_title: 'Films and Documentaries',
      meta_home_page_description: 'Get the latest  FloLive news, videos,  events. All the info, all the time.',
      meta_home_page_title: 'The latest FloLive news  videos!',
      meta_login_page_description:
        'Log in to get the latest FloLive news, videos,  events. All the info, all the time.',
      meta_login_page_title: 'Log in now to check out exclusive FloLive content!',
      meta_not_found_page_description: 'Page not found for whatever reason!',
      meta_not_found_page_title: 'Page not found',
      meta_pay_page_description: 'Get the latest FloLive news, videos,  events. All the info, all the time.',
      meta_pay_page_title: 'Subscribe  get access to the latest FloLive news, films, and events!',
      meta_ranking_page_description: "Who's the best of the best? Get current FloLive rankings here.",
      meta_ranking_page_title: 'Get the most current FloLive rankings!',
      meta_ranking_page_type: 'rankings',
      meta_result_page_description: 'Check out the latest FloLive scores, direct  the results headquarters.',
      meta_result_page_title: 'Check out the FloLive results!',
      meta_search_page_description: 'Search the latest FloLive news, videos,  events. All the info, all the time.',
      meta_search_page_title: 'Search the latest FloLive news  videos!',
      meta_signup_page_description: 'Get the latest FloLive news, videos,  events. All the info, all the time.',
      meta_signup_page_title: 'Subscribe  get access to the latest FloLive news, films, and events!',
      meta_sport_name: null,
      meta_training_page_description: 'Watch training and technique videos',
      meta_training_page_title: 'Training and Technique Videos',
      meta_twitter_card_type: 'summary_large_image',
      meta_videos_page_description: 'Watch the latest FloLive videos. All videos, all the time.',
      meta_videos_page_page_type: 'video.other',
      meta_videos_page_title: 'Watch the latest FloLive videos!',
      ooyala_master_ad_set: null,
      ooyala_player_id: 'e0798993365348c58b8e71befc2860e6',
      primary_color: '#FF140F',
      privacy_url: 'https://www.flosports.tv/privacy/',
      segment_api_key: 'ZUHcnFn1thW6jxIHzpClKrkH5r7zYsFI',
      site_id: 35,
      site_name: 'FloLive',
      sport_name: null,
      tos_url: 'https://www.flosports.tv/terms-and-conditions/',
      training_videos_name: 'Training',
      twitter_page_url: 'https://twitter.com/flosports',
      youtube_page_url: 'https://www.youtube.com/user/Flocasts',
      gift_url: '/gift'
    }
  ],
  [
    SiteCode.Dance,
    {
      api_url: 'https://staging-api.flodance.com',
      california_privacy_url: 'https://www.flosports.tv/california-privacy-policy/',
      careers_url: 'https://www.flosports.tv/work-with-us',
      contact_url: 'https://www.flosports.tv/contact/',
      core_site_url: 'https://staging-public.flodance.com',
      facebook_app_id: '1658254970856815',
      facebook_page_url: 'https://www.facebook.com/flosports/',
      faq_url: 'https://www.facebook.com/flosports/',
      favicon_url: 'https://d6fm3yzmawlcs.cloudfront.net/favicons/new-favicon/',
      flosports_url: 'https://www.flosports.tv/',
      google_client_id: '994780048765-1a6urjdeoilaf9fu5m3ig1panuv1253f.apps.googleusercontent.com',
      instagram_page_url: 'https://www.instagram.com/explore/locations/921189021340396/flosports/',
      meta_articles_page_description:
        'Stay up-to-date on all the news in the FloDance world with the latest articles, delivered daily.',
      meta_articles_page_title: 'The most up-to-date FloDance news  articles!',
      meta_articles_page_type: 'article',
      meta_default_image: 'https://d6fm3yzmawlcs.cloudfront.net/ogImages/Dance-1920x1080.jpg',
      meta_default_type: 'website',
      meta_events_entries_page_description: 'Watch  stream FloDance live events. Events are our thing. Enjoy',
      meta_events_entries_page_title: 'Watch  stream FloDance events.',
      meta_events_entries_page_type: 'events',
      meta_events_news_page_description: 'Watch  stream FloDance live events. Events are our thing. Enjoy.',
      meta_events_news_page_title: 'Watch  stream FloDance events.',
      meta_events_news_page_type: 'event',
      meta_events_page_description: 'Watch  stream FloDance live events. Events are our thing. Enjoy.',
      meta_events_page_title: 'Watch  stream FloDance events.',
      meta_events_page_type: 'event',
      meta_events_photo_page_type: 'event',
      meta_events_photos_page_description: 'Watch  stream FloDance live events. Events are our thing. Enjoy',
      meta_events_photos_page_title: 'Watch  stream FloDance events',
      meta_events_schedule_page_description: 'Watch  stream FloDance live events. Events are our thing. Enjoy.',
      meta_events_schedule_page_title: 'Watch  stream FloDance events.',
      meta_events_schedule_page_type: 'event',
      meta_events_videos_page_description: 'Watch  stream FloDance live events. Events are our thing. Enjoy.',
      meta_events_videos_page_title: 'Watch  stream FloDance events.',
      meta_events_videos_page_type: 'event',
      meta_films_page_description: 'Watch Films and Documentaries',
      meta_films_page_title: 'Films and Documentaries',
      meta_home_page_description: 'Get the latest  FloDance news, videos,  events. All the info, all the time.',
      meta_home_page_title: 'The latest FloDance news  videos!',
      meta_login_page_description:
        'Log in to get the latest FloDance news, videos,  events. All the info, all the time.',
      meta_login_page_title: 'Log in now to check out exclusive FloDance content!',
      meta_not_found_page_description: 'Page not found for whatever reason!',
      meta_not_found_page_title: 'Page not found',
      meta_pay_page_description: 'Get the latest FloDance news, videos,  events. All the info, all the time.',
      meta_pay_page_title: 'Subscribe  get access to the latest FloDance news, films, and events!',
      meta_ranking_page_description: "Who's the best of the best? Get current FloDance rankings here.",
      meta_ranking_page_title: 'Get the most current FloDance rankings!',
      meta_ranking_page_type: 'rankings',
      meta_result_page_description: 'Check out the latest FloDance scores, direct  the results headquarters.',
      meta_result_page_title: 'Check out the FloDance results!',
      meta_search_page_description: 'Search the latest FloDance news, videos,  events. All the info, all the time.',
      meta_search_page_title: 'Search the latest FloDance news  videos!',
      meta_signup_page_description: 'Get the latest FloDance news, videos,  events. All the info, all the time.',
      meta_signup_page_title: 'Subscribe  get access to the latest FloDance news, films, and events!',
      meta_sport_name: 'contemporary  ballroom dance',
      meta_training_page_description: 'Watch training and technique videos',
      meta_training_page_title: 'Training and Technique Videos',
      meta_twitter_card_type: 'summary_large_image',
      meta_videos_page_description: 'Watch the latest FloDance videos. All videos, all the time.',
      meta_videos_page_page_type: 'video.other',
      meta_videos_page_title: 'Watch the latest FloDance videos!',
      ooyala_master_ad_set: '65752e4e3c8946ad86e1fdb5e35453af',
      ooyala_player_id: 'e0798993365348c58b8e71befc2860e6',
      primary_color: '#FF140F',
      privacy_url: 'https://www.flosports.tv/privacy/',
      segment_api_key: 'ZUHcnFn1thW6jxIHzpClKrkH5r7zYsFI',
      site_id: 36,
      site_name: 'FloDance',
      sport_name: 'Dance',
      tos_url: 'https://www.flosports.tv/terms-and-conditions/',
      training_videos_name: 'Training',
      twitter_page_url: 'https://twitter.com/flosports',
      youtube_page_url: 'https://www.youtube.com/user/Flocasts',
      gift_url: '/gift'
    }
  ],
  [
    SiteCode.Bikes,
    {
      api_url: 'https://staging-api.flobikes.com',
      california_privacy_url: 'https://www.flosports.tv/california-privacy-policy/',
      careers_url: 'https://www.flosports.tv/work-with-us',
      contact_url: 'https://www.flosports.tv/contact/',
      core_site_url: 'https://staging-public.flobikes.com',
      facebook_app_id: '457332847942059',
      facebook_page_url: 'https://www.facebook.com/flobikes',
      faq_url: 'https://www.flosports.tv/faq/',
      favicon_url: 'https://d6fm3yzmawlcs.cloudfront.net/favicons/new-favicon/',
      flosports_url: 'https://www.flosports.tv/',
      google_client_id: '197576172139-l75drjj1m3njc8p1q2tnr6r1lnl04usq.apps.googleusercontent.com',
      instagram_page_url: 'https://www.instagram.com/flobikes/',
      meta_articles_page_description:
        'Cycling articles, competitions, news,  videos. Watch  stream live cycling events. Professional Road Cycling event  news coverage.',
      meta_articles_page_title: 'Cycling Articles | Cycling News',
      meta_articles_page_type: 'article',
      meta_default_image: 'https://d6fm3yzmawlcs.cloudfront.net/ogImages/Bikes-1920x1080.jpg',
      meta_default_type: 'website',
      meta_events_entries_page_description:
        'Watch  stream live cycling events. Cycling videos, competitions, news,  articles. Professional Road Cycling event  news coverage.',
      meta_events_entries_page_title: 'Cycling Events | Cycling Event Entries',
      meta_events_entries_page_type: 'events',
      meta_events_news_page_description:
        'Watch  stream live cycling events. Cycling videos, competitions, news,  articles. Professional Road Cycling event  news coverage.',
      meta_events_news_page_title: 'Cycling News | Cycling Articles',
      meta_events_news_page_type: 'event',
      meta_events_page_description:
        'Watch  stream live cycling events. Cycling videos, competitions, news,  articles. Professional Road Cycling event  news coverage.',
      meta_events_page_title: 'Cycling Events | Upcoming Cycling Events',
      meta_events_page_type: 'event',
      meta_events_photo_page_type: 'event',
      meta_events_photos_page_description:
        'Watch  stream live cycling events. Cycling videos, competitions, news,  articles. Professional Road Cycling event  news coverage.',
      meta_events_photos_page_title: 'Cycling Events | Cycling Event Photos',
      meta_events_schedule_page_description:
        'Watch  stream live cycling events. Cycling videos, competitions, news,  articles. Professional Road Cycling event  news coverage.',
      meta_events_schedule_page_title: 'Cycling Events | Cycling Event Schedules',
      meta_events_schedule_page_type: 'event',
      meta_events_videos_page_description:
        'Watch  stream live cycling events. Cycling videos, competitions, news,  articles. Professional Road Cycling event  news coverage.',
      meta_events_videos_page_title: 'Cycling Events | Cycling Event Videos',
      meta_events_videos_page_type: 'event',
      meta_films_page_description: 'Watch Films and Documentaries',
      meta_films_page_title: 'Films and Documentaries',
      meta_home_page_description:
        'Cycling competitions, videos, news,  articles. Watch  stream live cycling events. Professional Road Cycling event  news coverage.',
      meta_home_page_title: 'Cycling | Events, News,  Articles',
      meta_login_page_description:
        'Cycling competitions, videos, news,  articles. Watch  stream live cycling events. Professional Road Cycling event  news coverage.',
      meta_login_page_title: 'FloBikes Login | Access Your FloBikes Account For Exclusive Content',
      meta_not_found_page_description: 'Page not found for whatever reason!',
      meta_not_found_page_title: 'Page not found',
      meta_pay_page_description:
        'Cycling competitions, videos, news,  articles. Watch  stream live cycling events. Professional Road Cycling event  news coverage.',
      meta_pay_page_title: 'Cycling | Events, News,  Articles - Join Today',
      meta_ranking_page_description:
        'Watch  stream live cycling events. Cycling videos, competitions, news,  articles. Professional Road Cycling event  news coverage.',
      meta_ranking_page_title: 'Cycling | Rankings  Event Coverage',
      meta_ranking_page_type: 'rankings',
      meta_result_page_description:
        'Watch  stream live cycling events. Cycling videos, competitions, news,  articles. Professional Road Cycling event  news coverage.',
      meta_result_page_title: 'Cycling | Results  Event Coverage',
      meta_search_page_description:
        'Cycling competitions, videos, news,  articles. Watch  stream live cycling events. Professional Road Cycling event  news coverage.',
      meta_search_page_title: 'Cycling | Events, News,  Articles',
      meta_signup_page_description:
        'Cycling competitions, videos, news,  articles. Watch  stream live cycling events. Professional Road Cycling event  news coverage.',
      meta_signup_page_title: 'Cycling | Events, News,  Articles - Join Today',
      meta_sport_name: 'cycling',
      meta_training_page_description: 'Watch training and technique videos',
      meta_training_page_title: 'Training and Technique Videos',
      meta_twitter_card_type: 'summary_large_image',
      meta_videos_page_description:
        'Cycling videos, competitions, news,  articles. Watch  stream live cycling events. Professional Road Cycling event  news coverage.',
      meta_videos_page_page_type: 'video.other',
      meta_videos_page_title: 'Cycling Videos | Event Videos  Recaps',
      ooyala_master_ad_set: '18363e4174ea49c4ada4303643446b30',
      ooyala_player_id: '29577def37cd40f98ae3495b4b5465fc',
      primary_color: '#FF140F',
      privacy_url: 'https://www.flosports.tv/privacy/',
      segment_api_key: 'ZUHcnFn1thW6jxIHzpClKrkH5r7zYsFI',
      site_id: 37,
      site_name: 'FloBikes',
      sport_name: 'Cycling',
      tos_url: 'https://www.flosports.tv/terms-and-conditions/',
      training_videos_name: 'Training',
      twitter_page_url: 'https://twitter.com/FloBikes',
      youtube_page_url: 'https://www.youtube.com/channel/UCljVdpux_uz7NydDWYEeSIA',
      gift_url: '/gift'
    }
  ],
  [
    SiteCode.Football,
    {
      api_url: 'https://staging-api.flofootball.com',
      california_privacy_url: 'https://www.flosports.tv/california-privacy-policy/',
      careers_url: 'https://www.flosports.tv/work-with-us',
      contact_url: 'https://www.flosports.tv/contact/',
      core_site_url: 'https://staging-public.flofootball.com',
      facebook_app_id: '1980979028801713',
      facebook_page_url: 'https://www.facebook.com/flosports/',
      faq_url: 'https://www.flosports.tv/faq/',
      favicon_url: 'https://d6fm3yzmawlcs.cloudfront.net/favicons/new-favicon/',
      flosports_url: 'http://www.flofootball.com',
      google_client_id: '562141902480-t9bkc1cgu4n7o15etb8arn0qoskkvf2t.apps.googleusercontent.com',
      instagram_page_url: 'https://www.instagram.com/explore/locations/921189021340396/flosports/',
      meta_articles_page_description:
        'Stay up-to-date on all the news in the FloSports world with the latest articles, delivered daily.',
      meta_articles_page_title: 'The most up-to-date FloSports news  articles!',
      meta_articles_page_type: 'article',
      meta_default_image: 'https://d6fm3yzmawlcs.cloudfront.net/ogImages/Football-1920x1080.jpg',
      meta_default_type: 'website',
      meta_events_entries_page_description: 'Watch  stream FloSports live events. Events are our thing. Enjoy',
      meta_events_entries_page_title: 'Watch  stream FloSports events.',
      meta_events_entries_page_type: 'events',
      meta_events_news_page_description: 'Watch  stream FloSports live events. Events are our thing. Enjoy.',
      meta_events_news_page_title: 'Watch  stream FloSports events.',
      meta_events_news_page_type: 'event',
      meta_events_page_description: 'Watch  stream FloSports live events. Events are our thing. Enjoy.',
      meta_events_page_title: 'Watch  stream FloSports events.',
      meta_events_page_type: 'event',
      meta_events_photo_page_type: 'event',
      meta_events_photos_page_description: 'Watch  stream FloSports live events. Events are our thing. Enjoy',
      meta_events_photos_page_title: 'Watch  stream FloSports events',
      meta_events_schedule_page_description: 'Watch  stream FloSports live events. Events are our thing. Enjoy.',
      meta_events_schedule_page_title: 'Watch  stream FloSports events.',
      meta_events_schedule_page_type: 'event',
      meta_events_videos_page_description: 'Watch  stream FloSports live events. Events are our thing. Enjoy.',
      meta_events_videos_page_title: 'Watch  stream FloSports events.',
      meta_events_videos_page_type: 'event',
      meta_films_page_description: 'Watch Films and Documentaries',
      meta_films_page_title: 'Films and Documentaries',
      meta_home_page_description: 'Get the latest  FloSports news, videos,  events. All the info, all the time.',
      meta_home_page_title: 'The latest FloSports news  videos!',
      meta_login_page_description:
        'Log in to get the latest FloSports news, videos,  events. All the info, all the time.',
      meta_login_page_title: 'Log in now to check out exclusive FloSports content!',
      meta_not_found_page_description: 'Page not found for whatever reason!',
      meta_not_found_page_title: 'Page not found',
      meta_pay_page_description: 'Get the latest FloSports news, videos,  events. All the info, all the time.',
      meta_pay_page_title: 'Subscribe  get access to the latest FloSports news, films, and events!',
      meta_ranking_page_description: "Who's the best of the best? Get current FloSports rankings here.",
      meta_ranking_page_title: 'Get the most current FloSports rankings!',
      meta_ranking_page_type: 'rankings',
      meta_result_page_description: 'Check out the latest FloSports scores, direct  the results headquarters.',
      meta_result_page_title: 'Check out the FloSports results!',
      meta_search_page_description: 'Search the latest FloSports news, videos,  events. All the info, all the time.',
      meta_search_page_title: 'Search the latest FloSports news  videos!',
      meta_signup_page_description: 'Get the latest FloSports news, videos,  events. All the info, all the time.',
      meta_signup_page_title: 'Subscribe  get access to the latest FloSports news, films, and events!',
      meta_sport_name: null,
      meta_training_page_description: 'Watch training and technique videos',
      meta_training_page_title: 'Training and Technique Videos',
      meta_twitter_card_type: 'summary_large_image',
      meta_videos_page_description: 'Watch the latest FloSports videos. All videos, all the time.',
      meta_videos_page_page_type: 'video.other',
      meta_videos_page_title: 'Watch the latest FloSports videos!',
      ooyala_master_ad_set: null,
      ooyala_player_id: 'e0798993365348c58b8e71befc2860e6',
      primary_color: '#FF140F',
      privacy_url: 'https://www.flosports.tv/privacy/',
      segment_api_key: 'ZUHcnFn1thW6jxIHzpClKrkH5r7zYsFI',
      site_id: 38,
      site_name: 'FloFootball',
      sport_name: 'Football',
      tos_url: 'https://www.flosports.tv/terms-and-conditions/',
      training_videos_name: 'Training',
      twitter_page_url: 'https://twitter.com/flosports',
      youtube_page_url: 'https://www.youtube.com/user/Flocasts',
      gift_url: '/gift'
    }
  ],
  [
    SiteCode.Bowling,
    {
      api_url: 'https://staging-api.flobowling.com',
      california_privacy_url: 'https://www.flosports.tv/california-privacy-policy/',
      careers_url: 'https://www.flosports.tv/work-with-us',
      contact_url: 'https://www.flosports.tv/contact/',
      core_site_url: 'https://staging-www.flobowling.com',
      facebook_app_id: '366069947247709',
      facebook_page_url: 'https://www.facebook.com/FloBowling/',
      faq_url: 'https://www.flosports.tv/faq/',
      favicon_url: 'https://d6fm3yzmawlcs.cloudfront.net/favicons/new-favicon/',
      flosports_url: 'https://www.flosports.tv/',
      google_client_id: '346848914731-ph5hmv7e7g383q48fad4077i4s8hc6a6.apps.googleusercontent.com',
      instagram_page_url: 'https://www.instagram.com/flobowling/',
      meta_articles_page_description:
        'Stay up-to-date on all the news in the FloSports world with the latest articles, delivered daily.',
      meta_articles_page_title: 'The most up-to-date FloSports news  articles!',
      meta_articles_page_type: 'article',
      meta_default_image: 'https://d6fm3yzmawlcs.cloudfront.net/ogImages/Bowling-1920x1080.jpg',
      meta_default_type: 'website',
      meta_events_entries_page_description: 'Watch  stream FloSports live events. Events are our thing. Enjoy',
      meta_events_entries_page_title: 'Watch  stream FloSports events.',
      meta_events_entries_page_type: 'events',
      meta_events_news_page_description: 'Watch  stream FloSports live events. Events are our thing. Enjoy.',
      meta_events_news_page_title: 'Watch  stream FloSports events.',
      meta_events_news_page_type: 'event',
      meta_events_page_description: 'Watch  stream FloSports live events. Events are our thing. Enjoy.',
      meta_events_page_title: 'Watch  stream FloSports events.',
      meta_events_page_type: 'event',
      meta_events_photo_page_type: 'event',
      meta_events_photos_page_description: 'Watch  stream FloSports live events. Events are our thing. Enjoy',
      meta_events_photos_page_title: 'Watch  stream FloSports events',
      meta_events_schedule_page_description: 'Watch  stream FloSports live events. Events are our thing. Enjoy.',
      meta_events_schedule_page_title: 'Watch  stream FloSports events.',
      meta_events_schedule_page_type: 'event',
      meta_events_videos_page_description: 'Watch  stream FloSports live events. Events are our thing. Enjoy.',
      meta_events_videos_page_title: 'Watch  stream FloSports events.',
      meta_events_videos_page_type: 'event',
      meta_films_page_description: null,
      meta_films_page_title: null,
      meta_home_page_description: 'Get the latest  FloSports news, videos,  events. All the info, all the time.',
      meta_home_page_title: 'The latest FloSports news  videos!',
      meta_login_page_description:
        'Log in to get the latest FloSports news, videos,  events. All the info, all the time.',
      meta_login_page_title: 'Log in now to check out exclusive FloSports content!',
      meta_not_found_page_description: 'Page not found for whatever reason!',
      meta_not_found_page_title: 'Page not found',
      meta_pay_page_description: 'Get the latest FloSports news, videos,  events. All the info, all the time.',
      meta_pay_page_title: 'Subscribe  get access to the latest FloSports news, films, and events!',
      meta_ranking_page_description: "Who's the best of the best? Get current FloSports rankings here.",
      meta_ranking_page_title: 'Get the most current FloSports rankings!',
      meta_ranking_page_type: 'rankings',
      meta_result_page_description: 'Check out the latest FloSports scores, direct  the results headquarters.',
      meta_result_page_title: 'Check out the FloSports results!',
      meta_search_page_description: 'Search the latest FloSports news, videos,  events. All the info, all the time.',
      meta_search_page_title: 'Search the latest FloSports news  videos!',
      meta_signup_page_description: 'Get the latest FloSports news, videos,  events. All the info, all the time.',
      meta_signup_page_title: 'Subscribe  get access to the latest FloSports news, films, and events!',
      meta_sport_name: null,
      meta_training_page_description: null,
      meta_training_page_title: null,
      meta_twitter_card_type: null,
      meta_videos_page_description: 'Watch the latest FloSports videos. All videos, all the time.',
      meta_videos_page_page_type: 'video.other',
      meta_videos_page_title: 'Watch the latest FloSports videos!',
      ooyala_master_ad_set: 'dad0494f0ccc4b6abcd68f2bea0aed05',
      ooyala_player_id: '7cd89be0ab0e494398fd8a945cb15805',
      primary_color: '#FF140F',
      privacy_url: 'https://www.flosports.tv/privacy/',
      segment_api_key: 'ZUHcnFn1thW6jxIHzpClKrkH5r7zYsFI',
      site_id: 41,
      site_name: 'FloBowling',
      sport_name: 'Bowling',
      tos_url: 'https://www.flosports.tv/terms-and-conditions/',
      training_videos_name: 'Training',
      twitter_page_url: 'https://twitter.com/flobowling',
      youtube_page_url: 'https://www.youtube.com/channel/UC80xBT9ErxjJDLvmTER1ToQ',
      gift_url: '/gift'
    }
  ],
  [
    SiteCode.Baseball,
    {
      api_url: 'https://staging-api.flobaseball.tv',
      california_privacy_url: 'https://www.flosports.tv/california-privacy-policy/',
      careers_url: 'https://www.flosports.tv/work-with-us',
      contact_url: 'https://www.flosports.tv/contact/',
      core_site_url: 'https://staging-public.flobaseball.tv',
      facebook_app_id: null,
      facebook_page_url: 'https://business.facebook.com/FloBaseball/?business_id=781772628543241',
      faq_url: 'https://www.flosports.tv/faq/',
      favicon_url: 'https://d6fm3yzmawlcs.cloudfront.net/favicons/new-favicon/',
      flosports_url: 'https://www.flosports.tv/',
      google_client_id: '725441156888-7omk04iprracmmh1be832orb4lgtdsb5.apps.googleusercontent.com',
      instagram_page_url: 'https://www.instagram.com/flobaseball/',
      meta_articles_page_description:
        'Stay up-to-date on all the news in the Baseball world with the latest articles, delivered daily.',
      meta_articles_page_title: 'The most up-to-date Baseball news  articles!',
      meta_articles_page_type: 'article',
      meta_default_image: 'https://d6fm3yzmawlcs.cloudfront.net/ogImages/Baseball-1920x1080.jpg',
      meta_default_type: 'website',
      meta_events_entries_page_description: 'Watch  stream Baseball live events. Events are our thing. Enjoy',
      meta_events_entries_page_title: 'Watch  stream Baseball events.',
      meta_events_entries_page_type: 'events',
      meta_events_news_page_description: 'Watch  stream Baseball live events. Events are our thing. Enjoy.',
      meta_events_news_page_title: 'Watch  stream Baseball events.',
      meta_events_news_page_type: 'event',
      meta_events_page_description: 'Watch  stream Baseball live events. Events are our thing. Enjoy.',
      meta_events_page_title: 'Watch  stream Baseball events.',
      meta_events_page_type: 'event',
      meta_events_photo_page_type: 'event',
      meta_events_photos_page_description: 'Watch  stream Baseball live events. Events are our thing. Enjoy',
      meta_events_photos_page_title: 'Watch  stream Baseball events',
      meta_events_schedule_page_description: 'Watch  stream Baseball live events. Events are our thing. Enjoy.',
      meta_events_schedule_page_title: 'Watch  stream Baseball events.',
      meta_events_schedule_page_type: 'event',
      meta_events_videos_page_description: 'Watch  stream Baseball live events. Events are our thing. Enjoy.',
      meta_events_videos_page_title: 'Watch  stream Baseball events.',
      meta_events_videos_page_type: 'event',
      meta_films_page_description: 'Check out the Baseball films!',
      meta_films_page_title: 'Check out the Baseball films!',
      meta_home_page_description: 'Get the latest Baseball news, videos,  events. All the info, all the time.',
      meta_home_page_title: 'The latest Baseball news  videos!',
      meta_login_page_description:
        'Log in to get the latest Baseball news, videos,  events. All the info, all the time.',
      meta_login_page_title: 'Log in now to check out exclusive Baseball content!',
      meta_not_found_page_description: 'Page not found for whatever reason!',
      meta_not_found_page_title: 'Page not found',
      meta_pay_page_description: 'Get the latest Baseball news, videos,  events. All the info, all the time.',
      meta_pay_page_title: 'Subscribe  get access to the latest Baseball news, films, and events!',
      meta_ranking_page_description: "Who's the best of the best? Get current Baseball rankings here.",
      meta_ranking_page_title: 'Get the most current Baseball rankings!',
      meta_ranking_page_type: 'rankings',
      meta_result_page_description: 'Check out the latest Baseball scores, direct  the results headquarters.',
      meta_result_page_title: 'Check out the Baseball results!',
      meta_search_page_description: 'Search the latest Baseball news, videos,  events. All the info, all the time.',
      meta_search_page_title: 'Search the latest Baseball news  videos!',
      meta_signup_page_description: 'Get the latest Baseball news, videos,  events. All the info, all the time.',
      meta_signup_page_title: 'Subscribe  get access to the latest Baseball news, films, and events!',
      meta_sport_name: null,
      meta_training_page_description: 'Check out the Baseball training videos!',
      meta_training_page_title: 'Check out the Baseball training videos!',
      meta_twitter_card_type: 'summary_large_image',
      meta_videos_page_description: 'Watch the latest Baseball videos. All videos, all the time.',
      meta_videos_page_page_type: 'video.other',
      meta_videos_page_title: 'Watch the latest Baseball videos!',
      ooyala_master_ad_set: null,
      ooyala_player_id: null,
      primary_color: '#FF140F',
      privacy_url: 'https://www.flosports.tv/privacy/',
      segment_api_key: 'ZUHcnFn1thW6jxIHzpClKrkH5r7zYsFI',
      site_id: 42,
      site_name: 'FloBaseball',
      sport_name: 'Baseball',
      tos_url: 'https://www.flosports.tv/terms-and-conditions/',
      training_videos_name: 'Training',
      twitter_page_url: 'https://twitter.com/FloBaseball',
      youtube_page_url: 'https://www.youtube.com/channel/UC61qfDamnMB3j1Qo4vDY26w?view_as=subscriber',
      gift_url: '/gift'
    }
  ],
  [
    SiteCode.Soccer,
    {
      api_url: 'https://staging-api.flofc.com',
      california_privacy_url: 'https://www.flosports.tv/california-privacy-policy/',
      careers_url: 'https://www.flosports.tv/work-with-us',
      contact_url: 'https://www.flosports.tv/contact/',
      core_site_url: 'https://staging-www.flofc.com',
      facebook_app_id: '111287849817430',
      facebook_page_url: 'https://www.facebook.com/FloFutbol',
      faq_url: 'https://www.flosports.tv/faq/',
      favicon_url: 'https://d6fm3yzmawlcs.cloudfront.net/favicons/new-favicon/',
      flosports_url: 'https://www.flosports.tv/',
      google_client_id: '382889032134-o4jkqsj4oi8jlh3ku593vj814m064osq.apps.googleusercontent.com',
      instagram_page_url: 'https://www.instagram.com/flofc',
      meta_articles_page_description:
        'Stay up-to-date on all the news in the FloFC world with the latest articles, delivered daily.',
      meta_articles_page_title: 'The most up-to-date FloFC news  articles!',
      meta_articles_page_type: 'article',
      meta_default_image: 'https://d6fm3yzmawlcs.cloudfront.net/ogImages/Soccer-1920x1080.jpg',
      meta_default_type: 'website',
      meta_events_entries_page_description: 'Watch  stream FloFC live events. Events are our thing. Enjoy',
      meta_events_entries_page_title: 'Watch  stream FloFC events.',
      meta_events_entries_page_type: 'events',
      meta_events_news_page_description: 'Watch  stream FloFC live events. Events are our thing. Enjoy.',
      meta_events_news_page_title: 'Watch  stream FloFC events.',
      meta_events_news_page_type: 'event',
      meta_events_page_description: 'Watch  stream FloFC live events. Events are our thing. Enjoy.',
      meta_events_page_title: 'Watch  stream FloFC events.',
      meta_events_page_type: 'event',
      meta_events_photo_page_type: 'event',
      meta_events_photos_page_description: 'Watch  stream FloFC live events. Events are our thing. Enjoy',
      meta_events_photos_page_title: 'Watch  stream FloFC events',
      meta_events_schedule_page_description: 'Watch  stream FloFC live events. Events are our thing. Enjoy.',
      meta_events_schedule_page_title: 'Watch  stream FloFC events.',
      meta_events_schedule_page_type: 'event',
      meta_events_videos_page_description: 'Watch  stream FloFC live events. Events are our thing. Enjoy.',
      meta_events_videos_page_title: 'Watch  stream FloFC events.',
      meta_events_videos_page_type: 'event',
      meta_films_page_description: 'Watch Films and Documentaries',
      meta_films_page_title: 'Films and Documentaries',
      meta_home_page_description: 'Get the latest FloFC news, videos,  events. All the info, all the time.',
      meta_home_page_title: 'The latest FloFC news  videos!',
      meta_login_page_description: 'Log in to get the latest FloFC news, videos,  events. All the info, all the time.',
      meta_login_page_title: 'Log in now to check out exclusive FloFC content!',
      meta_not_found_page_description: 'Page not found for whatever reason!',
      meta_not_found_page_title: 'Page not found',
      meta_pay_page_description: 'Get the latest FloFC news, videos,  events. All the info, all the time.',
      meta_pay_page_title: 'Subscribe  get access to the latest FloFC news, films, and events!',
      meta_ranking_page_description: "Who's the best of the best? Get current FloFC rankings here.",
      meta_ranking_page_title: 'Get the most current FloFC rankings!',
      meta_ranking_page_type: 'rankings',
      meta_result_page_description: 'Check out the latest FloFC scores, direct  the results headquarters.',
      meta_result_page_title: 'Check out FloFC results!',
      meta_search_page_description: 'Search the latest FloFC news, videos,  events. All the info, all the time.',
      meta_search_page_title: 'Search the latest FloFC news  videos!',
      meta_signup_page_description: 'Get the latest FloFC news, videos,  events. All the info, all the time.',
      meta_signup_page_title: 'Subscribe  get access to the latest FloFC news, films, and events!',
      meta_sport_name: null,
      meta_training_page_description: 'Watch training and technique videos',
      meta_training_page_title: 'Training and Technique Videos',
      meta_twitter_card_type: 'summary_large_image',
      meta_videos_page_description: 'Watch the latest FloFC videos. All videos, all the time.',
      meta_videos_page_page_type: 'video.other',
      meta_videos_page_title: 'Watch the latest FloFC videos!',
      ooyala_master_ad_set: null,
      ooyala_player_id: null,
      primary_color: '#FF140F',
      privacy_url: 'https://www.flosports.tv/privacy/',
      segment_api_key: 'ZUHcnFn1thW6jxIHzpClKrkH5r7zYsFI',
      site_id: 43,
      site_name: 'FloFC',
      sport_name: 'Soccer',
      tos_url: 'https://www.flosports.tv/terms-and-conditions/',
      training_videos_name: 'Training',
      twitter_page_url: 'https://twitter.com/FloFC_',
      youtube_page_url: 'https://www.youtube.com/channel/UCEXgc0EmLodQ4_WGFgLl3Ng',
      gift_url: '/gift'
    }
  ],
  [
    SiteCode.TrackWrestling,
    {
      api_url: 'https://staging-flosports30-api.trackwrestling.com',
      california_privacy_url: 'https://www.flosports.tv/california-privacy-policy/',
      careers_url: 'https://www.flosports.tv/work-with-us',
      contact_url: 'https://www.flosports.tv/contact/',
      core_site_url: 'https://staging-accounts-public.trackwrestling.com',
      facebook_app_id: '1017411902416884',
      facebook_page_url: 'https://www.facebook.com/flosports/',
      faq_url: 'https://www.flosports.tv/faq/',
      favicon_url: 'https://dvsfd86tdlcfa.cloudfront.net/assets/2016111719441264/bundles/app/images/floslam/favicon/',
      flosports_url: 'https://www.flosports.tv/',
      google_client_id: '1023656513010-s08ashcjkquanik4vkq6tqp18f886fio.apps.googleusercontent.com',
      instagram_page_url: null,
      meta_articles_page_description: null,
      meta_articles_page_title: null,
      meta_articles_page_type: null,
      meta_default_image: 'http://static-assets.flosports.local/photo/58a1f091d8ff6.png?width=300',
      meta_default_type: 'website',
      meta_events_entries_page_description: null,
      meta_events_entries_page_title: null,
      meta_events_entries_page_type: null,
      meta_events_news_page_description: null,
      meta_events_news_page_title: null,
      meta_events_news_page_type: null,
      meta_events_page_description: null,
      meta_events_page_title: null,
      meta_events_page_type: null,
      meta_events_photo_page_type: null,
      meta_events_photos_page_description: null,
      meta_events_photos_page_title: null,
      meta_events_schedule_page_description: null,
      meta_events_schedule_page_title: null,
      meta_events_schedule_page_type: null,
      meta_events_videos_page_description: null,
      meta_events_videos_page_title: null,
      meta_events_videos_page_type: null,
      meta_films_page_description: null,
      meta_films_page_title: null,
      meta_home_page_description:
        'Get the latest TrackWrestling news, videos, &amp; events. All the info, all the time.',
      meta_home_page_title: 'The latest TrackWrestling news &amp; videos!',
      meta_login_page_description:
        'Wrestling events, videos, &amp; news. Watch &amp; stream live wrestling competitions on Trackwrestling.com. High school, NCAA, &amp; elite wrestling coverage.',
      meta_login_page_title: 'Trackwrestling | Wrestling Matches &amp; Videos',
      meta_not_found_page_description: 'Page not found for whatever reason!',
      meta_not_found_page_title: 'Page not found',
      meta_pay_page_description:
        'Wrestling events, videos, &amp; news. Watch &amp; stream live wrestling competitions on Trackwrestling.com. High school, NCAA, &amp; elite wrestling coverage.',
      meta_pay_page_title: 'Trackwrestling | Wrestling Matches &amp; Videos - Join Today',
      meta_ranking_page_description: null,
      meta_ranking_page_title: null,
      meta_ranking_page_type: null,
      meta_result_page_description: null,
      meta_result_page_title: null,
      meta_search_page_description:
        'Search the latest TrackWrestling news, videos, &amp; events. All the info, all the time.',
      meta_search_page_title: 'Search the latest TrackWrestling news &amp; videos!',
      meta_signup_page_description:
        'Wrestling events, videos, &amp; news. Watch &amp; stream live wrestling competitions on Trackwrestling.com. High school, NCAA, &amp; elite wrestling coverage.',
      meta_signup_page_title: 'Trackwrestling | Wrestling Matches &amp; Videos - Join Today',
      meta_sport_name: null,
      meta_training_page_description: null,
      meta_training_page_title: null,
      meta_twitter_card_type: 'summary_large_image',
      meta_videos_page_description: null,
      meta_videos_page_page_type: null,
      meta_videos_page_title: 'Watch the latest TrackWrestling videos!',
      ooyala_master_ad_set: null,
      ooyala_player_id: null,
      primary_color: '#0070bb',
      privacy_url: 'https://www.flosports.tv/privacy/',
      segment_api_key: 'oIq71j4faVPMsnW66krWyAI91aCJJuDA',
      site_id: 44,
      site_name: 'Trackwrestling',
      site_styles:
        '/* Brand Colors*/\r\n.color-ignite, .primary-color-text { color: #0070bb !important; }\r\n.primary-color-text:hover, .primary-color-text:focus { color: #0070bb !important; transition: all 250ms }\r\n.primary-color-text-active.active .apply-text-active, .primary-color-text-active.active.apply-text-active,\r\n.nested-primary-color-text-active.active .nested-apply-text-active, .nested-primary-color-text-active.nested-active.apply-text-active { color: #0070bb !important; }\r\n.primary-color-text-hover:hover .apply-text-hover, .primary-color-text-hover:hover.apply-text-hover, .hover-text-primary:hover { color: #0070bb !important; }\r\n.primary-color-bg { background: #0070bb !important; }\r\n.primary-color-border { border-color: #0070bb !important }\r\n.primary-color-border-bottom { border-bottom-color: #0070bb !important }\r\n.primary-color-border-top { border-top-color: #0070bb !important }\r\n.primary-color-border-left { border-left-color: #0070bb !important }\r\n.primary-color-border-right { border-right-color: #0070bb !important }\r\n.primary-color-border-active.active { border-color: #0070bb !important }\r\n.primary-color-outline { outline-color: #0070bb !important }\r\n.primary-color-stroke { stroke: #0070bb !important }\r\n\r\n/* Osano */\r\n.osano-cm-info .osano-cm-button, .osano-cm-info .osano-cm-input:checked + .osano-cm-switch, .osano-cm-info .osano-cm-input:hover + .osano-cm-switch, .osano-cm-info .osano-cm-input:checked:focus + .osano-cm-switch {background-color: #0070BA !important}\r\n.osano-cm-dialog a {\r\ncolor: #0070BA !important}\r\n\r\n\r\n/* Nav */\r\n@media (max-width: 992px) { ul li.mobile-menu { background: rgb(0, 112, 187); }}\r\n\r\n/* Logo */\r\n.logo-wrapper .logo {height: 42px !important;}\r\n.logo-wrapper .logo svg { height: 35px !important; }\r\n.logo svg .text-powered { fill: #ffffff }\r\n.logo.dark-alternate svg .text-powered { fill: #64656a; }\r\n.logo svg .text-track { fill: #ffffff; }\r\n.logo.dark-alternate svg .text-track { fill: #232327; }\r\n.checkout-header-wrapper { margin: 36px auto !important; }\r\n.checkout-header-wrapper .logo svg {height: 35px !important;}\r\n.outer-margin-wrapper .logo-links .logo svg {height: 35px !important;}\r\n.radial-overlay .logo{margin: 5px 0 !important;}\r\n.radial-overlay .logo img {height: 30px !important;} @media (max-width: 768px) {.radial-overlay .logo{margin: 5px auto !important;}}\r\n\r\n/* Typography */\r\na, a.visited { color:hsl(204, 100%, 37%) }\r\na:hover { color: hsl(204, 100%, 33%) !important; }\r\n.drill-through { color: #0070bb !important; }\r\n\r\n.header ul.utility-bar li.dropdown:hover a.dropdown-toggle { background: rgb(0, 112, 187) !important; }\r\n.header ul.utility-bar .flo-9748-upgrade button.flo-9748-upgrade-button,\r\n.logo-wrapper .flo-9748-dropdown-mobile-only button.flo-9748-upgrade-button { background: #ffffff !important; color: rgb(0, 112, 187) !important; }\r\n\r\n/* Watch on Web Header*/\r\n.header ul.utility-bar .primary-color-bg-hover:hover .apply-bg-hover { background: rgb(0, 112, 187) !important; }\r\n\r\n\r\n/*Button*/\r\n.btn-primary.btn, .btn-primary-small.btn, .btn-primary-tiny.btn { background: #0070bb; border-color: #0070bb !important; }\r\n.btn-primary.btn:hover, .btn-primary-small.btn:hover, .btn-primary-tiny.btn:hover {\r\n    background-color: hsl(204, 100%, 33%) !important; border-color: hsl(204, 100%, 33%) !important; color: #fff !important;\r\n}\r\n\r\n.btn-secondary.btn, .btn-secondary-small.btn, .btn-secondary-tiny.btn { color: #0070bb; }\r\n.btn.btn-secondary, .btn.btn-secondary:active { border-color: #eeeef0 !important;}\r\n.btn-secondary.btn a, .btn-secondary-small.btn a, .btn-secondary-tiny.btn a { color: #0070bb; }\r\n.btn.btn-secondary:active { color: #0070bb !important; }\r\n.btn.btn-primary:focus, .btn.btn-secondary:focus { box-shadow: 0 0 0 .16471rem rgba(0, 112, 187, .2) !important;}\r\n.btn.btn-primary:active { background-color: #0070bb !important; }\r\n.btn.btn-primary:disabled, .btn.btn-secondary:disabled { border-color: #eeeef0 !important;}\r\n.btn-group .btn-outline-secondary.active,\r\n.btn-group .btn-outline-secondary:active { background-color: #0070bb !important; border-color: #0070bb !important; }\r\n.btn-group .btn-outline-secondary.hover,\r\n.btn-group .btn-outline-secondary:hover,\r\n.btn-group .btn-outline-secondary:hover:not([disabled]) { background-color: #0070bb !important; border-color: #0070bb !important; color: #fff !important; }\r\n.btn-secondary.btn:hover, .btn-secondary-small.btn:hover, .btn-secondary-tiny.btn:hover {\r\n    color: #0070bb !important;\r\n}\r\n\r\n/* Tabs */\r\n.tabs-container .tab-active {\r\n  border-bottom: .05882rem solid #0070bb !important;\r\n  color: #0070bb !important;\r\n}\r\n/*Play Icon */\r\n.play-icon span.play-button {background-color: #0070bb !important;}\r\n/* Nav Bar */\r\n.utility-bar span[flosvg="icon-search"],\r\n.utility-bar span[flosvg="icon-share"]\r\n { color: white !important; }\r\n @media (min-width: 992px) {\r\n  .utility-bar li:not(.dropdown) a:hover { color: white !important; }\r\n }\r\n @media (max-width: 992px) {\r\n  .primary-links li a:hover { color: white !important; }\r\n }\r\n.nav-icon.mobile.rotate a:hover { color: white !important; }\r\nul.utility-bar li.dropdown ul.user-dropdown li:hover .user-links {color: #0070bb !important;}\r\n\r\n/* SVG */\r\n.primary-color-svg svg path { fill: #0070bb; }\r\n.primary-color-svg-hover svg:hover path { fill: #0070bb; }\r\n.primary-color-svg-apply svg .primary-color-apply { fill: #0070bb; }\r\n.primary-color-svg-hover-apply svg:hover .primary-color-apply { fill: #0070bb; }',
      sport_name: 'Wrestling',
      tos_url: 'https://www.flosports.tv/terms-and-conditions/',
      training_videos_name: 'Training',
      twitter_page_url: 'https://twitter.com/flosports',
      youtube_page_url: 'https://www.youtube.com/user/Flocasts',
      gift_url: '/gift'
    }
  ],
  [
    SiteCode.Dogs,
    {
      api_url: 'https://staging-api.flodogs.com',
      california_privacy_url: 'https://www.flosports.tv/california-privacy-policy/',
      careers_url: 'https://www.flosports.tv/work-with-us',
      contact_url: 'https://support.flosports.tv/',
      core_site_url: 'https://staging-public.flodogs.com',
      facebook_app_id: '821824194653094',
      facebook_page_url: 'https://www.facebook.com/flosports/',
      faq_url: 'https://www.facebook.com/flosports/',
      favicon_url: 'https://d6fm3yzmawlcs.cloudfront.net/favicons/new-favicon/',
      flosports_url: 'https://www.flosports.tv/',
      google_client_id: '758984137660-pottd3c2mv09isftnk9ghac2hu7tn4bn.apps.googleusercontent.com',
      instagram_page_url: 'https://www.instagram.com/explore/locations/921189021340396/flosports/',
      meta_articles_page_description:
        'Stay up-to-date on all the news in the FloDogs world with the latest articles, delivered daily.',
      meta_articles_page_title: 'The most up-to-date FloDogs news  articles!',
      meta_articles_page_type: 'article',
      meta_default_image: 'https://d6fm3yzmawlcs.cloudfront.net/ogImages/FloSports-Logo-Overlay.jpg',
      meta_default_type: 'website',
      meta_events_entries_page_description: 'Watch  stream FloDogs live events. Events are our thing. Enjoy',
      meta_events_entries_page_title: 'Watch  stream FloDogs events.',
      meta_events_entries_page_type: 'events',
      meta_events_news_page_description: 'Watch  stream FloDogs live events. Events are our thing. Enjoy.',
      meta_events_news_page_title: 'Watch  stream FloDogs events.',
      meta_events_news_page_type: 'event',
      meta_events_page_description: 'Watch  stream FloDogs live events. Events are our thing. Enjoy.',
      meta_events_page_title: 'Watch  stream FloDogs events.',
      meta_events_page_type: 'event',
      meta_events_photo_page_type: 'event',
      meta_events_photos_page_description: 'Watch  stream FloDogs live events. Events are our thing. Enjoy',
      meta_events_photos_page_title: 'Watch  stream FloDogs events',
      meta_events_schedule_page_description: 'Watch  stream FloDogs live events. Events are our thing. Enjoy.',
      meta_events_schedule_page_title: 'Watch  stream FloDogs events.',
      meta_events_schedule_page_type: 'event',
      meta_events_videos_page_description: 'Watch  stream FloDogs live events. Events are our thing. Enjoy.',
      meta_events_videos_page_title: 'Watch  stream FloDogs events.',
      meta_events_videos_page_type: 'event',
      meta_films_page_description: 'Watch Films and Documentaries',
      meta_films_page_title: 'Films and Documentaries',
      meta_home_page_description: 'Get the latest  FloDogs news, videos,  events. All the info, all the time.',
      meta_home_page_title: 'The latest FloDogs news  videos!',
      meta_login_page_description:
        'Log in to get the latest FloDogs news, videos,  events. All the info, all the time.',
      meta_login_page_title: 'Log in now to check out exclusive FloDogs content!',
      meta_not_found_page_description: 'Page not found for whatever reason!',
      meta_not_found_page_title: 'Page not found',
      meta_pay_page_description: 'Get the latest FloDogs news, videos,  events. All the info, all the time.',
      meta_pay_page_title: 'Subscribe  get access to the latest FloDogs news, films, and events!',
      meta_ranking_page_description: "Who's the best of the best? Get current FloDogs rankings here.",
      meta_ranking_page_title: 'Get the most current FloDogs rankings!',
      meta_ranking_page_type: 'rankings',
      meta_result_page_description: 'Check out the latest FloDogs scores, direct  the results headquarters.',
      meta_result_page_title: 'Check out the FloDogs results!',
      meta_search_page_description: 'Search the latest FloDogs news, videos,  events. All the info, all the time.',
      meta_search_page_title: 'Search the latest FloDogs news  videos!',
      meta_signup_page_description: 'Get the latest FloDogs news, videos,  events. All the info, all the time.',
      meta_signup_page_title: 'Subscribe  get access to the latest FloDogs news, films, and events!',
      meta_sport_name: 'doggies  puppers',
      meta_training_page_description: 'Watch training and technique videos',
      meta_training_page_title: 'Training and Technique Videos',
      meta_twitter_card_type: 'summary_large_image',
      meta_videos_page_description: 'Watch the latest FloDogs videos. All videos, all the time.',
      meta_videos_page_page_type: 'video.other',
      meta_videos_page_title: 'Watch the latest FloDogs videos!',
      ooyala_master_ad_set: 'dad0494f0ccc4b6abcd68f2bea0aed05',
      ooyala_player_id: 'e0798993365348c58b8e71befc2860e6',
      primary_color: '#FF140F',
      privacy_url: 'https://www.flosports.tv/privacy/',
      segment_api_key: 'ZUHcnFn1thW6jxIHzpClKrkH5r7zYsFI',
      site_id: 9001,
      site_name: 'FloDogs',
      sport_name: 'Dogs',
      tos_url: 'https://www.flosports.tv/terms-of-service/',
      training_videos_name: 'Training',
      twitter_page_url: 'https://twitter.com/flosports',
      youtube_page_url: 'https://www.youtube.com/user/Flocasts',
      gift_url: '/gift'
    }
  ],
  [
    SiteCode.College,
    {
      api_url: 'https://staging-api.flocollege.com',
      california_privacy_url: 'https://www.flosports.tv/california-privacy-policy/',
      careers_url: 'https://www.flosports.tv/work-with-us',
      contact_url: 'https://support.flosports.tv/',
      core_site_url: 'https://staging-public.flocollege.com',
      facebook_app_id: '7940140659429790',
      facebook_page_url: null,
      faq_url: 'https://support.flosports.tv/',
      favicon_url: 'https://d6fm3yzmawlcs.cloudfront.net/favicons/new-favicon/',
      flosports_url: 'https://www.flosports.tv/',
      google_client_id: '974618297901-4j914vuh8d2t7d7gq2am00oa72r57vau.apps.googleusercontent.com',
      instagram_page_url: null,
      meta_articles_page_description:
        'Stay up-to-date on all the news in the FloSports world with the latest articles, delivered daily.',
      meta_articles_page_title: 'The most up-to-date FloSports news & articles!',
      meta_articles_page_type: 'article',
      meta_default_image: 'https://d6fm3yzmawlcs.cloudfront.net/ogImages/College-1920x1080.jpg',
      meta_default_type: 'website',
      meta_events_entries_page_description: 'Watch & stream FloSports live events. Events are our thing. Enjoy',
      meta_events_entries_page_title: 'Watch & stream FloSports events.',
      meta_events_entries_page_type: 'events',
      meta_events_news_page_description: 'Watch & stream FloSports live events. Events are our thing. Enjoy',
      meta_events_news_page_title: 'Watch & stream FloSports events.',
      meta_events_news_page_type: 'event',
      meta_events_page_description: 'Watch & stream FloSports live events. Events are our thing. Enjoy',
      meta_events_page_title: 'Watch & stream FloSports events.',
      meta_events_page_type: 'event',
      meta_events_photo_page_type: 'event',
      meta_events_photos_page_description: 'Watch & stream FloSports live events. Events are our thing. Enjoy',
      meta_events_photos_page_title: 'Watch & stream FloSports events',
      meta_events_schedule_page_description: 'Watch & stream FloSports live events. Events are our thing. Enjoy',
      meta_events_schedule_page_title: 'Watch & stream FloSports events.',
      meta_events_schedule_page_type: 'event',
      meta_events_videos_page_description: 'Watch & stream FloSports live events. Events are our thing. Enjoy.',
      meta_events_videos_page_title: 'Watch & stream FloSports events.',
      meta_events_videos_page_type: 'event',
      meta_films_page_description: null,
      meta_films_page_title: null,
      meta_home_page_description: 'Get the latest  FloSports news, videos, & events. All the info, all the time.',
      meta_home_page_title: 'The latest FloSports news & videos!',
      meta_login_page_description:
        'Log in to get the latest FloSports news, videos, & events. All the info, all the time.',
      meta_login_page_title: 'Log in now to check out exclusive FloSports content!',
      meta_not_found_page_description: 'Page not found for whatever reason!',
      meta_not_found_page_title: 'Page not found',
      meta_pay_page_description: 'Get the latest FloSports news, videos, & events. All the info, all the time.',
      meta_pay_page_title: 'Subscribe & get access to the latest FloSports news, films, and events!',
      meta_ranking_page_description: "Who's the best of the best? Get current FloSports rankings here.",
      meta_ranking_page_title: 'Get the most current FloSports rankings!',
      meta_ranking_page_type: 'rankings',
      meta_result_page_description: 'Check out the latest FloSports scores, direct  the results headquarters.',
      meta_result_page_title: 'Check out the FloSports results!',
      meta_search_page_description: 'Get the latest  FloSports news, videos, & events. All the info, all the time.',
      meta_search_page_title: 'Search the latest FloSports news & videos!',
      meta_signup_page_description: 'Get the latest FloSports news, videos, & events. All the info, all the time.',
      meta_signup_page_title: 'Subscribe & get access to the latest FloSports news, films, and events!',
      meta_sport_name: 'College Sports',
      meta_training_page_description: 'Watch training and technique videos',
      meta_training_page_title: 'Training and Technique Videos',
      meta_twitter_card_type: 'summary_large_image',
      meta_videos_page_description: 'Watch the latest FloSports videos. All videos, all the time.',
      meta_videos_page_page_type: 'video',
      meta_videos_page_title: 'The most up-to-date FloSports news & articles!',
      ooyala_master_ad_set: null,
      ooyala_player_id: 'e0798993365348c58b8e71befc2860e6',
      primary_color: '#FF140F',
      privacy_url: 'https://www.flosports.tv/privacy/',
      segment_api_key: 'ZUHcnFn1thW6jxIHzpClKrkH5r7zYsFI',
      site_id: 45,
      site_name: 'FloCollege',
      sport_name: 'College Sports',
      tos_url: 'https://www.flosports.tv/terms-of-service/',
      training_videos_name: 'Training',
      twitter_page_url: null,
      youtube_page_url: null,
      gift_url: '/gift'
    }
  ]
])
